var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/murmurhash-js/murmurhash3_gc.js
var require_murmurhash3_gc = __commonJS({
  "../../node_modules/murmurhash-js/murmurhash3_gc.js"(exports, module) {
    function murmurhash3_32_gc2(key, seed) {
      var remainder, bytes, h1, h1b, c1, c1b, c2, c2b, k1, i;
      remainder = key.length & 3;
      bytes = key.length - remainder;
      h1 = seed;
      c1 = 3432918353;
      c2 = 461845907;
      i = 0;
      while (i < bytes) {
        k1 = key.charCodeAt(i) & 255 | (key.charCodeAt(++i) & 255) << 8 | (key.charCodeAt(++i) & 255) << 16 | (key.charCodeAt(++i) & 255) << 24;
        ++i;
        k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
        h1 ^= k1;
        h1 = h1 << 13 | h1 >>> 19;
        h1b = (h1 & 65535) * 5 + (((h1 >>> 16) * 5 & 65535) << 16) & 4294967295;
        h1 = (h1b & 65535) + 27492 + (((h1b >>> 16) + 58964 & 65535) << 16);
      }
      k1 = 0;
      switch (remainder) {
        case 3:
          k1 ^= (key.charCodeAt(i + 2) & 255) << 16;
        case 2:
          k1 ^= (key.charCodeAt(i + 1) & 255) << 8;
        case 1:
          k1 ^= key.charCodeAt(i) & 255;
          k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
          k1 = k1 << 15 | k1 >>> 17;
          k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
          h1 ^= k1;
      }
      h1 ^= key.length;
      h1 ^= h1 >>> 16;
      h1 = (h1 & 65535) * 2246822507 + (((h1 >>> 16) * 2246822507 & 65535) << 16) & 4294967295;
      h1 ^= h1 >>> 13;
      h1 = (h1 & 65535) * 3266489909 + (((h1 >>> 16) * 3266489909 & 65535) << 16) & 4294967295;
      h1 ^= h1 >>> 16;
      return h1 >>> 0;
    }
    if (typeof module !== "undefined") {
      module.exports = murmurhash3_32_gc2;
    }
  }
});

// src/SSOButton/index.tsx
import React18, { useState as useState11 } from "react";

// src/SSOButton/modal.tsx
import React17, { Suspense as Suspense3 } from "react";
import { CloseButton, Modal, ModalBody } from "react-bootstrap";

// src/SSOButton/Providers/index.tsx
import React16, { Suspense as Suspense2, useState as useState10 } from "react";

// src/SSOButton/styles/index.scss
var css = `@charset "UTF-8";
:root,
[data-bs-theme=light] {
  --aesirxsso-blue: #0d6efd;
  --aesirxsso-indigo: #6610f2;
  --aesirxsso-purple: #6f42c1;
  --aesirxsso-pink: #d63384;
  --aesirxsso-red: #dc3545;
  --aesirxsso-orange: #fd7e14;
  --aesirxsso-yellow: #ffc107;
  --aesirxsso-green: #198754;
  --aesirxsso-teal: #20c997;
  --aesirxsso-cyan: #0dcaf0;
  --aesirxsso-black: #000;
  --aesirxsso-white: #fff;
  --aesirxsso-gray: #6c757d;
  --aesirxsso-gray-dark: #343a40;
  --aesirxsso-gray-100: #f8f9fa;
  --aesirxsso-gray-200: #e9ecef;
  --aesirxsso-gray-300: #dee2e6;
  --aesirxsso-gray-400: #ced4da;
  --aesirxsso-gray-500: #adb5bd;
  --aesirxsso-gray-600: #6c757d;
  --aesirxsso-gray-700: #495057;
  --aesirxsso-gray-800: #343a40;
  --aesirxsso-gray-900: #212529;
  --aesirxsso-primary: #132342;
  --aesirxsso-secondary: #627eea;
  --aesirxsso-success: #1ab394;
  --aesirxsso-info: #0dcaf0;
  --aesirxsso-warning: #ffc107;
  --aesirxsso-danger: #dc3545;
  --aesirxsso-light: #f8f9fa;
  --aesirxsso-dark: #0f1314;
  --aesirxsso-primary-rgb: 19, 35, 66;
  --aesirxsso-secondary-rgb: 98, 126, 234;
  --aesirxsso-success-rgb: 26, 179, 148;
  --aesirxsso-info-rgb: 13, 202, 240;
  --aesirxsso-warning-rgb: 255, 193, 7;
  --aesirxsso-danger-rgb: 220, 53, 69;
  --aesirxsso-light-rgb: 248, 249, 250;
  --aesirxsso-dark-rgb: 15, 19, 20;
  --aesirxsso-primary-text-emphasis: rgb(7.6, 14, 26.4);
  --aesirxsso-secondary-text-emphasis: rgb(39.2, 50.4, 93.6);
  --aesirxsso-success-text-emphasis: rgb(10.4, 71.6, 59.2);
  --aesirxsso-info-text-emphasis: rgb(5.2, 80.8, 96);
  --aesirxsso-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --aesirxsso-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --aesirxsso-light-text-emphasis: #495057;
  --aesirxsso-dark-text-emphasis: #495057;
  --aesirxsso-primary-bg-subtle: rgb(207.8, 211, 217.2);
  --aesirxsso-secondary-bg-subtle: rgb(223.6, 229.2, 250.8);
  --aesirxsso-success-bg-subtle: rgb(209.2, 239.8, 233.6);
  --aesirxsso-info-bg-subtle: rgb(206.6, 244.4, 252);
  --aesirxsso-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --aesirxsso-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --aesirxsso-light-bg-subtle: rgb(251.5, 252, 252.5);
  --aesirxsso-dark-bg-subtle: #ced4da;
  --aesirxsso-primary-border-subtle: rgb(160.6, 167, 179.4);
  --aesirxsso-secondary-border-subtle: rgb(192.2, 203.4, 246.6);
  --aesirxsso-success-border-subtle: rgb(163.4, 224.6, 212.2);
  --aesirxsso-info-border-subtle: rgb(158.2, 233.8, 249);
  --aesirxsso-warning-border-subtle: rgb(255, 230.2, 155.8);
  --aesirxsso-danger-border-subtle: rgb(241, 174.2, 180.6);
  --aesirxsso-light-border-subtle: #e9ecef;
  --aesirxsso-dark-border-subtle: #adb5bd;
  --aesirxsso-white-rgb: 255, 255, 255;
  --aesirxsso-black-rgb: 0, 0, 0;
  --aesirxsso-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --aesirxsso-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --aesirxsso-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --aesirxsso-body-font-family: var(--aesirxsso-font-sans-serif);
  --aesirxsso-body-font-size: 1rem;
  --aesirxsso-body-font-weight: 400;
  --aesirxsso-body-line-height: 1.5;
  --aesirxsso-body-color: #212529;
  --aesirxsso-body-color-rgb: 33, 37, 41;
  --aesirxsso-body-bg: #fff;
  --aesirxsso-body-bg-rgb: 255, 255, 255;
  --aesirxsso-emphasis-color: #000;
  --aesirxsso-emphasis-color-rgb: 0, 0, 0;
  --aesirxsso-secondary-color: rgba(33, 37, 41, 0.75);
  --aesirxsso-secondary-color-rgb: 33, 37, 41;
  --aesirxsso-secondary-bg: #e9ecef;
  --aesirxsso-secondary-bg-rgb: 233, 236, 239;
  --aesirxsso-tertiary-color: rgba(33, 37, 41, 0.5);
  --aesirxsso-tertiary-color-rgb: 33, 37, 41;
  --aesirxsso-tertiary-bg: #f8f9fa;
  --aesirxsso-tertiary-bg-rgb: 248, 249, 250;
  --aesirxsso-heading-color: inherit;
  --aesirxsso-link-color: #132342;
  --aesirxsso-link-color-rgb: 19, 35, 66;
  --aesirxsso-link-decoration: underline;
  --aesirxsso-link-hover-color: rgb(15.2, 28, 52.8);
  --aesirxsso-link-hover-color-rgb: 15, 28, 53;
  --aesirxsso-code-color: #d63384;
  --aesirxsso-highlight-color: #212529;
  --aesirxsso-highlight-bg: rgb(255, 242.6, 205.4);
  --aesirxsso-border-width: 1px;
  --aesirxsso-border-style: solid;
  --aesirxsso-border-color: #dee2e6;
  --aesirxsso-border-color-translucent: rgba(0, 0, 0, 0.175);
  --aesirxsso-border-radius: 0.375rem;
  --aesirxsso-border-radius-sm: 0.25rem;
  --aesirxsso-border-radius-lg: 0.5rem;
  --aesirxsso-border-radius-xl: 1rem;
  --aesirxsso-border-radius-xxl: 2rem;
  --aesirxsso-border-radius-2xl: var(--aesirxsso-border-radius-xxl);
  --aesirxsso-border-radius-pill: 50rem;
  --aesirxsso-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --aesirxsso-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --aesirxsso-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --aesirxsso-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --aesirxsso-focus-ring-width: 0.25rem;
  --aesirxsso-focus-ring-opacity: 0.25;
  --aesirxsso-focus-ring-color: rgba(19, 35, 66, 0.25);
  --aesirxsso-form-valid-color: #1ab394;
  --aesirxsso-form-valid-border-color: #1ab394;
  --aesirxsso-form-invalid-color: #dc3545;
  --aesirxsso-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --aesirxsso-body-color: #dee2e6;
  --aesirxsso-body-color-rgb: 222, 226, 230;
  --aesirxsso-body-bg: #212529;
  --aesirxsso-body-bg-rgb: 33, 37, 41;
  --aesirxsso-emphasis-color: #fff;
  --aesirxsso-emphasis-color-rgb: 255, 255, 255;
  --aesirxsso-secondary-color: rgba(222, 226, 230, 0.75);
  --aesirxsso-secondary-color-rgb: 222, 226, 230;
  --aesirxsso-secondary-bg: #343a40;
  --aesirxsso-secondary-bg-rgb: 52, 58, 64;
  --aesirxsso-tertiary-color: rgba(222, 226, 230, 0.5);
  --aesirxsso-tertiary-color-rgb: 222, 226, 230;
  --aesirxsso-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --aesirxsso-tertiary-bg-rgb: 43, 48, 53;
  --aesirxsso-primary-text-emphasis: rgb(113.4, 123, 141.6);
  --aesirxsso-secondary-text-emphasis: rgb(160.8, 177.6, 242.4);
  --aesirxsso-success-text-emphasis: rgb(117.6, 209.4, 190.8);
  --aesirxsso-info-text-emphasis: rgb(109.8, 223.2, 246);
  --aesirxsso-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --aesirxsso-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --aesirxsso-light-text-emphasis: #f8f9fa;
  --aesirxsso-dark-text-emphasis: #dee2e6;
  --aesirxsso-primary-bg-subtle: rgb(3.8, 7, 13.2);
  --aesirxsso-secondary-bg-subtle: rgb(19.6, 25.2, 46.8);
  --aesirxsso-success-bg-subtle: rgb(5.2, 35.8, 29.6);
  --aesirxsso-info-bg-subtle: rgb(2.6, 40.4, 48);
  --aesirxsso-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --aesirxsso-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --aesirxsso-light-bg-subtle: #343a40;
  --aesirxsso-dark-bg-subtle: #1a1d20;
  --aesirxsso-primary-border-subtle: rgb(11.4, 21, 39.6);
  --aesirxsso-secondary-border-subtle: rgb(58.8, 75.6, 140.4);
  --aesirxsso-success-border-subtle: rgb(15.6, 107.4, 88.8);
  --aesirxsso-info-border-subtle: rgb(7.8, 121.2, 144);
  --aesirxsso-warning-border-subtle: rgb(153, 115.8, 4.2);
  --aesirxsso-danger-border-subtle: rgb(132, 31.8, 41.4);
  --aesirxsso-light-border-subtle: #495057;
  --aesirxsso-dark-border-subtle: #343a40;
  --aesirxsso-heading-color: inherit;
  --aesirxsso-link-color: rgb(113.4, 123, 141.6);
  --aesirxsso-link-hover-color: rgb(141.72, 149.4, 164.28);
  --aesirxsso-link-color-rgb: 113, 123, 142;
  --aesirxsso-link-hover-color-rgb: 142, 149, 164;
  --aesirxsso-code-color: rgb(230.4, 132.6, 181.2);
  --aesirxsso-highlight-color: #dee2e6;
  --aesirxsso-highlight-bg: rgb(102, 77.2, 2.8);
  --aesirxsso-border-color: #495057;
  --aesirxsso-border-color-translucent: rgba(255, 255, 255, 0.15);
  --aesirxsso-form-valid-color: rgb(117, 183, 152.4);
  --aesirxsso-form-valid-border-color: rgb(117, 183, 152.4);
  --aesirxsso-form-invalid-color: rgb(234, 133.8, 143.4);
  --aesirxsso-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

.aesirxsso {
  /* rtl:raw:
  [type="tel"],
  [type="url"],
  [type="email"],
  [type="number"] {
    direction: ltr;
  }
  */
  /* rtl:begin:remove */
  /* rtl:end:remove */
}
.aesirxsso *,
.aesirxsso *::before,
.aesirxsso *::after {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: no-preference) {
  .aesirxsso :root {
    scroll-behavior: smooth;
  }
}
.aesirxsso body {
  margin: 0;
  font-family: var(--aesirxsso-body-font-family);
  font-size: var(--aesirxsso-body-font-size);
  font-weight: var(--aesirxsso-body-font-weight);
  line-height: var(--aesirxsso-body-line-height);
  color: var(--aesirxsso-body-color);
  text-align: var(--aesirxsso-body-text-align);
  background-color: var(--aesirxsso-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.aesirxsso hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--aesirxsso-border-width) solid;
  opacity: 0.25;
}
.aesirxsso h6, .aesirxsso .h6, .aesirxsso h5, .aesirxsso .h5, .aesirxsso h4, .aesirxsso .h4, .aesirxsso h3, .aesirxsso .h3, .aesirxsso h2, .aesirxsso .h2, .aesirxsso h1, .aesirxsso .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--aesirxsso-heading-color);
}
.aesirxsso h1, .aesirxsso .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .aesirxsso h1, .aesirxsso .h1 {
    font-size: 2.5rem;
  }
}
.aesirxsso h2, .aesirxsso .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  .aesirxsso h2, .aesirxsso .h2 {
    font-size: 2rem;
  }
}
.aesirxsso h3, .aesirxsso .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  .aesirxsso h3, .aesirxsso .h3 {
    font-size: 1.75rem;
  }
}
.aesirxsso h4, .aesirxsso .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  .aesirxsso h4, .aesirxsso .h4 {
    font-size: 1.5rem;
  }
}
.aesirxsso h5, .aesirxsso .h5 {
  font-size: 1.25rem;
}
.aesirxsso h6, .aesirxsso .h6 {
  font-size: 1rem;
}
.aesirxsso p {
  margin-top: 0;
  margin-bottom: 1rem;
}
.aesirxsso abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}
.aesirxsso address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}
.aesirxsso ol,
.aesirxsso ul {
  padding-left: 2rem;
}
.aesirxsso ol,
.aesirxsso ul,
.aesirxsso dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
.aesirxsso ol ol,
.aesirxsso ul ul,
.aesirxsso ol ul,
.aesirxsso ul ol {
  margin-bottom: 0;
}
.aesirxsso dt {
  font-weight: 700;
}
.aesirxsso dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
.aesirxsso blockquote {
  margin: 0 0 1rem;
}
.aesirxsso b,
.aesirxsso strong {
  font-weight: bolder;
}
.aesirxsso small, .aesirxsso .small {
  font-size: 0.875em;
}
.aesirxsso mark, .aesirxsso .mark {
  padding: 0.1875em;
  color: var(--aesirxsso-highlight-color);
  background-color: var(--aesirxsso-highlight-bg);
}
.aesirxsso sub,
.aesirxsso sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}
.aesirxsso sub {
  bottom: -0.25em;
}
.aesirxsso sup {
  top: -0.5em;
}
.aesirxsso a {
  color: rgba(var(--aesirxsso-link-color-rgb), var(--aesirxsso-link-opacity, 1));
  text-decoration: underline;
}
.aesirxsso a:hover {
  --aesirxsso-link-color-rgb: var(--aesirxsso-link-hover-color-rgb);
}
.aesirxsso a:not([href]):not([class]), .aesirxsso a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}
.aesirxsso pre,
.aesirxsso code,
.aesirxsso kbd,
.aesirxsso samp {
  font-family: var(--aesirxsso-font-monospace);
  font-size: 1em;
}
.aesirxsso pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
.aesirxsso pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}
.aesirxsso code {
  font-size: 0.875em;
  color: var(--aesirxsso-code-color);
  word-wrap: break-word;
}
a > .aesirxsso code {
  color: inherit;
}
.aesirxsso kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--aesirxsso-body-bg);
  background-color: var(--aesirxsso-body-color);
  border-radius: 0.25rem;
}
.aesirxsso kbd kbd {
  padding: 0;
  font-size: 1em;
}
.aesirxsso figure {
  margin: 0 0 1rem;
}
.aesirxsso img,
.aesirxsso svg {
  vertical-align: middle;
}
.aesirxsso table {
  caption-side: bottom;
  border-collapse: collapse;
}
.aesirxsso caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--aesirxsso-secondary-color);
  text-align: left;
}
.aesirxsso th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}
.aesirxsso thead,
.aesirxsso tbody,
.aesirxsso tfoot,
.aesirxsso tr,
.aesirxsso td,
.aesirxsso th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}
.aesirxsso label {
  display: inline-block;
}
.aesirxsso button {
  border-radius: 0;
}
.aesirxsso button:focus:not(:focus-visible) {
  outline: 0;
}
.aesirxsso input,
.aesirxsso button,
.aesirxsso select,
.aesirxsso optgroup,
.aesirxsso textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.aesirxsso button,
.aesirxsso select {
  text-transform: none;
}
.aesirxsso [role=button] {
  cursor: pointer;
}
.aesirxsso select {
  word-wrap: normal;
}
.aesirxsso select:disabled {
  opacity: 1;
}
.aesirxsso [list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}
.aesirxsso button,
.aesirxsso [type=button],
.aesirxsso [type=reset],
.aesirxsso [type=submit] {
  -webkit-appearance: button;
}
.aesirxsso button:not(:disabled),
.aesirxsso [type=button]:not(:disabled),
.aesirxsso [type=reset]:not(:disabled),
.aesirxsso [type=submit]:not(:disabled) {
  cursor: pointer;
}
.aesirxsso ::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
.aesirxsso textarea {
  resize: vertical;
}
.aesirxsso fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
.aesirxsso legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  .aesirxsso legend {
    font-size: 1.5rem;
  }
}
.aesirxsso legend + * {
  clear: left;
}
.aesirxsso ::-webkit-datetime-edit-fields-wrapper,
.aesirxsso ::-webkit-datetime-edit-text,
.aesirxsso ::-webkit-datetime-edit-minute,
.aesirxsso ::-webkit-datetime-edit-hour-field,
.aesirxsso ::-webkit-datetime-edit-day-field,
.aesirxsso ::-webkit-datetime-edit-month-field,
.aesirxsso ::-webkit-datetime-edit-year-field {
  padding: 0;
}
.aesirxsso ::-webkit-inner-spin-button {
  height: auto;
}
.aesirxsso [type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
.aesirxsso ::-webkit-search-decoration {
  -webkit-appearance: none;
}
.aesirxsso ::-webkit-color-swatch-wrapper {
  padding: 0;
}
.aesirxsso ::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}
.aesirxsso output {
  display: inline-block;
}
.aesirxsso iframe {
  border: 0;
}
.aesirxsso summary {
  display: list-item;
  cursor: pointer;
}
.aesirxsso progress {
  vertical-align: baseline;
}
.aesirxsso [hidden] {
  display: none !important;
}
.aesirxsso .lead {
  font-size: 1.25rem;
  font-weight: 300;
}
.aesirxsso .display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxsso .display-1 {
    font-size: 5rem;
  }
}
.aesirxsso .display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxsso .display-2 {
    font-size: 4.5rem;
  }
}
.aesirxsso .display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxsso .display-3 {
    font-size: 4rem;
  }
}
.aesirxsso .display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxsso .display-4 {
    font-size: 3.5rem;
  }
}
.aesirxsso .display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxsso .display-5 {
    font-size: 3rem;
  }
}
.aesirxsso .display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .aesirxsso .display-6 {
    font-size: 2.5rem;
  }
}
.aesirxsso .list-unstyled {
  padding-left: 0;
  list-style: none;
}
.aesirxsso .list-inline {
  padding-left: 0;
  list-style: none;
}
.aesirxsso .list-inline-item {
  display: inline-block;
}
.aesirxsso .list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
.aesirxsso .initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}
.aesirxsso .blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.aesirxsso .blockquote > :last-child {
  margin-bottom: 0;
}
.aesirxsso .blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.aesirxsso .blockquote-footer::before {
  content: "\u2014\xA0";
}
.aesirxsso .modal {
  --aesirxsso-modal-zindex: 1055;
  --aesirxsso-modal-width: 846px;
  --aesirxsso-modal-padding: 1rem;
  --aesirxsso-modal-margin: 0.5rem;
  --aesirxsso-modal-color: ;
  --aesirxsso-modal-bg: var(--aesirxsso-body-bg);
  --aesirxsso-modal-border-color: var(--aesirxsso-border-color-translucent);
  --aesirxsso-modal-border-width: var(--aesirxsso-border-width);
  --aesirxsso-modal-border-radius: var(--aesirxsso-border-radius-lg);
  --aesirxsso-modal-box-shadow: var(--aesirxsso-box-shadow-sm);
  --aesirxsso-modal-inner-border-radius: calc(var(--aesirxsso-border-radius-lg) - (var(--aesirxsso-border-width)));
  --aesirxsso-modal-header-padding-x: 1rem;
  --aesirxsso-modal-header-padding-y: 1rem;
  --aesirxsso-modal-header-padding: 1rem 1rem;
  --aesirxsso-modal-header-border-color: var(--aesirxsso-border-color);
  --aesirxsso-modal-header-border-width: var(--aesirxsso-border-width);
  --aesirxsso-modal-title-line-height: 1.5;
  --aesirxsso-modal-footer-gap: 0.5rem;
  --aesirxsso-modal-footer-bg: ;
  --aesirxsso-modal-footer-border-color: var(--aesirxsso-border-color);
  --aesirxsso-modal-footer-border-width: var(--aesirxsso-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--aesirxsso-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
.aesirxsso .modal-dialog {
  position: relative;
  width: auto;
  margin: var(--aesirxsso-modal-margin);
  pointer-events: none;
}
.modal.fade .aesirxsso .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .aesirxsso .modal-dialog {
    transition: none;
  }
}
.modal.show .aesirxsso .modal-dialog {
  transform: none;
}
.modal.modal-static .aesirxsso .modal-dialog {
  transform: scale(1.02);
}
.aesirxsso .modal-dialog-scrollable {
  height: calc(100% - var(--aesirxsso-modal-margin) * 2);
}
.aesirxsso .modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.aesirxsso .modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}
.aesirxsso .modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--aesirxsso-modal-margin) * 2);
}
.aesirxsso .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--aesirxsso-modal-color);
  pointer-events: auto;
  background-color: var(--aesirxsso-modal-bg);
  background-clip: padding-box;
  border: var(--aesirxsso-modal-border-width) solid var(--aesirxsso-modal-border-color);
  border-radius: var(--aesirxsso-modal-border-radius);
  outline: 0;
}
.aesirxsso .modal-backdrop {
  --aesirxsso-backdrop-zindex: 1050;
  --aesirxsso-backdrop-bg: #000;
  --aesirxsso-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--aesirxsso-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--aesirxsso-backdrop-bg);
}
.aesirxsso .modal-backdrop.fade {
  opacity: 0;
}
.aesirxsso .modal-backdrop.show {
  opacity: var(--aesirxsso-backdrop-opacity);
}
.aesirxsso .modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--aesirxsso-modal-header-padding);
  border-bottom: var(--aesirxsso-modal-header-border-width) solid var(--aesirxsso-modal-header-border-color);
  border-top-left-radius: var(--aesirxsso-modal-inner-border-radius);
  border-top-right-radius: var(--aesirxsso-modal-inner-border-radius);
}
.aesirxsso .modal-header .btn-close {
  padding: calc(var(--aesirxsso-modal-header-padding-y) * 0.5) calc(var(--aesirxsso-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--aesirxsso-modal-header-padding-y)) calc(-0.5 * var(--aesirxsso-modal-header-padding-x)) calc(-0.5 * var(--aesirxsso-modal-header-padding-y)) auto;
}
.aesirxsso .modal-title {
  margin-bottom: 0;
  line-height: var(--aesirxsso-modal-title-line-height);
}
.aesirxsso .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--aesirxsso-modal-padding);
}
.aesirxsso .modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--aesirxsso-modal-padding) - var(--aesirxsso-modal-footer-gap) * 0.5);
  background-color: var(--aesirxsso-modal-footer-bg);
  border-top: var(--aesirxsso-modal-footer-border-width) solid var(--aesirxsso-modal-footer-border-color);
  border-bottom-right-radius: var(--aesirxsso-modal-inner-border-radius);
  border-bottom-left-radius: var(--aesirxsso-modal-inner-border-radius);
}
.aesirxsso .modal-footer > * {
  margin: calc(var(--aesirxsso-modal-footer-gap) * 0.5);
}
@media (min-width: 576px) {
  .aesirxsso .modal {
    --aesirxsso-modal-margin: 1.75rem;
    --aesirxsso-modal-box-shadow: var(--aesirxsso-box-shadow);
  }
  .aesirxsso .modal-dialog {
    max-width: var(--aesirxsso-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxsso .modal-sm {
    --aesirxsso-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .aesirxsso .modal-lg,
  .aesirxsso .modal-xl {
    --aesirxsso-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .aesirxsso .modal-xl {
    --aesirxsso-modal-width: 846px;
  }
}
.aesirxsso .modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.aesirxsso .modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.aesirxsso .modal-fullscreen .modal-header,
.aesirxsso .modal-fullscreen .modal-footer {
  border-radius: 0;
}
.aesirxsso .modal-fullscreen .modal-body {
  overflow-y: auto;
}
@media (max-width: 575.98px) {
  .aesirxsso .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .aesirxsso .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .aesirxsso .modal-fullscreen-sm-down .modal-header,
  .aesirxsso .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .aesirxsso .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .aesirxsso .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .aesirxsso .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .aesirxsso .modal-fullscreen-md-down .modal-header,
  .aesirxsso .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .aesirxsso .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .aesirxsso .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .aesirxsso .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .aesirxsso .modal-fullscreen-lg-down .modal-header,
  .aesirxsso .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .aesirxsso .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .aesirxsso .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .aesirxsso .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .aesirxsso .modal-fullscreen-xl-down .modal-header,
  .aesirxsso .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .aesirxsso .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .aesirxsso .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .aesirxsso .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .aesirxsso .modal-fullscreen-xxl-down .modal-header,
  .aesirxsso .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .aesirxsso .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.aesirxsso .form-label {
  margin-bottom: 0.5rem;
}
.aesirxsso .col-form-label {
  padding-top: calc(0.375rem + var(--aesirxsso-border-width));
  padding-bottom: calc(0.375rem + var(--aesirxsso-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
.aesirxsso .col-form-label-lg {
  padding-top: calc(0.5rem + var(--aesirxsso-border-width));
  padding-bottom: calc(0.5rem + var(--aesirxsso-border-width));
  font-size: 1.25rem;
}
.aesirxsso .col-form-label-sm {
  padding-top: calc(0.25rem + var(--aesirxsso-border-width));
  padding-bottom: calc(0.25rem + var(--aesirxsso-border-width));
  font-size: 0.875rem;
}
.aesirxsso .form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--aesirxsso-secondary-color);
}
.aesirxsso .form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--aesirxsso-body-color);
  appearance: none;
  background-color: var(--aesirxsso-body-bg);
  background-clip: padding-box;
  border: var(--aesirxsso-border-width) solid var(--aesirxsso-border-color);
  border-radius: var(--aesirxsso-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .form-control {
    transition: none;
  }
}
.aesirxsso .form-control[type=file] {
  overflow: hidden;
}
.aesirxsso .form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.aesirxsso .form-control:focus {
  color: var(--aesirxsso-body-color);
  background-color: var(--aesirxsso-body-bg);
  border-color: rgb(137, 145, 160.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(19, 35, 66, 0.25);
}
.aesirxsso .form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.aesirxsso .form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.aesirxsso .form-control::placeholder {
  color: var(--aesirxsso-secondary-color);
  opacity: 1;
}
.aesirxsso .form-control:disabled {
  background-color: var(--aesirxsso-secondary-bg);
  opacity: 1;
}
.aesirxsso .form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--aesirxsso-body-color);
  background-color: var(--aesirxsso-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--aesirxsso-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .form-control::file-selector-button {
    transition: none;
  }
}
.aesirxsso .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--aesirxsso-secondary-bg);
}
.aesirxsso .form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--aesirxsso-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--aesirxsso-border-width) 0;
}
.aesirxsso .form-control-plaintext:focus {
  outline: 0;
}
.aesirxsso .form-control-plaintext.form-control-sm, .aesirxsso .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}
.aesirxsso .form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--aesirxsso-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--aesirxsso-border-radius-sm);
}
.aesirxsso .form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}
.aesirxsso .form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--aesirxsso-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--aesirxsso-border-radius-lg);
}
.aesirxsso .form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}
.aesirxsso textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--aesirxsso-border-width) * 2));
}
.aesirxsso textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--aesirxsso-border-width) * 2));
}
.aesirxsso textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--aesirxsso-border-width) * 2));
}
.aesirxsso .form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--aesirxsso-border-width) * 2));
  padding: 0.375rem;
}
.aesirxsso .form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.aesirxsso .form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--aesirxsso-border-width) * 2));
}
.aesirxsso .form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--aesirxsso-border-width) * 2));
}
.aesirxsso .form-select {
  --aesirxsso-form-select-bg-img: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--aesirxsso-body-color);
  appearance: none;
  background-color: var(--aesirxsso-body-bg);
  background-image: var(--aesirxsso-form-select-bg-img), var(--aesirxsso-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--aesirxsso-border-width) solid var(--aesirxsso-border-color);
  border-radius: var(--aesirxsso-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .form-select {
    transition: none;
  }
}
.aesirxsso .form-select:focus {
  border-color: rgb(137, 145, 160.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(19, 35, 66, 0.25);
}
.aesirxsso .form-select[multiple], .aesirxsso .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.aesirxsso .form-select:disabled {
  background-color: var(--aesirxsso-secondary-bg);
}
.aesirxsso .form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--aesirxsso-body-color);
}
.aesirxsso .form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--aesirxsso-border-radius-sm);
}
.aesirxsso .form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--aesirxsso-border-radius-lg);
}
.aesirxsso [data-bs-theme=dark] .form-select {
  --aesirxsso-form-select-bg-img: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
}
.aesirxsso .form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.aesirxsso .form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}
.aesirxsso .form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.aesirxsso .form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}
.aesirxsso .form-check-input {
  --aesirxsso-form-check-bg: var(--aesirxsso-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--aesirxsso-form-check-bg);
  background-image: var(--aesirxsso-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--aesirxsso-border-width) solid var(--aesirxsso-border-color);
  print-color-adjust: exact;
}
.aesirxsso .form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.aesirxsso .form-check-input[type=radio] {
  border-radius: 50%;
}
.aesirxsso .form-check-input:active {
  filter: brightness(90%);
}
.aesirxsso .form-check-input:focus {
  border-color: rgb(137, 145, 160.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(19, 35, 66, 0.25);
}
.aesirxsso .form-check-input:checked {
  background-color: #132342;
  border-color: #132342;
}
.aesirxsso .form-check-input:checked[type=checkbox] {
  --aesirxsso-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
}
.aesirxsso .form-check-input:checked[type=radio] {
  --aesirxsso-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e");
}
.aesirxsso .form-check-input[type=checkbox]:indeterminate {
  background-color: #132342;
  border-color: #132342;
  --aesirxsso-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e");
}
.aesirxsso .form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.aesirxsso .form-check-input[disabled] ~ .form-check-label, .aesirxsso .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}
.aesirxsso .form-switch {
  padding-left: 2.5em;
}
.aesirxsso .form-switch .form-check-input {
  --aesirxsso-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e");
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--aesirxsso-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .form-switch .form-check-input {
    transition: none;
  }
}
.aesirxsso .form-switch .form-check-input:focus {
  --aesirxsso-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%28137, 145, 160.5%29'/%3e%3c/svg%3e");
}
.aesirxsso .form-switch .form-check-input:checked {
  background-position: right center;
  --aesirxsso-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}
.aesirxsso .form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.aesirxsso .form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}
.aesirxsso .form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}
.aesirxsso .btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.aesirxsso .btn-check[disabled] + .btn, .aesirxsso .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}
.aesirxsso [data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --aesirxsso-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e");
}
.aesirxsso .form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.aesirxsso .form-range:focus {
  outline: 0;
}
.aesirxsso .form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(19, 35, 66, 0.25);
}
.aesirxsso .form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(19, 35, 66, 0.25);
}
.aesirxsso .form-range::-moz-focus-outer {
  border: 0;
}
.aesirxsso .form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #132342;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
.aesirxsso .form-range::-webkit-slider-thumb:active {
  background-color: rgb(184.2, 189, 198.3);
}
.aesirxsso .form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--aesirxsso-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.aesirxsso .form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #132342;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .form-range::-moz-range-thumb {
    transition: none;
  }
}
.aesirxsso .form-range::-moz-range-thumb:active {
  background-color: rgb(184.2, 189, 198.3);
}
.aesirxsso .form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--aesirxsso-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.aesirxsso .form-range:disabled {
  pointer-events: none;
}
.aesirxsso .form-range:disabled::-webkit-slider-thumb {
  background-color: var(--aesirxsso-secondary-color);
}
.aesirxsso .form-range:disabled::-moz-range-thumb {
  background-color: var(--aesirxsso-secondary-color);
}
.aesirxsso .form-floating {
  position: relative;
}
.aesirxsso .form-floating > .form-control,
.aesirxsso .form-floating > .form-control-plaintext,
.aesirxsso .form-floating > .form-select {
  height: calc(3.5rem + calc(var(--aesirxsso-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--aesirxsso-border-width) * 2));
  line-height: 1.25;
}
.aesirxsso .form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--aesirxsso-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .form-floating > label {
    transition: none;
  }
}
.aesirxsso .form-floating > .form-control,
.aesirxsso .form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.aesirxsso .form-floating > .form-control::placeholder,
.aesirxsso .form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.aesirxsso .form-floating > .form-control:focus, .aesirxsso .form-floating > .form-control:not(:placeholder-shown),
.aesirxsso .form-floating > .form-control-plaintext:focus,
.aesirxsso .form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.aesirxsso .form-floating > .form-control:-webkit-autofill,
.aesirxsso .form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.aesirxsso .form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.aesirxsso .form-floating > .form-control:focus ~ label,
.aesirxsso .form-floating > .form-control:not(:placeholder-shown) ~ label,
.aesirxsso .form-floating > .form-control-plaintext ~ label,
.aesirxsso .form-floating > .form-select ~ label {
  color: rgba(var(--aesirxsso-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.aesirxsso .form-floating > .form-control:focus ~ label::after,
.aesirxsso .form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.aesirxsso .form-floating > .form-control-plaintext ~ label::after,
.aesirxsso .form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--aesirxsso-body-bg);
  border-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--aesirxsso-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.aesirxsso .form-floating > .form-control-plaintext ~ label {
  border-width: var(--aesirxsso-border-width) 0;
}
.aesirxsso .form-floating > :disabled ~ label,
.aesirxsso .form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.aesirxsso .form-floating > :disabled ~ label::after,
.aesirxsso .form-floating > .form-control:disabled ~ label::after {
  background-color: var(--aesirxsso-secondary-bg);
}
.aesirxsso .input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.aesirxsso .input-group > .form-control,
.aesirxsso .input-group > .form-select,
.aesirxsso .input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.aesirxsso .input-group > .form-control:focus,
.aesirxsso .input-group > .form-select:focus,
.aesirxsso .input-group > .form-floating:focus-within {
  z-index: 5;
}
.aesirxsso .input-group .btn {
  position: relative;
  z-index: 2;
}
.aesirxsso .input-group .btn:focus {
  z-index: 5;
}
.aesirxsso .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--aesirxsso-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--aesirxsso-tertiary-bg);
  border: var(--aesirxsso-border-width) solid var(--aesirxsso-border-color);
  border-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .input-group-lg > .form-control,
.aesirxsso .input-group-lg > .form-select,
.aesirxsso .input-group-lg > .input-group-text,
.aesirxsso .input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--aesirxsso-border-radius-lg);
}
.aesirxsso .input-group-sm > .form-control,
.aesirxsso .input-group-sm > .form-select,
.aesirxsso .input-group-sm > .input-group-text,
.aesirxsso .input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--aesirxsso-border-radius-sm);
}
.aesirxsso .input-group-lg > .form-select,
.aesirxsso .input-group-sm > .form-select {
  padding-right: 3rem;
}
.aesirxsso .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.aesirxsso .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.aesirxsso .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.aesirxsso .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.aesirxsso .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.aesirxsso .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.aesirxsso .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.aesirxsso .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.aesirxsso .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--aesirxsso-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxsso .input-group > .form-floating:not(:first-child) > .form-control,
.aesirxsso .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxsso .valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--aesirxsso-form-valid-color);
}
.aesirxsso .valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--aesirxsso-success);
  border-radius: var(--aesirxsso-border-radius);
}
.was-validated .aesirxsso:valid ~ .valid-feedback,
.was-validated .aesirxsso:valid ~ .valid-tooltip, .aesirxsso.is-valid ~ .valid-feedback,
.aesirxsso.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .aesirxsso .form-control:valid, .aesirxsso .form-control.is-valid {
  border-color: var(--aesirxsso-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%231ab394' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .aesirxsso .form-control:valid:focus, .aesirxsso .form-control.is-valid:focus {
  border-color: var(--aesirxsso-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxsso-success-rgb), 0.25);
}
.was-validated .aesirxsso textarea.form-control:valid, .aesirxsso textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
.was-validated .aesirxsso .form-select:valid, .aesirxsso .form-select.is-valid {
  border-color: var(--aesirxsso-form-valid-border-color);
}
.was-validated .aesirxsso .form-select:valid:not([multiple]):not([size]), .was-validated .aesirxsso .form-select:valid:not([multiple])[size="1"], .aesirxsso .form-select.is-valid:not([multiple]):not([size]), .aesirxsso .form-select.is-valid:not([multiple])[size="1"] {
  --aesirxsso-form-select-bg-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%231ab394' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .aesirxsso .form-select:valid:focus, .aesirxsso .form-select.is-valid:focus {
  border-color: var(--aesirxsso-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxsso-success-rgb), 0.25);
}
.was-validated .aesirxsso .form-control-color:valid, .aesirxsso .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}
.was-validated .aesirxsso .form-check-input:valid, .aesirxsso .form-check-input.is-valid {
  border-color: var(--aesirxsso-form-valid-border-color);
}
.was-validated .aesirxsso .form-check-input:valid:checked, .aesirxsso .form-check-input.is-valid:checked {
  background-color: var(--aesirxsso-form-valid-color);
}
.was-validated .aesirxsso .form-check-input:valid:focus, .aesirxsso .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxsso-success-rgb), 0.25);
}
.was-validated .aesirxsso .form-check-input:valid ~ .form-check-label, .aesirxsso .form-check-input.is-valid ~ .form-check-label {
  color: var(--aesirxsso-form-valid-color);
}
.aesirxsso .form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}
.was-validated .aesirxsso .input-group > .form-control:not(:focus):valid, .aesirxsso .input-group > .form-control:not(:focus).is-valid,
.was-validated .aesirxsso .input-group > .form-select:not(:focus):valid,
.aesirxsso .input-group > .form-select:not(:focus).is-valid,
.was-validated .aesirxsso .input-group > .form-floating:not(:focus-within):valid,
.aesirxsso .input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}
.aesirxsso .invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--aesirxsso-form-invalid-color);
}
.aesirxsso .invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--aesirxsso-danger);
  border-radius: var(--aesirxsso-border-radius);
}
.was-validated .aesirxsso:invalid ~ .invalid-feedback,
.was-validated .aesirxsso:invalid ~ .invalid-tooltip, .aesirxsso.is-invalid ~ .invalid-feedback,
.aesirxsso.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .aesirxsso .form-control:invalid, .aesirxsso .form-control.is-invalid {
  border-color: var(--aesirxsso-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .aesirxsso .form-control:invalid:focus, .aesirxsso .form-control.is-invalid:focus {
  border-color: var(--aesirxsso-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxsso-danger-rgb), 0.25);
}
.was-validated .aesirxsso textarea.form-control:invalid, .aesirxsso textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
.was-validated .aesirxsso .form-select:invalid, .aesirxsso .form-select.is-invalid {
  border-color: var(--aesirxsso-form-invalid-border-color);
}
.was-validated .aesirxsso .form-select:invalid:not([multiple]):not([size]), .was-validated .aesirxsso .form-select:invalid:not([multiple])[size="1"], .aesirxsso .form-select.is-invalid:not([multiple]):not([size]), .aesirxsso .form-select.is-invalid:not([multiple])[size="1"] {
  --aesirxsso-form-select-bg-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .aesirxsso .form-select:invalid:focus, .aesirxsso .form-select.is-invalid:focus {
  border-color: var(--aesirxsso-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxsso-danger-rgb), 0.25);
}
.was-validated .aesirxsso .form-control-color:invalid, .aesirxsso .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}
.was-validated .aesirxsso .form-check-input:invalid, .aesirxsso .form-check-input.is-invalid {
  border-color: var(--aesirxsso-form-invalid-border-color);
}
.was-validated .aesirxsso .form-check-input:invalid:checked, .aesirxsso .form-check-input.is-invalid:checked {
  background-color: var(--aesirxsso-form-invalid-color);
}
.was-validated .aesirxsso .form-check-input:invalid:focus, .aesirxsso .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--aesirxsso-danger-rgb), 0.25);
}
.was-validated .aesirxsso .form-check-input:invalid ~ .form-check-label, .aesirxsso .form-check-input.is-invalid ~ .form-check-label {
  color: var(--aesirxsso-form-invalid-color);
}
.aesirxsso .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}
.was-validated .aesirxsso .input-group > .form-control:not(:focus):invalid, .aesirxsso .input-group > .form-control:not(:focus).is-invalid,
.was-validated .aesirxsso .input-group > .form-select:not(:focus):invalid,
.aesirxsso .input-group > .form-select:not(:focus).is-invalid,
.was-validated .aesirxsso .input-group > .form-floating:not(:focus-within):invalid,
.aesirxsso .input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}
.aesirxsso .btn-group,
.aesirxsso .btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.aesirxsso .btn-group > .btn,
.aesirxsso .btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.aesirxsso .btn-group > .btn-check:checked + .btn,
.aesirxsso .btn-group > .btn-check:focus + .btn,
.aesirxsso .btn-group > .btn:hover,
.aesirxsso .btn-group > .btn:focus,
.aesirxsso .btn-group > .btn:active,
.aesirxsso .btn-group > .btn.active,
.aesirxsso .btn-group-vertical > .btn-check:checked + .btn,
.aesirxsso .btn-group-vertical > .btn-check:focus + .btn,
.aesirxsso .btn-group-vertical > .btn:hover,
.aesirxsso .btn-group-vertical > .btn:focus,
.aesirxsso .btn-group-vertical > .btn:active,
.aesirxsso .btn-group-vertical > .btn.active {
  z-index: 1;
}
.aesirxsso .btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.aesirxsso .btn-toolbar .input-group {
  width: auto;
}
.aesirxsso .btn-group {
  border-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .btn-group > :not(.btn-check:first-child) + .btn,
.aesirxsso .btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--aesirxsso-border-width) * -1);
}
.aesirxsso .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.aesirxsso .btn-group > .btn.dropdown-toggle-split:first-child,
.aesirxsso .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.aesirxsso .btn-group > .btn:nth-child(n+3),
.aesirxsso .btn-group > :not(.btn-check) + .btn,
.aesirxsso .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxsso .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.aesirxsso .dropdown-toggle-split::after, .dropup .aesirxsso .dropdown-toggle-split::after, .dropend .aesirxsso .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .aesirxsso .dropdown-toggle-split::before {
  margin-right: 0;
}
.aesirxsso .btn-sm + .dropdown-toggle-split, .aesirxsso .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}
.aesirxsso .btn-lg + .dropdown-toggle-split, .aesirxsso .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
.aesirxsso .btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.aesirxsso .btn-group-vertical > .btn,
.aesirxsso .btn-group-vertical > .btn-group {
  width: 100%;
}
.aesirxsso .btn-group-vertical > .btn:not(:first-child),
.aesirxsso .btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--aesirxsso-border-width) * -1);
}
.aesirxsso .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.aesirxsso .btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxsso .btn-group-vertical > .btn ~ .btn,
.aesirxsso .btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.aesirxsso .btn {
  --aesirxsso-btn-padding-x: 0.75rem;
  --aesirxsso-btn-padding-y: 0.375rem;
  --aesirxsso-btn-font-family: ;
  --aesirxsso-btn-font-size: 1rem;
  --aesirxsso-btn-font-weight: 400;
  --aesirxsso-btn-line-height: 1.5;
  --aesirxsso-btn-color: var(--aesirxsso-body-color);
  --aesirxsso-btn-bg: transparent;
  --aesirxsso-btn-border-width: var(--aesirxsso-border-width);
  --aesirxsso-btn-border-color: transparent;
  --aesirxsso-btn-border-radius: var(--aesirxsso-border-radius);
  --aesirxsso-btn-hover-border-color: transparent;
  --aesirxsso-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --aesirxsso-btn-disabled-opacity: 0.65;
  --aesirxsso-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--aesirxsso-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--aesirxsso-btn-padding-y) var(--aesirxsso-btn-padding-x);
  font-family: var(--aesirxsso-btn-font-family);
  font-size: var(--aesirxsso-btn-font-size);
  font-weight: var(--aesirxsso-btn-font-weight);
  line-height: var(--aesirxsso-btn-line-height);
  color: var(--aesirxsso-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--aesirxsso-btn-border-width) solid var(--aesirxsso-btn-border-color);
  border-radius: var(--aesirxsso-btn-border-radius);
  background-color: var(--aesirxsso-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .btn {
    transition: none;
  }
}
.aesirxsso .btn:hover {
  color: var(--aesirxsso-btn-hover-color);
  background-color: var(--aesirxsso-btn-hover-bg);
  border-color: var(--aesirxsso-btn-hover-border-color);
}
.btn-check + .aesirxsso .btn:hover {
  color: var(--aesirxsso-btn-color);
  background-color: var(--aesirxsso-btn-bg);
  border-color: var(--aesirxsso-btn-border-color);
}
.aesirxsso .btn:focus-visible {
  color: var(--aesirxsso-btn-hover-color);
  background-color: var(--aesirxsso-btn-hover-bg);
  border-color: var(--aesirxsso-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--aesirxsso-btn-focus-box-shadow);
}
.btn-check:focus-visible + .aesirxsso .btn {
  border-color: var(--aesirxsso-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--aesirxsso-btn-focus-box-shadow);
}
.btn-check:checked + .aesirxsso .btn, :not(.btn-check) + .aesirxsso .btn:active, .aesirxsso .btn:first-child:active, .aesirxsso .btn.active, .aesirxsso .btn.show {
  color: var(--aesirxsso-btn-active-color);
  background-color: var(--aesirxsso-btn-active-bg);
  border-color: var(--aesirxsso-btn-active-border-color);
}
.btn-check:checked + .aesirxsso .btn:focus-visible, :not(.btn-check) + .aesirxsso .btn:active:focus-visible, .aesirxsso .btn:first-child:active:focus-visible, .aesirxsso .btn.active:focus-visible, .aesirxsso .btn.show:focus-visible {
  box-shadow: var(--aesirxsso-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .aesirxsso .btn {
  box-shadow: var(--aesirxsso-btn-focus-box-shadow);
}
.aesirxsso .btn:disabled, .aesirxsso .btn.disabled, fieldset:disabled .aesirxsso .btn {
  color: var(--aesirxsso-btn-disabled-color);
  pointer-events: none;
  background-color: var(--aesirxsso-btn-disabled-bg);
  border-color: var(--aesirxsso-btn-disabled-border-color);
  opacity: var(--aesirxsso-btn-disabled-opacity);
}
.aesirxsso .btn-primary {
  --aesirxsso-btn-color: #fff;
  --aesirxsso-btn-bg: #132342;
  --aesirxsso-btn-border-color: #132342;
  --aesirxsso-btn-hover-color: #fff;
  --aesirxsso-btn-hover-bg: rgb(16.15, 29.75, 56.1);
  --aesirxsso-btn-hover-border-color: rgb(15.2, 28, 52.8);
  --aesirxsso-btn-focus-shadow-rgb: 54, 68, 94;
  --aesirxsso-btn-active-color: #fff;
  --aesirxsso-btn-active-bg: rgb(15.2, 28, 52.8);
  --aesirxsso-btn-active-border-color: rgb(14.25, 26.25, 49.5);
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #fff;
  --aesirxsso-btn-disabled-bg: #132342;
  --aesirxsso-btn-disabled-border-color: #132342;
}
.aesirxsso .btn-secondary {
  --aesirxsso-btn-color: #000;
  --aesirxsso-btn-bg: #627eea;
  --aesirxsso-btn-border-color: #627eea;
  --aesirxsso-btn-hover-color: #000;
  --aesirxsso-btn-hover-bg: rgb(121.55, 145.35, 237.15);
  --aesirxsso-btn-hover-border-color: rgb(113.7, 138.9, 236.1);
  --aesirxsso-btn-focus-shadow-rgb: 83, 107, 199;
  --aesirxsso-btn-active-color: #000;
  --aesirxsso-btn-active-bg: rgb(129.4, 151.8, 238.2);
  --aesirxsso-btn-active-border-color: rgb(113.7, 138.9, 236.1);
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #000;
  --aesirxsso-btn-disabled-bg: #627eea;
  --aesirxsso-btn-disabled-border-color: #627eea;
}
.aesirxsso .btn-success {
  --aesirxsso-btn-color: #000;
  --aesirxsso-btn-bg: #1ab394;
  --aesirxsso-btn-border-color: #1ab394;
  --aesirxsso-btn-hover-color: #000;
  --aesirxsso-btn-hover-bg: rgb(60.35, 190.4, 164.05);
  --aesirxsso-btn-hover-border-color: rgb(48.9, 186.6, 158.7);
  --aesirxsso-btn-focus-shadow-rgb: 22, 152, 126;
  --aesirxsso-btn-active-color: #000;
  --aesirxsso-btn-active-bg: rgb(71.8, 194.2, 169.4);
  --aesirxsso-btn-active-border-color: rgb(48.9, 186.6, 158.7);
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #000;
  --aesirxsso-btn-disabled-bg: #1ab394;
  --aesirxsso-btn-disabled-border-color: #1ab394;
}
.aesirxsso .btn-info {
  --aesirxsso-btn-color: #000;
  --aesirxsso-btn-bg: #0dcaf0;
  --aesirxsso-btn-border-color: #0dcaf0;
  --aesirxsso-btn-hover-color: #000;
  --aesirxsso-btn-hover-bg: rgb(49.3, 209.95, 242.25);
  --aesirxsso-btn-hover-border-color: rgb(37.2, 207.3, 241.5);
  --aesirxsso-btn-focus-shadow-rgb: 11, 172, 204;
  --aesirxsso-btn-active-color: #000;
  --aesirxsso-btn-active-bg: rgb(61.4, 212.6, 243);
  --aesirxsso-btn-active-border-color: rgb(37.2, 207.3, 241.5);
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #000;
  --aesirxsso-btn-disabled-bg: #0dcaf0;
  --aesirxsso-btn-disabled-border-color: #0dcaf0;
}
.aesirxsso .btn-warning {
  --aesirxsso-btn-color: #000;
  --aesirxsso-btn-bg: #ffc107;
  --aesirxsso-btn-border-color: #ffc107;
  --aesirxsso-btn-hover-color: #000;
  --aesirxsso-btn-hover-bg: rgb(255, 202.3, 44.2);
  --aesirxsso-btn-hover-border-color: rgb(255, 199.2, 31.8);
  --aesirxsso-btn-focus-shadow-rgb: 217, 164, 6;
  --aesirxsso-btn-active-color: #000;
  --aesirxsso-btn-active-bg: rgb(255, 205.4, 56.6);
  --aesirxsso-btn-active-border-color: rgb(255, 199.2, 31.8);
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #000;
  --aesirxsso-btn-disabled-bg: #ffc107;
  --aesirxsso-btn-disabled-border-color: #ffc107;
}
.aesirxsso .btn-danger {
  --aesirxsso-btn-color: #fff;
  --aesirxsso-btn-bg: #dc3545;
  --aesirxsso-btn-border-color: #dc3545;
  --aesirxsso-btn-hover-color: #fff;
  --aesirxsso-btn-hover-bg: rgb(187, 45.05, 58.65);
  --aesirxsso-btn-hover-border-color: rgb(176, 42.4, 55.2);
  --aesirxsso-btn-focus-shadow-rgb: 225, 83, 97;
  --aesirxsso-btn-active-color: #fff;
  --aesirxsso-btn-active-bg: rgb(176, 42.4, 55.2);
  --aesirxsso-btn-active-border-color: rgb(165, 39.75, 51.75);
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #fff;
  --aesirxsso-btn-disabled-bg: #dc3545;
  --aesirxsso-btn-disabled-border-color: #dc3545;
}
.aesirxsso .btn-light {
  --aesirxsso-btn-color: #000;
  --aesirxsso-btn-bg: #f8f9fa;
  --aesirxsso-btn-border-color: #f8f9fa;
  --aesirxsso-btn-hover-color: #000;
  --aesirxsso-btn-hover-bg: rgb(210.8, 211.65, 212.5);
  --aesirxsso-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --aesirxsso-btn-focus-shadow-rgb: 211, 212, 213;
  --aesirxsso-btn-active-color: #000;
  --aesirxsso-btn-active-bg: rgb(198.4, 199.2, 200);
  --aesirxsso-btn-active-border-color: rgb(186, 186.75, 187.5);
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #000;
  --aesirxsso-btn-disabled-bg: #f8f9fa;
  --aesirxsso-btn-disabled-border-color: #f8f9fa;
}
.aesirxsso .btn-dark {
  --aesirxsso-btn-color: #fff;
  --aesirxsso-btn-bg: #0f1314;
  --aesirxsso-btn-border-color: #0f1314;
  --aesirxsso-btn-hover-color: #fff;
  --aesirxsso-btn-hover-bg: rgb(51, 54.4, 55.25);
  --aesirxsso-btn-hover-border-color: rgb(39, 42.6, 43.5);
  --aesirxsso-btn-focus-shadow-rgb: 51, 54, 55;
  --aesirxsso-btn-active-color: #fff;
  --aesirxsso-btn-active-bg: rgb(63, 66.2, 67);
  --aesirxsso-btn-active-border-color: rgb(39, 42.6, 43.5);
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #fff;
  --aesirxsso-btn-disabled-bg: #0f1314;
  --aesirxsso-btn-disabled-border-color: #0f1314;
}
.aesirxsso .btn-outline-primary {
  --aesirxsso-btn-color: #132342;
  --aesirxsso-btn-border-color: #132342;
  --aesirxsso-btn-hover-color: #fff;
  --aesirxsso-btn-hover-bg: #132342;
  --aesirxsso-btn-hover-border-color: #132342;
  --aesirxsso-btn-focus-shadow-rgb: 19, 35, 66;
  --aesirxsso-btn-active-color: #fff;
  --aesirxsso-btn-active-bg: #132342;
  --aesirxsso-btn-active-border-color: #132342;
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #132342;
  --aesirxsso-btn-disabled-bg: transparent;
  --aesirxsso-btn-disabled-border-color: #132342;
  --aesirxsso-gradient: none;
}
.aesirxsso .btn-outline-secondary {
  --aesirxsso-btn-color: #627eea;
  --aesirxsso-btn-border-color: #627eea;
  --aesirxsso-btn-hover-color: #000;
  --aesirxsso-btn-hover-bg: #627eea;
  --aesirxsso-btn-hover-border-color: #627eea;
  --aesirxsso-btn-focus-shadow-rgb: 98, 126, 234;
  --aesirxsso-btn-active-color: #000;
  --aesirxsso-btn-active-bg: #627eea;
  --aesirxsso-btn-active-border-color: #627eea;
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #627eea;
  --aesirxsso-btn-disabled-bg: transparent;
  --aesirxsso-btn-disabled-border-color: #627eea;
  --aesirxsso-gradient: none;
}
.aesirxsso .btn-outline-success {
  --aesirxsso-btn-color: #1ab394;
  --aesirxsso-btn-border-color: #1ab394;
  --aesirxsso-btn-hover-color: #000;
  --aesirxsso-btn-hover-bg: #1ab394;
  --aesirxsso-btn-hover-border-color: #1ab394;
  --aesirxsso-btn-focus-shadow-rgb: 26, 179, 148;
  --aesirxsso-btn-active-color: #000;
  --aesirxsso-btn-active-bg: #1ab394;
  --aesirxsso-btn-active-border-color: #1ab394;
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #1ab394;
  --aesirxsso-btn-disabled-bg: transparent;
  --aesirxsso-btn-disabled-border-color: #1ab394;
  --aesirxsso-gradient: none;
}
.aesirxsso .btn-outline-info {
  --aesirxsso-btn-color: #0dcaf0;
  --aesirxsso-btn-border-color: #0dcaf0;
  --aesirxsso-btn-hover-color: #000;
  --aesirxsso-btn-hover-bg: #0dcaf0;
  --aesirxsso-btn-hover-border-color: #0dcaf0;
  --aesirxsso-btn-focus-shadow-rgb: 13, 202, 240;
  --aesirxsso-btn-active-color: #000;
  --aesirxsso-btn-active-bg: #0dcaf0;
  --aesirxsso-btn-active-border-color: #0dcaf0;
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #0dcaf0;
  --aesirxsso-btn-disabled-bg: transparent;
  --aesirxsso-btn-disabled-border-color: #0dcaf0;
  --aesirxsso-gradient: none;
}
.aesirxsso .btn-outline-warning {
  --aesirxsso-btn-color: #ffc107;
  --aesirxsso-btn-border-color: #ffc107;
  --aesirxsso-btn-hover-color: #000;
  --aesirxsso-btn-hover-bg: #ffc107;
  --aesirxsso-btn-hover-border-color: #ffc107;
  --aesirxsso-btn-focus-shadow-rgb: 255, 193, 7;
  --aesirxsso-btn-active-color: #000;
  --aesirxsso-btn-active-bg: #ffc107;
  --aesirxsso-btn-active-border-color: #ffc107;
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #ffc107;
  --aesirxsso-btn-disabled-bg: transparent;
  --aesirxsso-btn-disabled-border-color: #ffc107;
  --aesirxsso-gradient: none;
}
.aesirxsso .btn-outline-danger {
  --aesirxsso-btn-color: #dc3545;
  --aesirxsso-btn-border-color: #dc3545;
  --aesirxsso-btn-hover-color: #fff;
  --aesirxsso-btn-hover-bg: #dc3545;
  --aesirxsso-btn-hover-border-color: #dc3545;
  --aesirxsso-btn-focus-shadow-rgb: 220, 53, 69;
  --aesirxsso-btn-active-color: #fff;
  --aesirxsso-btn-active-bg: #dc3545;
  --aesirxsso-btn-active-border-color: #dc3545;
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #dc3545;
  --aesirxsso-btn-disabled-bg: transparent;
  --aesirxsso-btn-disabled-border-color: #dc3545;
  --aesirxsso-gradient: none;
}
.aesirxsso .btn-outline-light {
  --aesirxsso-btn-color: #f8f9fa;
  --aesirxsso-btn-border-color: #f8f9fa;
  --aesirxsso-btn-hover-color: #000;
  --aesirxsso-btn-hover-bg: #f8f9fa;
  --aesirxsso-btn-hover-border-color: #f8f9fa;
  --aesirxsso-btn-focus-shadow-rgb: 248, 249, 250;
  --aesirxsso-btn-active-color: #000;
  --aesirxsso-btn-active-bg: #f8f9fa;
  --aesirxsso-btn-active-border-color: #f8f9fa;
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #f8f9fa;
  --aesirxsso-btn-disabled-bg: transparent;
  --aesirxsso-btn-disabled-border-color: #f8f9fa;
  --aesirxsso-gradient: none;
}
.aesirxsso .btn-outline-dark {
  --aesirxsso-btn-color: #0f1314;
  --aesirxsso-btn-border-color: #0f1314;
  --aesirxsso-btn-hover-color: #fff;
  --aesirxsso-btn-hover-bg: #0f1314;
  --aesirxsso-btn-hover-border-color: #0f1314;
  --aesirxsso-btn-focus-shadow-rgb: 15, 19, 20;
  --aesirxsso-btn-active-color: #fff;
  --aesirxsso-btn-active-bg: #0f1314;
  --aesirxsso-btn-active-border-color: #0f1314;
  --aesirxsso-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --aesirxsso-btn-disabled-color: #0f1314;
  --aesirxsso-btn-disabled-bg: transparent;
  --aesirxsso-btn-disabled-border-color: #0f1314;
  --aesirxsso-gradient: none;
}
.aesirxsso .btn-link {
  --aesirxsso-btn-font-weight: 400;
  --aesirxsso-btn-color: var(--aesirxsso-link-color);
  --aesirxsso-btn-bg: transparent;
  --aesirxsso-btn-border-color: transparent;
  --aesirxsso-btn-hover-color: var(--aesirxsso-link-hover-color);
  --aesirxsso-btn-hover-border-color: transparent;
  --aesirxsso-btn-active-color: var(--aesirxsso-link-hover-color);
  --aesirxsso-btn-active-border-color: transparent;
  --aesirxsso-btn-disabled-color: #6c757d;
  --aesirxsso-btn-disabled-border-color: transparent;
  --aesirxsso-btn-box-shadow: 0 0 0 #000;
  --aesirxsso-btn-focus-shadow-rgb: 54, 68, 94;
  text-decoration: underline;
}
.aesirxsso .btn-link:focus-visible {
  color: var(--aesirxsso-btn-color);
}
.aesirxsso .btn-link:hover {
  color: var(--aesirxsso-btn-hover-color);
}
.aesirxsso .btn-lg, .aesirxsso .btn-group-lg > .btn {
  --aesirxsso-btn-padding-y: 0.5rem;
  --aesirxsso-btn-padding-x: 1rem;
  --aesirxsso-btn-font-size: 1.25rem;
  --aesirxsso-btn-border-radius: var(--aesirxsso-border-radius-lg);
}
.aesirxsso .btn-sm, .aesirxsso .btn-group-sm > .btn {
  --aesirxsso-btn-padding-y: 0.25rem;
  --aesirxsso-btn-padding-x: 0.5rem;
  --aesirxsso-btn-font-size: 0.875rem;
  --aesirxsso-btn-border-radius: var(--aesirxsso-border-radius-sm);
}
.aesirxsso .spinner-grow,
.aesirxsso .spinner-border {
  display: inline-block;
  width: var(--aesirxsso-spinner-width);
  height: var(--aesirxsso-spinner-height);
  vertical-align: var(--aesirxsso-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--aesirxsso-spinner-animation-speed) linear infinite var(--aesirxsso-spinner-animation-name);
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.aesirxsso .spinner-border {
  --aesirxsso-spinner-width: 2rem;
  --aesirxsso-spinner-height: 2rem;
  --aesirxsso-spinner-vertical-align: -0.125em;
  --aesirxsso-spinner-border-width: 0.25em;
  --aesirxsso-spinner-animation-speed: 0.75s;
  --aesirxsso-spinner-animation-name: spinner-border;
  border: var(--aesirxsso-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}
.aesirxsso .spinner-border-sm {
  --aesirxsso-spinner-width: 1rem;
  --aesirxsso-spinner-height: 1rem;
  --aesirxsso-spinner-border-width: 0.2em;
}
@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.aesirxsso .spinner-grow {
  --aesirxsso-spinner-width: 2rem;
  --aesirxsso-spinner-height: 2rem;
  --aesirxsso-spinner-vertical-align: -0.125em;
  --aesirxsso-spinner-animation-speed: 0.75s;
  --aesirxsso-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}
.aesirxsso .spinner-grow-sm {
  --aesirxsso-spinner-width: 1rem;
  --aesirxsso-spinner-height: 1rem;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .spinner-border,
  .aesirxsso .spinner-grow {
    --aesirxsso-spinner-animation-speed: 1.5s;
  }
}
.aesirxsso .btn-close {
  --aesirxsso-btn-close-color: #fff;
  --aesirxsso-btn-close-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e");
  --aesirxsso-btn-close-opacity: 1;
  --aesirxsso-btn-close-hover-opacity: 0.75;
  --aesirxsso-btn-close-focus-shadow: 0 0 0 0.25rem rgba(19, 35, 66, 0.25);
  --aesirxsso-btn-close-focus-opacity: 1;
  --aesirxsso-btn-close-disabled-opacity: 0.25;
  --aesirxsso-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--aesirxsso-btn-close-color);
  background: transparent var(--aesirxsso-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--aesirxsso-btn-close-opacity);
}
.aesirxsso .btn-close:hover {
  color: var(--aesirxsso-btn-close-color);
  text-decoration: none;
  opacity: var(--aesirxsso-btn-close-hover-opacity);
}
.aesirxsso .btn-close:focus {
  outline: 0;
  box-shadow: var(--aesirxsso-btn-close-focus-shadow);
  opacity: var(--aesirxsso-btn-close-focus-opacity);
}
.aesirxsso .btn-close:disabled, .aesirxsso .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--aesirxsso-btn-close-disabled-opacity);
}
.aesirxsso .btn-close-white {
  filter: var(--aesirxsso-btn-close-white-filter);
}
.aesirxsso [data-bs-theme=dark] .btn-close {
  filter: var(--aesirxsso-btn-close-white-filter);
}
.aesirxsso .fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .fade {
    transition: none;
  }
}
.aesirxsso .fade:not(.show) {
  opacity: 0;
}
.aesirxsso .collapse:not(.show) {
  display: none;
}
.aesirxsso .collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .collapsing {
    transition: none;
  }
}
.aesirxsso .collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .collapsing.collapse-horizontal {
    transition: none;
  }
}
.aesirxsso .clearfix::after {
  display: block;
  clear: both;
  content: "";
}
.aesirxsso .text-bg-primary {
  color: #fff;
  background-color: RGBA(var(--aesirxsso-primary-rgb), var(--aesirxsso-bg-opacity, 1));
}
.aesirxsso .text-bg-secondary {
  color: #000;
  background-color: RGBA(var(--aesirxsso-secondary-rgb), var(--aesirxsso-bg-opacity, 1));
}
.aesirxsso .text-bg-success {
  color: #000;
  background-color: RGBA(var(--aesirxsso-success-rgb), var(--aesirxsso-bg-opacity, 1));
}
.aesirxsso .text-bg-info {
  color: #000;
  background-color: RGBA(var(--aesirxsso-info-rgb), var(--aesirxsso-bg-opacity, 1));
}
.aesirxsso .text-bg-warning {
  color: #000;
  background-color: RGBA(var(--aesirxsso-warning-rgb), var(--aesirxsso-bg-opacity, 1));
}
.aesirxsso .text-bg-danger {
  color: #fff;
  background-color: RGBA(var(--aesirxsso-danger-rgb), var(--aesirxsso-bg-opacity, 1));
}
.aesirxsso .text-bg-light {
  color: #000;
  background-color: RGBA(var(--aesirxsso-light-rgb), var(--aesirxsso-bg-opacity, 1));
}
.aesirxsso .text-bg-dark {
  color: #fff;
  background-color: RGBA(var(--aesirxsso-dark-rgb), var(--aesirxsso-bg-opacity, 1));
}
.aesirxsso .link-primary {
  color: RGBA(var(--aesirxsso-primary-rgb), var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxsso-primary-rgb), var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-primary:hover, .aesirxsso .link-primary:focus {
  color: RGBA(15, 28, 53, var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(15, 28, 53, var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-secondary {
  color: RGBA(var(--aesirxsso-secondary-rgb), var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxsso-secondary-rgb), var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-secondary:hover, .aesirxsso .link-secondary:focus {
  color: RGBA(129, 152, 238, var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(129, 152, 238, var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-success {
  color: RGBA(var(--aesirxsso-success-rgb), var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxsso-success-rgb), var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-success:hover, .aesirxsso .link-success:focus {
  color: RGBA(72, 194, 169, var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(72, 194, 169, var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-info {
  color: RGBA(var(--aesirxsso-info-rgb), var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxsso-info-rgb), var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-info:hover, .aesirxsso .link-info:focus {
  color: RGBA(61, 213, 243, var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(61, 213, 243, var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-warning {
  color: RGBA(var(--aesirxsso-warning-rgb), var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxsso-warning-rgb), var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-warning:hover, .aesirxsso .link-warning:focus {
  color: RGBA(255, 205, 57, var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(255, 205, 57, var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-danger {
  color: RGBA(var(--aesirxsso-danger-rgb), var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxsso-danger-rgb), var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-danger:hover, .aesirxsso .link-danger:focus {
  color: RGBA(176, 42, 55, var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(176, 42, 55, var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-light {
  color: RGBA(var(--aesirxsso-light-rgb), var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxsso-light-rgb), var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-light:hover, .aesirxsso .link-light:focus {
  color: RGBA(249, 250, 251, var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(249, 250, 251, var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-dark {
  color: RGBA(var(--aesirxsso-dark-rgb), var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxsso-dark-rgb), var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-dark:hover, .aesirxsso .link-dark:focus {
  color: RGBA(12, 15, 16, var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(12, 15, 16, var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-body-emphasis {
  color: RGBA(var(--aesirxsso-emphasis-color-rgb), var(--aesirxsso-link-opacity, 1));
  text-decoration-color: RGBA(var(--aesirxsso-emphasis-color-rgb), var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-body-emphasis:hover, .aesirxsso .link-body-emphasis:focus {
  color: RGBA(var(--aesirxsso-emphasis-color-rgb), var(--aesirxsso-link-opacity, 0.75));
  text-decoration-color: RGBA(var(--aesirxsso-emphasis-color-rgb), var(--aesirxsso-link-underline-opacity, 0.75));
}
.aesirxsso .focus-ring:focus {
  outline: 0;
  box-shadow: var(--aesirxsso-focus-ring-x, 0) var(--aesirxsso-focus-ring-y, 0) var(--aesirxsso-focus-ring-blur, 0) var(--aesirxsso-focus-ring-width) var(--aesirxsso-focus-ring-color);
}
.aesirxsso .icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--aesirxsso-link-color-rgb), var(--aesirxsso-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.aesirxsso .icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .aesirxsso .icon-link > .bi {
    transition: none;
  }
}
.aesirxsso .icon-link-hover:hover > .bi, .aesirxsso .icon-link-hover:focus-visible > .bi {
  transform: var(--aesirxsso-icon-link-transform, translate3d(0.25em, 0, 0));
}
.aesirxsso .ratio {
  position: relative;
  width: 100%;
}
.aesirxsso .ratio::before {
  display: block;
  padding-top: var(--aesirxsso-aspect-ratio);
  content: "";
}
.aesirxsso .ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.aesirxsso .ratio-1x1 {
  --aesirxsso-aspect-ratio: 100%;
}
.aesirxsso .ratio-4x3 {
  --aesirxsso-aspect-ratio: 75%;
}
.aesirxsso .ratio-16x9 {
  --aesirxsso-aspect-ratio: 56.25%;
}
.aesirxsso .ratio-21x9 {
  --aesirxsso-aspect-ratio: 42.8571428571%;
}
.aesirxsso .fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.aesirxsso .fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
.aesirxsso .sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}
.aesirxsso .sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}
@media (min-width: 576px) {
  .aesirxsso .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .aesirxsso .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .aesirxsso .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .aesirxsso .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .aesirxsso .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .aesirxsso .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .aesirxsso .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .aesirxsso .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .aesirxsso .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .aesirxsso .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.aesirxsso .hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}
.aesirxsso .vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}
.aesirxsso .visually-hidden,
.aesirxsso .visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.aesirxsso .visually-hidden:not(caption),
.aesirxsso .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.aesirxsso .stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}
.aesirxsso .text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.aesirxsso .vr {
  display: inline-block;
  align-self: stretch;
  width: var(--aesirxsso-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}
.aesirxsso .align-baseline {
  vertical-align: baseline;
}
.aesirxsso .align-top {
  vertical-align: top;
}
.aesirxsso .align-middle {
  vertical-align: middle;
}
.aesirxsso .align-bottom {
  vertical-align: bottom;
}
.aesirxsso .align-text-bottom {
  vertical-align: text-bottom;
}
.aesirxsso .align-text-top {
  vertical-align: text-top;
}
.aesirxsso .float-start {
  float: left;
}
.aesirxsso .float-end {
  float: right;
}
.aesirxsso .float-none {
  float: none;
}
.aesirxsso .object-fit-contain {
  object-fit: contain;
}
.aesirxsso .object-fit-cover {
  object-fit: cover;
}
.aesirxsso .object-fit-fill {
  object-fit: fill;
}
.aesirxsso .object-fit-scale {
  object-fit: scale-down;
}
.aesirxsso .object-fit-none {
  object-fit: none;
}
.aesirxsso .opacity-0 {
  opacity: 0;
}
.aesirxsso .opacity-25 {
  opacity: 0.25;
}
.aesirxsso .opacity-50 {
  opacity: 0.5;
}
.aesirxsso .opacity-75 {
  opacity: 0.75;
}
.aesirxsso .opacity-100 {
  opacity: 1;
}
.aesirxsso .overflow-auto {
  overflow: auto;
}
.aesirxsso .overflow-hidden {
  overflow: hidden;
}
.aesirxsso .overflow-visible {
  overflow: visible;
}
.aesirxsso .overflow-scroll {
  overflow: scroll;
}
.aesirxsso .overflow-x-auto {
  overflow-x: auto;
}
.aesirxsso .overflow-x-hidden {
  overflow-x: hidden;
}
.aesirxsso .overflow-x-visible {
  overflow-x: visible;
}
.aesirxsso .overflow-x-scroll {
  overflow-x: scroll;
}
.aesirxsso .overflow-y-auto {
  overflow-y: auto;
}
.aesirxsso .overflow-y-hidden {
  overflow-y: hidden;
}
.aesirxsso .overflow-y-visible {
  overflow-y: visible;
}
.aesirxsso .overflow-y-scroll {
  overflow-y: scroll;
}
.aesirxsso .d-inline {
  display: inline;
}
.aesirxsso .d-inline-block {
  display: inline-block;
}
.aesirxsso .d-block {
  display: block;
}
.aesirxsso .d-grid {
  display: grid;
}
.aesirxsso .d-inline-grid {
  display: inline-grid;
}
.aesirxsso .d-table {
  display: table;
}
.aesirxsso .d-table-row {
  display: table-row;
}
.aesirxsso .d-table-cell {
  display: table-cell;
}
.aesirxsso .d-flex {
  display: flex;
}
.aesirxsso .d-inline-flex {
  display: inline-flex;
}
.aesirxsso .d-none {
  display: none;
}
.aesirxsso .shadow {
  box-shadow: var(--aesirxsso-box-shadow);
}
.aesirxsso .shadow-sm {
  box-shadow: var(--aesirxsso-box-shadow-sm);
}
.aesirxsso .shadow-lg {
  box-shadow: var(--aesirxsso-box-shadow-lg);
}
.aesirxsso .shadow-none {
  box-shadow: none;
}
.aesirxsso .focus-ring-primary {
  --aesirxsso-focus-ring-color: rgba(var(--aesirxsso-primary-rgb), var(--aesirxsso-focus-ring-opacity));
}
.aesirxsso .focus-ring-secondary {
  --aesirxsso-focus-ring-color: rgba(var(--aesirxsso-secondary-rgb), var(--aesirxsso-focus-ring-opacity));
}
.aesirxsso .focus-ring-success {
  --aesirxsso-focus-ring-color: rgba(var(--aesirxsso-success-rgb), var(--aesirxsso-focus-ring-opacity));
}
.aesirxsso .focus-ring-info {
  --aesirxsso-focus-ring-color: rgba(var(--aesirxsso-info-rgb), var(--aesirxsso-focus-ring-opacity));
}
.aesirxsso .focus-ring-warning {
  --aesirxsso-focus-ring-color: rgba(var(--aesirxsso-warning-rgb), var(--aesirxsso-focus-ring-opacity));
}
.aesirxsso .focus-ring-danger {
  --aesirxsso-focus-ring-color: rgba(var(--aesirxsso-danger-rgb), var(--aesirxsso-focus-ring-opacity));
}
.aesirxsso .focus-ring-light {
  --aesirxsso-focus-ring-color: rgba(var(--aesirxsso-light-rgb), var(--aesirxsso-focus-ring-opacity));
}
.aesirxsso .focus-ring-dark {
  --aesirxsso-focus-ring-color: rgba(var(--aesirxsso-dark-rgb), var(--aesirxsso-focus-ring-opacity));
}
.aesirxsso .position-static {
  position: static;
}
.aesirxsso .position-relative {
  position: relative;
}
.aesirxsso .position-absolute {
  position: absolute;
}
.aesirxsso .position-fixed {
  position: fixed;
}
.aesirxsso .position-sticky {
  position: sticky;
}
.aesirxsso .top-0 {
  top: 0;
}
.aesirxsso .top-50 {
  top: 50%;
}
.aesirxsso .top-100 {
  top: 100%;
}
.aesirxsso .bottom-0 {
  bottom: 0;
}
.aesirxsso .bottom-50 {
  bottom: 50%;
}
.aesirxsso .bottom-100 {
  bottom: 100%;
}
.aesirxsso .start-0 {
  left: 0;
}
.aesirxsso .start-50 {
  left: 50%;
}
.aesirxsso .start-100 {
  left: 100%;
}
.aesirxsso .end-0 {
  right: 0;
}
.aesirxsso .end-50 {
  right: 50%;
}
.aesirxsso .end-100 {
  right: 100%;
}
.aesirxsso .translate-middle {
  transform: translate(-50%, -50%);
}
.aesirxsso .translate-middle-x {
  transform: translateX(-50%);
}
.aesirxsso .translate-middle-y {
  transform: translateY(-50%);
}
.aesirxsso .border {
  border: var(--aesirxsso-border-width) var(--aesirxsso-border-style) var(--aesirxsso-border-color);
}
.aesirxsso .border-0 {
  border: 0;
}
.aesirxsso .border-top {
  border-top: var(--aesirxsso-border-width) var(--aesirxsso-border-style) var(--aesirxsso-border-color);
}
.aesirxsso .border-top-0 {
  border-top: 0;
}
.aesirxsso .border-end {
  border-right: var(--aesirxsso-border-width) var(--aesirxsso-border-style) var(--aesirxsso-border-color);
}
.aesirxsso .border-end-0 {
  border-right: 0;
}
.aesirxsso .border-bottom {
  border-bottom: var(--aesirxsso-border-width) var(--aesirxsso-border-style) var(--aesirxsso-border-color);
}
.aesirxsso .border-bottom-0 {
  border-bottom: 0;
}
.aesirxsso .border-start {
  border-left: var(--aesirxsso-border-width) var(--aesirxsso-border-style) var(--aesirxsso-border-color);
}
.aesirxsso .border-start-0 {
  border-left: 0;
}
.aesirxsso .border-primary {
  --aesirxsso-border-opacity: 1;
  border-color: rgba(var(--aesirxsso-primary-rgb), var(--aesirxsso-border-opacity));
}
.aesirxsso .border-secondary {
  --aesirxsso-border-opacity: 1;
  border-color: rgba(var(--aesirxsso-secondary-rgb), var(--aesirxsso-border-opacity));
}
.aesirxsso .border-success {
  --aesirxsso-border-opacity: 1;
  border-color: rgba(var(--aesirxsso-success-rgb), var(--aesirxsso-border-opacity));
}
.aesirxsso .border-info {
  --aesirxsso-border-opacity: 1;
  border-color: rgba(var(--aesirxsso-info-rgb), var(--aesirxsso-border-opacity));
}
.aesirxsso .border-warning {
  --aesirxsso-border-opacity: 1;
  border-color: rgba(var(--aesirxsso-warning-rgb), var(--aesirxsso-border-opacity));
}
.aesirxsso .border-danger {
  --aesirxsso-border-opacity: 1;
  border-color: rgba(var(--aesirxsso-danger-rgb), var(--aesirxsso-border-opacity));
}
.aesirxsso .border-light {
  --aesirxsso-border-opacity: 1;
  border-color: rgba(var(--aesirxsso-light-rgb), var(--aesirxsso-border-opacity));
}
.aesirxsso .border-dark {
  --aesirxsso-border-opacity: 1;
  border-color: rgba(var(--aesirxsso-dark-rgb), var(--aesirxsso-border-opacity));
}
.aesirxsso .border-black {
  --aesirxsso-border-opacity: 1;
  border-color: rgba(var(--aesirxsso-black-rgb), var(--aesirxsso-border-opacity));
}
.aesirxsso .border-white {
  --aesirxsso-border-opacity: 1;
  border-color: rgba(var(--aesirxsso-white-rgb), var(--aesirxsso-border-opacity));
}
.aesirxsso .border-primary-subtle {
  border-color: var(--aesirxsso-primary-border-subtle);
}
.aesirxsso .border-secondary-subtle {
  border-color: var(--aesirxsso-secondary-border-subtle);
}
.aesirxsso .border-success-subtle {
  border-color: var(--aesirxsso-success-border-subtle);
}
.aesirxsso .border-info-subtle {
  border-color: var(--aesirxsso-info-border-subtle);
}
.aesirxsso .border-warning-subtle {
  border-color: var(--aesirxsso-warning-border-subtle);
}
.aesirxsso .border-danger-subtle {
  border-color: var(--aesirxsso-danger-border-subtle);
}
.aesirxsso .border-light-subtle {
  border-color: var(--aesirxsso-light-border-subtle);
}
.aesirxsso .border-dark-subtle {
  border-color: var(--aesirxsso-dark-border-subtle);
}
.aesirxsso .border-1 {
  border-width: 1px;
}
.aesirxsso .border-2 {
  border-width: 2px;
}
.aesirxsso .border-3 {
  border-width: 3px;
}
.aesirxsso .border-4 {
  border-width: 4px;
}
.aesirxsso .border-5 {
  border-width: 5px;
}
.aesirxsso .border-opacity-10 {
  --aesirxsso-border-opacity: 0.1;
}
.aesirxsso .border-opacity-25 {
  --aesirxsso-border-opacity: 0.25;
}
.aesirxsso .border-opacity-50 {
  --aesirxsso-border-opacity: 0.5;
}
.aesirxsso .border-opacity-75 {
  --aesirxsso-border-opacity: 0.75;
}
.aesirxsso .border-opacity-100 {
  --aesirxsso-border-opacity: 1;
}
.aesirxsso .w-25 {
  width: 25%;
}
.aesirxsso .w-50 {
  width: 50%;
}
.aesirxsso .w-75 {
  width: 75%;
}
.aesirxsso .w-100 {
  width: 100%;
}
.aesirxsso .w-auto {
  width: auto;
}
.aesirxsso .mw-100 {
  max-width: 100%;
}
.aesirxsso .vw-100 {
  width: 100vw;
}
.aesirxsso .min-vw-100 {
  min-width: 100vw;
}
.aesirxsso .h-25 {
  height: 25%;
}
.aesirxsso .h-50 {
  height: 50%;
}
.aesirxsso .h-75 {
  height: 75%;
}
.aesirxsso .h-100 {
  height: 100%;
}
.aesirxsso .h-auto {
  height: auto;
}
.aesirxsso .mh-100 {
  max-height: 100%;
}
.aesirxsso .vh-100 {
  height: 100vh;
}
.aesirxsso .min-vh-100 {
  min-height: 100vh;
}
.aesirxsso .flex-fill {
  flex: 1 1 auto;
}
.aesirxsso .flex-row {
  flex-direction: row;
}
.aesirxsso .flex-column {
  flex-direction: column;
}
.aesirxsso .flex-row-reverse {
  flex-direction: row-reverse;
}
.aesirxsso .flex-column-reverse {
  flex-direction: column-reverse;
}
.aesirxsso .flex-grow-0 {
  flex-grow: 0;
}
.aesirxsso .flex-grow-1 {
  flex-grow: 1;
}
.aesirxsso .flex-shrink-0 {
  flex-shrink: 0;
}
.aesirxsso .flex-shrink-1 {
  flex-shrink: 1;
}
.aesirxsso .flex-wrap {
  flex-wrap: wrap;
}
.aesirxsso .flex-nowrap {
  flex-wrap: nowrap;
}
.aesirxsso .flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
.aesirxsso .justify-content-start {
  justify-content: flex-start;
}
.aesirxsso .justify-content-end {
  justify-content: flex-end;
}
.aesirxsso .justify-content-center {
  justify-content: center;
}
.aesirxsso .justify-content-between {
  justify-content: space-between;
}
.aesirxsso .justify-content-around {
  justify-content: space-around;
}
.aesirxsso .justify-content-evenly {
  justify-content: space-evenly;
}
.aesirxsso .align-items-start {
  align-items: flex-start;
}
.aesirxsso .align-items-end {
  align-items: flex-end;
}
.aesirxsso .align-items-center {
  align-items: center;
}
.aesirxsso .align-items-baseline {
  align-items: baseline;
}
.aesirxsso .align-items-stretch {
  align-items: stretch;
}
.aesirxsso .align-content-start {
  align-content: flex-start;
}
.aesirxsso .align-content-end {
  align-content: flex-end;
}
.aesirxsso .align-content-center {
  align-content: center;
}
.aesirxsso .align-content-between {
  align-content: space-between;
}
.aesirxsso .align-content-around {
  align-content: space-around;
}
.aesirxsso .align-content-stretch {
  align-content: stretch;
}
.aesirxsso .align-self-auto {
  align-self: auto;
}
.aesirxsso .align-self-start {
  align-self: flex-start;
}
.aesirxsso .align-self-end {
  align-self: flex-end;
}
.aesirxsso .align-self-center {
  align-self: center;
}
.aesirxsso .align-self-baseline {
  align-self: baseline;
}
.aesirxsso .align-self-stretch {
  align-self: stretch;
}
.aesirxsso .order-first {
  order: -1;
}
.aesirxsso .order-0 {
  order: 0;
}
.aesirxsso .order-1 {
  order: 1;
}
.aesirxsso .order-2 {
  order: 2;
}
.aesirxsso .order-3 {
  order: 3;
}
.aesirxsso .order-4 {
  order: 4;
}
.aesirxsso .order-5 {
  order: 5;
}
.aesirxsso .order-last {
  order: 6;
}
.aesirxsso .m-0 {
  margin: 0;
}
.aesirxsso .m-1 {
  margin: 0.25rem;
}
.aesirxsso .m-2 {
  margin: 0.5rem;
}
.aesirxsso .m-3 {
  margin: 1rem;
}
.aesirxsso .m-4 {
  margin: 1.5rem;
}
.aesirxsso .m-5 {
  margin: 3rem;
}
.aesirxsso .m-auto {
  margin: auto;
}
.aesirxsso .mx-0 {
  margin-right: 0;
  margin-left: 0;
}
.aesirxsso .mx-1 {
  margin-right: 0.25rem;
  margin-left: 0.25rem;
}
.aesirxsso .mx-2 {
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}
.aesirxsso .mx-3 {
  margin-right: 1rem;
  margin-left: 1rem;
}
.aesirxsso .mx-4 {
  margin-right: 1.5rem;
  margin-left: 1.5rem;
}
.aesirxsso .mx-5 {
  margin-right: 3rem;
  margin-left: 3rem;
}
.aesirxsso .mx-auto {
  margin-right: auto;
  margin-left: auto;
}
.aesirxsso .my-0 {
  margin-top: 0;
  margin-bottom: 0;
}
.aesirxsso .my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.aesirxsso .my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.aesirxsso .my-3 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.aesirxsso .my-4 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.aesirxsso .my-5 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.aesirxsso .my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.aesirxsso .mt-0 {
  margin-top: 0;
}
.aesirxsso .mt-1 {
  margin-top: 0.25rem;
}
.aesirxsso .mt-2 {
  margin-top: 0.5rem;
}
.aesirxsso .mt-3 {
  margin-top: 1rem;
}
.aesirxsso .mt-4 {
  margin-top: 1.5rem;
}
.aesirxsso .mt-5 {
  margin-top: 3rem;
}
.aesirxsso .mt-auto {
  margin-top: auto;
}
.aesirxsso .me-0 {
  margin-right: 0;
}
.aesirxsso .me-1 {
  margin-right: 0.25rem;
}
.aesirxsso .me-2 {
  margin-right: 0.5rem;
}
.aesirxsso .me-3 {
  margin-right: 1rem;
}
.aesirxsso .me-4 {
  margin-right: 1.5rem;
}
.aesirxsso .me-5 {
  margin-right: 3rem;
}
.aesirxsso .me-auto {
  margin-right: auto;
}
.aesirxsso .mb-0 {
  margin-bottom: 0;
}
.aesirxsso .mb-1 {
  margin-bottom: 0.25rem;
}
.aesirxsso .mb-2 {
  margin-bottom: 0.5rem;
}
.aesirxsso .mb-3 {
  margin-bottom: 1rem;
}
.aesirxsso .mb-4 {
  margin-bottom: 1.5rem;
}
.aesirxsso .mb-5 {
  margin-bottom: 3rem;
}
.aesirxsso .mb-auto {
  margin-bottom: auto;
}
.aesirxsso .ms-0 {
  margin-left: 0;
}
.aesirxsso .ms-1 {
  margin-left: 0.25rem;
}
.aesirxsso .ms-2 {
  margin-left: 0.5rem;
}
.aesirxsso .ms-3 {
  margin-left: 1rem;
}
.aesirxsso .ms-4 {
  margin-left: 1.5rem;
}
.aesirxsso .ms-5 {
  margin-left: 3rem;
}
.aesirxsso .ms-auto {
  margin-left: auto;
}
.aesirxsso .m-n1 {
  margin: -0.25rem;
}
.aesirxsso .m-n2 {
  margin: -0.5rem;
}
.aesirxsso .m-n3 {
  margin: -1rem;
}
.aesirxsso .m-n4 {
  margin: -1.5rem;
}
.aesirxsso .m-n5 {
  margin: -3rem;
}
.aesirxsso .mx-n1 {
  margin-right: -0.25rem;
  margin-left: -0.25rem;
}
.aesirxsso .mx-n2 {
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}
.aesirxsso .mx-n3 {
  margin-right: -1rem;
  margin-left: -1rem;
}
.aesirxsso .mx-n4 {
  margin-right: -1.5rem;
  margin-left: -1.5rem;
}
.aesirxsso .mx-n5 {
  margin-right: -3rem;
  margin-left: -3rem;
}
.aesirxsso .my-n1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.aesirxsso .my-n2 {
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}
.aesirxsso .my-n3 {
  margin-top: -1rem;
  margin-bottom: -1rem;
}
.aesirxsso .my-n4 {
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;
}
.aesirxsso .my-n5 {
  margin-top: -3rem;
  margin-bottom: -3rem;
}
.aesirxsso .mt-n1 {
  margin-top: -0.25rem;
}
.aesirxsso .mt-n2 {
  margin-top: -0.5rem;
}
.aesirxsso .mt-n3 {
  margin-top: -1rem;
}
.aesirxsso .mt-n4 {
  margin-top: -1.5rem;
}
.aesirxsso .mt-n5 {
  margin-top: -3rem;
}
.aesirxsso .me-n1 {
  margin-right: -0.25rem;
}
.aesirxsso .me-n2 {
  margin-right: -0.5rem;
}
.aesirxsso .me-n3 {
  margin-right: -1rem;
}
.aesirxsso .me-n4 {
  margin-right: -1.5rem;
}
.aesirxsso .me-n5 {
  margin-right: -3rem;
}
.aesirxsso .mb-n1 {
  margin-bottom: -0.25rem;
}
.aesirxsso .mb-n2 {
  margin-bottom: -0.5rem;
}
.aesirxsso .mb-n3 {
  margin-bottom: -1rem;
}
.aesirxsso .mb-n4 {
  margin-bottom: -1.5rem;
}
.aesirxsso .mb-n5 {
  margin-bottom: -3rem;
}
.aesirxsso .ms-n1 {
  margin-left: -0.25rem;
}
.aesirxsso .ms-n2 {
  margin-left: -0.5rem;
}
.aesirxsso .ms-n3 {
  margin-left: -1rem;
}
.aesirxsso .ms-n4 {
  margin-left: -1.5rem;
}
.aesirxsso .ms-n5 {
  margin-left: -3rem;
}
.aesirxsso .p-0 {
  padding: 0;
}
.aesirxsso .p-1 {
  padding: 0.25rem;
}
.aesirxsso .p-2 {
  padding: 0.5rem;
}
.aesirxsso .p-3 {
  padding: 1rem;
}
.aesirxsso .p-4 {
  padding: 1.5rem;
}
.aesirxsso .p-5 {
  padding: 3rem;
}
.aesirxsso .px-0 {
  padding-right: 0;
  padding-left: 0;
}
.aesirxsso .px-1 {
  padding-right: 0.25rem;
  padding-left: 0.25rem;
}
.aesirxsso .px-2 {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.aesirxsso .px-3 {
  padding-right: 1rem;
  padding-left: 1rem;
}
.aesirxsso .px-4 {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}
.aesirxsso .px-5 {
  padding-right: 3rem;
  padding-left: 3rem;
}
.aesirxsso .py-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.aesirxsso .py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.aesirxsso .py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.aesirxsso .py-3 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.aesirxsso .py-4 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.aesirxsso .py-5 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.aesirxsso .pt-0 {
  padding-top: 0;
}
.aesirxsso .pt-1 {
  padding-top: 0.25rem;
}
.aesirxsso .pt-2 {
  padding-top: 0.5rem;
}
.aesirxsso .pt-3 {
  padding-top: 1rem;
}
.aesirxsso .pt-4 {
  padding-top: 1.5rem;
}
.aesirxsso .pt-5 {
  padding-top: 3rem;
}
.aesirxsso .pe-0 {
  padding-right: 0;
}
.aesirxsso .pe-1 {
  padding-right: 0.25rem;
}
.aesirxsso .pe-2 {
  padding-right: 0.5rem;
}
.aesirxsso .pe-3 {
  padding-right: 1rem;
}
.aesirxsso .pe-4 {
  padding-right: 1.5rem;
}
.aesirxsso .pe-5 {
  padding-right: 3rem;
}
.aesirxsso .pb-0 {
  padding-bottom: 0;
}
.aesirxsso .pb-1 {
  padding-bottom: 0.25rem;
}
.aesirxsso .pb-2 {
  padding-bottom: 0.5rem;
}
.aesirxsso .pb-3 {
  padding-bottom: 1rem;
}
.aesirxsso .pb-4 {
  padding-bottom: 1.5rem;
}
.aesirxsso .pb-5 {
  padding-bottom: 3rem;
}
.aesirxsso .ps-0 {
  padding-left: 0;
}
.aesirxsso .ps-1 {
  padding-left: 0.25rem;
}
.aesirxsso .ps-2 {
  padding-left: 0.5rem;
}
.aesirxsso .ps-3 {
  padding-left: 1rem;
}
.aesirxsso .ps-4 {
  padding-left: 1.5rem;
}
.aesirxsso .ps-5 {
  padding-left: 3rem;
}
.aesirxsso .gap-0 {
  gap: 0;
}
.aesirxsso .gap-1 {
  gap: 0.25rem;
}
.aesirxsso .gap-2 {
  gap: 0.5rem;
}
.aesirxsso .gap-3 {
  gap: 1rem;
}
.aesirxsso .gap-4 {
  gap: 1.5rem;
}
.aesirxsso .gap-5 {
  gap: 3rem;
}
.aesirxsso .row-gap-0 {
  row-gap: 0;
}
.aesirxsso .row-gap-1 {
  row-gap: 0.25rem;
}
.aesirxsso .row-gap-2 {
  row-gap: 0.5rem;
}
.aesirxsso .row-gap-3 {
  row-gap: 1rem;
}
.aesirxsso .row-gap-4 {
  row-gap: 1.5rem;
}
.aesirxsso .row-gap-5 {
  row-gap: 3rem;
}
.aesirxsso .column-gap-0 {
  column-gap: 0;
}
.aesirxsso .column-gap-1 {
  column-gap: 0.25rem;
}
.aesirxsso .column-gap-2 {
  column-gap: 0.5rem;
}
.aesirxsso .column-gap-3 {
  column-gap: 1rem;
}
.aesirxsso .column-gap-4 {
  column-gap: 1.5rem;
}
.aesirxsso .column-gap-5 {
  column-gap: 3rem;
}
.aesirxsso .font-monospace {
  font-family: var(--aesirxsso-font-monospace);
}
.aesirxsso .fs-1 {
  font-size: calc(1.375rem + 1.5vw);
}
.aesirxsso .fs-2 {
  font-size: calc(1.325rem + 0.9vw);
}
.aesirxsso .fs-3 {
  font-size: calc(1.3rem + 0.6vw);
}
.aesirxsso .fs-4 {
  font-size: calc(1.275rem + 0.3vw);
}
.aesirxsso .fs-5 {
  font-size: 1.25rem;
}
.aesirxsso .fs-6 {
  font-size: 1rem;
}
.aesirxsso .fst-italic {
  font-style: italic;
}
.aesirxsso .fst-normal {
  font-style: normal;
}
.aesirxsso .fw-lighter {
  font-weight: lighter;
}
.aesirxsso .fw-light {
  font-weight: 300;
}
.aesirxsso .fw-normal {
  font-weight: 400;
}
.aesirxsso .fw-medium {
  font-weight: 500;
}
.aesirxsso .fw-semibold {
  font-weight: 600;
}
.aesirxsso .fw-bold {
  font-weight: 700;
}
.aesirxsso .fw-bolder {
  font-weight: bolder;
}
.aesirxsso .lh-1 {
  line-height: 1;
}
.aesirxsso .lh-sm {
  line-height: 1.25;
}
.aesirxsso .lh-base {
  line-height: 1.5;
}
.aesirxsso .lh-lg {
  line-height: 2;
}
.aesirxsso .text-start {
  text-align: left;
}
.aesirxsso .text-end {
  text-align: right;
}
.aesirxsso .text-center {
  text-align: center;
}
.aesirxsso .text-decoration-none {
  text-decoration: none;
}
.aesirxsso .text-decoration-underline {
  text-decoration: underline;
}
.aesirxsso .text-decoration-line-through {
  text-decoration: line-through;
}
.aesirxsso .text-lowercase {
  text-transform: lowercase;
}
.aesirxsso .text-uppercase {
  text-transform: uppercase;
}
.aesirxsso .text-capitalize {
  text-transform: capitalize;
}
.aesirxsso .text-wrap {
  white-space: normal;
}
.aesirxsso .text-nowrap {
  white-space: nowrap;
}
.aesirxsso .text-break {
  word-wrap: break-word;
  word-break: break-word;
}
.aesirxsso .text-primary {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-primary-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-secondary {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-secondary-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-success {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-success-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-info {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-info-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-warning {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-warning-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-danger {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-danger-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-light {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-light-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-dark {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-dark-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-black {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-black-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-white {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-white-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-body {
  --aesirxsso-text-opacity: 1;
  color: rgba(var(--aesirxsso-body-color-rgb), var(--aesirxsso-text-opacity));
}
.aesirxsso .text-muted {
  --aesirxsso-text-opacity: 1;
  color: var(--aesirxsso-secondary-color);
}
.aesirxsso .text-black-50 {
  --aesirxsso-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5);
}
.aesirxsso .text-white-50 {
  --aesirxsso-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5);
}
.aesirxsso .text-body-secondary {
  --aesirxsso-text-opacity: 1;
  color: var(--aesirxsso-secondary-color);
}
.aesirxsso .text-body-tertiary {
  --aesirxsso-text-opacity: 1;
  color: var(--aesirxsso-tertiary-color);
}
.aesirxsso .text-body-emphasis {
  --aesirxsso-text-opacity: 1;
  color: var(--aesirxsso-emphasis-color);
}
.aesirxsso .text-reset {
  --aesirxsso-text-opacity: 1;
  color: inherit;
}
.aesirxsso .text-opacity-25 {
  --aesirxsso-text-opacity: 0.25;
}
.aesirxsso .text-opacity-50 {
  --aesirxsso-text-opacity: 0.5;
}
.aesirxsso .text-opacity-75 {
  --aesirxsso-text-opacity: 0.75;
}
.aesirxsso .text-opacity-100 {
  --aesirxsso-text-opacity: 1;
}
.aesirxsso .text-primary-emphasis {
  color: var(--aesirxsso-primary-text-emphasis);
}
.aesirxsso .text-secondary-emphasis {
  color: var(--aesirxsso-secondary-text-emphasis);
}
.aesirxsso .text-success-emphasis {
  color: var(--aesirxsso-success-text-emphasis);
}
.aesirxsso .text-info-emphasis {
  color: var(--aesirxsso-info-text-emphasis);
}
.aesirxsso .text-warning-emphasis {
  color: var(--aesirxsso-warning-text-emphasis);
}
.aesirxsso .text-danger-emphasis {
  color: var(--aesirxsso-danger-text-emphasis);
}
.aesirxsso .text-light-emphasis {
  color: var(--aesirxsso-light-text-emphasis);
}
.aesirxsso .text-dark-emphasis {
  color: var(--aesirxsso-dark-text-emphasis);
}
.aesirxsso .link-opacity-10 {
  --aesirxsso-link-opacity: 0.1;
}
.aesirxsso .link-opacity-10-hover:hover {
  --aesirxsso-link-opacity: 0.1;
}
.aesirxsso .link-opacity-25 {
  --aesirxsso-link-opacity: 0.25;
}
.aesirxsso .link-opacity-25-hover:hover {
  --aesirxsso-link-opacity: 0.25;
}
.aesirxsso .link-opacity-50 {
  --aesirxsso-link-opacity: 0.5;
}
.aesirxsso .link-opacity-50-hover:hover {
  --aesirxsso-link-opacity: 0.5;
}
.aesirxsso .link-opacity-75 {
  --aesirxsso-link-opacity: 0.75;
}
.aesirxsso .link-opacity-75-hover:hover {
  --aesirxsso-link-opacity: 0.75;
}
.aesirxsso .link-opacity-100 {
  --aesirxsso-link-opacity: 1;
}
.aesirxsso .link-opacity-100-hover:hover {
  --aesirxsso-link-opacity: 1;
}
.aesirxsso .link-offset-1 {
  text-underline-offset: 0.125em;
}
.aesirxsso .link-offset-1-hover:hover {
  text-underline-offset: 0.125em;
}
.aesirxsso .link-offset-2 {
  text-underline-offset: 0.25em;
}
.aesirxsso .link-offset-2-hover:hover {
  text-underline-offset: 0.25em;
}
.aesirxsso .link-offset-3 {
  text-underline-offset: 0.375em;
}
.aesirxsso .link-offset-3-hover:hover {
  text-underline-offset: 0.375em;
}
.aesirxsso .link-underline-primary {
  --aesirxsso-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxsso-primary-rgb), var(--aesirxsso-link-underline-opacity));
}
.aesirxsso .link-underline-secondary {
  --aesirxsso-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxsso-secondary-rgb), var(--aesirxsso-link-underline-opacity));
}
.aesirxsso .link-underline-success {
  --aesirxsso-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxsso-success-rgb), var(--aesirxsso-link-underline-opacity));
}
.aesirxsso .link-underline-info {
  --aesirxsso-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxsso-info-rgb), var(--aesirxsso-link-underline-opacity));
}
.aesirxsso .link-underline-warning {
  --aesirxsso-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxsso-warning-rgb), var(--aesirxsso-link-underline-opacity));
}
.aesirxsso .link-underline-danger {
  --aesirxsso-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxsso-danger-rgb), var(--aesirxsso-link-underline-opacity));
}
.aesirxsso .link-underline-light {
  --aesirxsso-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxsso-light-rgb), var(--aesirxsso-link-underline-opacity));
}
.aesirxsso .link-underline-dark {
  --aesirxsso-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxsso-dark-rgb), var(--aesirxsso-link-underline-opacity));
}
.aesirxsso .link-underline {
  --aesirxsso-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--aesirxsso-link-color-rgb), var(--aesirxsso-link-underline-opacity, 1));
}
.aesirxsso .link-underline-opacity-0 {
  --aesirxsso-link-underline-opacity: 0;
}
.aesirxsso .link-underline-opacity-0-hover:hover {
  --aesirxsso-link-underline-opacity: 0;
}
.aesirxsso .link-underline-opacity-10 {
  --aesirxsso-link-underline-opacity: 0.1;
}
.aesirxsso .link-underline-opacity-10-hover:hover {
  --aesirxsso-link-underline-opacity: 0.1;
}
.aesirxsso .link-underline-opacity-25 {
  --aesirxsso-link-underline-opacity: 0.25;
}
.aesirxsso .link-underline-opacity-25-hover:hover {
  --aesirxsso-link-underline-opacity: 0.25;
}
.aesirxsso .link-underline-opacity-50 {
  --aesirxsso-link-underline-opacity: 0.5;
}
.aesirxsso .link-underline-opacity-50-hover:hover {
  --aesirxsso-link-underline-opacity: 0.5;
}
.aesirxsso .link-underline-opacity-75 {
  --aesirxsso-link-underline-opacity: 0.75;
}
.aesirxsso .link-underline-opacity-75-hover:hover {
  --aesirxsso-link-underline-opacity: 0.75;
}
.aesirxsso .link-underline-opacity-100 {
  --aesirxsso-link-underline-opacity: 1;
}
.aesirxsso .link-underline-opacity-100-hover:hover {
  --aesirxsso-link-underline-opacity: 1;
}
.aesirxsso .bg-primary {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-primary-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-secondary {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-secondary-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-success {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-success-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-info {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-info-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-warning {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-warning-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-danger {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-danger-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-light {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-light-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-dark {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-dark-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-black {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-black-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-white {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-white-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-body {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-body-bg-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-transparent {
  --aesirxsso-bg-opacity: 1;
  background-color: transparent;
}
.aesirxsso .bg-body-secondary {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-secondary-bg-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-body-tertiary {
  --aesirxsso-bg-opacity: 1;
  background-color: rgba(var(--aesirxsso-tertiary-bg-rgb), var(--aesirxsso-bg-opacity));
}
.aesirxsso .bg-opacity-10 {
  --aesirxsso-bg-opacity: 0.1;
}
.aesirxsso .bg-opacity-25 {
  --aesirxsso-bg-opacity: 0.25;
}
.aesirxsso .bg-opacity-50 {
  --aesirxsso-bg-opacity: 0.5;
}
.aesirxsso .bg-opacity-75 {
  --aesirxsso-bg-opacity: 0.75;
}
.aesirxsso .bg-opacity-100 {
  --aesirxsso-bg-opacity: 1;
}
.aesirxsso .bg-primary-subtle {
  background-color: var(--aesirxsso-primary-bg-subtle);
}
.aesirxsso .bg-secondary-subtle {
  background-color: var(--aesirxsso-secondary-bg-subtle);
}
.aesirxsso .bg-success-subtle {
  background-color: var(--aesirxsso-success-bg-subtle);
}
.aesirxsso .bg-info-subtle {
  background-color: var(--aesirxsso-info-bg-subtle);
}
.aesirxsso .bg-warning-subtle {
  background-color: var(--aesirxsso-warning-bg-subtle);
}
.aesirxsso .bg-danger-subtle {
  background-color: var(--aesirxsso-danger-bg-subtle);
}
.aesirxsso .bg-light-subtle {
  background-color: var(--aesirxsso-light-bg-subtle);
}
.aesirxsso .bg-dark-subtle {
  background-color: var(--aesirxsso-dark-bg-subtle);
}
.aesirxsso .bg-gradient {
  background-image: var(--aesirxsso-gradient);
}
.aesirxsso .user-select-all {
  user-select: all;
}
.aesirxsso .user-select-auto {
  user-select: auto;
}
.aesirxsso .user-select-none {
  user-select: none;
}
.aesirxsso .pe-none {
  pointer-events: none;
}
.aesirxsso .pe-auto {
  pointer-events: auto;
}
.aesirxsso .rounded {
  border-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .rounded-0 {
  border-radius: 0;
}
.aesirxsso .rounded-1 {
  border-radius: var(--aesirxsso-border-radius-sm);
}
.aesirxsso .rounded-2 {
  border-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .rounded-3 {
  border-radius: var(--aesirxsso-border-radius-lg);
}
.aesirxsso .rounded-4 {
  border-radius: var(--aesirxsso-border-radius-xl);
}
.aesirxsso .rounded-5 {
  border-radius: var(--aesirxsso-border-radius-xxl);
}
.aesirxsso .rounded-circle {
  border-radius: 50%;
}
.aesirxsso .rounded-pill {
  border-radius: var(--aesirxsso-border-radius-pill);
}
.aesirxsso .rounded-top {
  border-top-left-radius: var(--aesirxsso-border-radius);
  border-top-right-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .rounded-top-0 {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.aesirxsso .rounded-top-1 {
  border-top-left-radius: var(--aesirxsso-border-radius-sm);
  border-top-right-radius: var(--aesirxsso-border-radius-sm);
}
.aesirxsso .rounded-top-2 {
  border-top-left-radius: var(--aesirxsso-border-radius);
  border-top-right-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .rounded-top-3 {
  border-top-left-radius: var(--aesirxsso-border-radius-lg);
  border-top-right-radius: var(--aesirxsso-border-radius-lg);
}
.aesirxsso .rounded-top-4 {
  border-top-left-radius: var(--aesirxsso-border-radius-xl);
  border-top-right-radius: var(--aesirxsso-border-radius-xl);
}
.aesirxsso .rounded-top-5 {
  border-top-left-radius: var(--aesirxsso-border-radius-xxl);
  border-top-right-radius: var(--aesirxsso-border-radius-xxl);
}
.aesirxsso .rounded-top-circle {
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
}
.aesirxsso .rounded-top-pill {
  border-top-left-radius: var(--aesirxsso-border-radius-pill);
  border-top-right-radius: var(--aesirxsso-border-radius-pill);
}
.aesirxsso .rounded-end {
  border-top-right-radius: var(--aesirxsso-border-radius);
  border-bottom-right-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .rounded-end-0 {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.aesirxsso .rounded-end-1 {
  border-top-right-radius: var(--aesirxsso-border-radius-sm);
  border-bottom-right-radius: var(--aesirxsso-border-radius-sm);
}
.aesirxsso .rounded-end-2 {
  border-top-right-radius: var(--aesirxsso-border-radius);
  border-bottom-right-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .rounded-end-3 {
  border-top-right-radius: var(--aesirxsso-border-radius-lg);
  border-bottom-right-radius: var(--aesirxsso-border-radius-lg);
}
.aesirxsso .rounded-end-4 {
  border-top-right-radius: var(--aesirxsso-border-radius-xl);
  border-bottom-right-radius: var(--aesirxsso-border-radius-xl);
}
.aesirxsso .rounded-end-5 {
  border-top-right-radius: var(--aesirxsso-border-radius-xxl);
  border-bottom-right-radius: var(--aesirxsso-border-radius-xxl);
}
.aesirxsso .rounded-end-circle {
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
}
.aesirxsso .rounded-end-pill {
  border-top-right-radius: var(--aesirxsso-border-radius-pill);
  border-bottom-right-radius: var(--aesirxsso-border-radius-pill);
}
.aesirxsso .rounded-bottom {
  border-bottom-right-radius: var(--aesirxsso-border-radius);
  border-bottom-left-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .rounded-bottom-0 {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.aesirxsso .rounded-bottom-1 {
  border-bottom-right-radius: var(--aesirxsso-border-radius-sm);
  border-bottom-left-radius: var(--aesirxsso-border-radius-sm);
}
.aesirxsso .rounded-bottom-2 {
  border-bottom-right-radius: var(--aesirxsso-border-radius);
  border-bottom-left-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .rounded-bottom-3 {
  border-bottom-right-radius: var(--aesirxsso-border-radius-lg);
  border-bottom-left-radius: var(--aesirxsso-border-radius-lg);
}
.aesirxsso .rounded-bottom-4 {
  border-bottom-right-radius: var(--aesirxsso-border-radius-xl);
  border-bottom-left-radius: var(--aesirxsso-border-radius-xl);
}
.aesirxsso .rounded-bottom-5 {
  border-bottom-right-radius: var(--aesirxsso-border-radius-xxl);
  border-bottom-left-radius: var(--aesirxsso-border-radius-xxl);
}
.aesirxsso .rounded-bottom-circle {
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
}
.aesirxsso .rounded-bottom-pill {
  border-bottom-right-radius: var(--aesirxsso-border-radius-pill);
  border-bottom-left-radius: var(--aesirxsso-border-radius-pill);
}
.aesirxsso .rounded-start {
  border-bottom-left-radius: var(--aesirxsso-border-radius);
  border-top-left-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .rounded-start-0 {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.aesirxsso .rounded-start-1 {
  border-bottom-left-radius: var(--aesirxsso-border-radius-sm);
  border-top-left-radius: var(--aesirxsso-border-radius-sm);
}
.aesirxsso .rounded-start-2 {
  border-bottom-left-radius: var(--aesirxsso-border-radius);
  border-top-left-radius: var(--aesirxsso-border-radius);
}
.aesirxsso .rounded-start-3 {
  border-bottom-left-radius: var(--aesirxsso-border-radius-lg);
  border-top-left-radius: var(--aesirxsso-border-radius-lg);
}
.aesirxsso .rounded-start-4 {
  border-bottom-left-radius: var(--aesirxsso-border-radius-xl);
  border-top-left-radius: var(--aesirxsso-border-radius-xl);
}
.aesirxsso .rounded-start-5 {
  border-bottom-left-radius: var(--aesirxsso-border-radius-xxl);
  border-top-left-radius: var(--aesirxsso-border-radius-xxl);
}
.aesirxsso .rounded-start-circle {
  border-bottom-left-radius: 50%;
  border-top-left-radius: 50%;
}
.aesirxsso .rounded-start-pill {
  border-bottom-left-radius: var(--aesirxsso-border-radius-pill);
  border-top-left-radius: var(--aesirxsso-border-radius-pill);
}
.aesirxsso .visible {
  visibility: visible;
}
.aesirxsso .invisible {
  visibility: hidden;
}
.aesirxsso .z-n1 {
  z-index: -1;
}
.aesirxsso .z-0 {
  z-index: 0;
}
.aesirxsso .z-1 {
  z-index: 1;
}
.aesirxsso .z-2 {
  z-index: 2;
}
.aesirxsso .z-3 {
  z-index: 3;
}
@media (min-width: 576px) {
  .aesirxsso .float-sm-start {
    float: left;
  }
  .aesirxsso .float-sm-end {
    float: right;
  }
  .aesirxsso .float-sm-none {
    float: none;
  }
  .aesirxsso .object-fit-sm-contain {
    object-fit: contain;
  }
  .aesirxsso .object-fit-sm-cover {
    object-fit: cover;
  }
  .aesirxsso .object-fit-sm-fill {
    object-fit: fill;
  }
  .aesirxsso .object-fit-sm-scale {
    object-fit: scale-down;
  }
  .aesirxsso .object-fit-sm-none {
    object-fit: none;
  }
  .aesirxsso .d-sm-inline {
    display: inline;
  }
  .aesirxsso .d-sm-inline-block {
    display: inline-block;
  }
  .aesirxsso .d-sm-block {
    display: block;
  }
  .aesirxsso .d-sm-grid {
    display: grid;
  }
  .aesirxsso .d-sm-inline-grid {
    display: inline-grid;
  }
  .aesirxsso .d-sm-table {
    display: table;
  }
  .aesirxsso .d-sm-table-row {
    display: table-row;
  }
  .aesirxsso .d-sm-table-cell {
    display: table-cell;
  }
  .aesirxsso .d-sm-flex {
    display: flex;
  }
  .aesirxsso .d-sm-inline-flex {
    display: inline-flex;
  }
  .aesirxsso .d-sm-none {
    display: none;
  }
  .aesirxsso .flex-sm-fill {
    flex: 1 1 auto;
  }
  .aesirxsso .flex-sm-row {
    flex-direction: row;
  }
  .aesirxsso .flex-sm-column {
    flex-direction: column;
  }
  .aesirxsso .flex-sm-row-reverse {
    flex-direction: row-reverse;
  }
  .aesirxsso .flex-sm-column-reverse {
    flex-direction: column-reverse;
  }
  .aesirxsso .flex-sm-grow-0 {
    flex-grow: 0;
  }
  .aesirxsso .flex-sm-grow-1 {
    flex-grow: 1;
  }
  .aesirxsso .flex-sm-shrink-0 {
    flex-shrink: 0;
  }
  .aesirxsso .flex-sm-shrink-1 {
    flex-shrink: 1;
  }
  .aesirxsso .flex-sm-wrap {
    flex-wrap: wrap;
  }
  .aesirxsso .flex-sm-nowrap {
    flex-wrap: nowrap;
  }
  .aesirxsso .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .aesirxsso .justify-content-sm-start {
    justify-content: flex-start;
  }
  .aesirxsso .justify-content-sm-end {
    justify-content: flex-end;
  }
  .aesirxsso .justify-content-sm-center {
    justify-content: center;
  }
  .aesirxsso .justify-content-sm-between {
    justify-content: space-between;
  }
  .aesirxsso .justify-content-sm-around {
    justify-content: space-around;
  }
  .aesirxsso .justify-content-sm-evenly {
    justify-content: space-evenly;
  }
  .aesirxsso .align-items-sm-start {
    align-items: flex-start;
  }
  .aesirxsso .align-items-sm-end {
    align-items: flex-end;
  }
  .aesirxsso .align-items-sm-center {
    align-items: center;
  }
  .aesirxsso .align-items-sm-baseline {
    align-items: baseline;
  }
  .aesirxsso .align-items-sm-stretch {
    align-items: stretch;
  }
  .aesirxsso .align-content-sm-start {
    align-content: flex-start;
  }
  .aesirxsso .align-content-sm-end {
    align-content: flex-end;
  }
  .aesirxsso .align-content-sm-center {
    align-content: center;
  }
  .aesirxsso .align-content-sm-between {
    align-content: space-between;
  }
  .aesirxsso .align-content-sm-around {
    align-content: space-around;
  }
  .aesirxsso .align-content-sm-stretch {
    align-content: stretch;
  }
  .aesirxsso .align-self-sm-auto {
    align-self: auto;
  }
  .aesirxsso .align-self-sm-start {
    align-self: flex-start;
  }
  .aesirxsso .align-self-sm-end {
    align-self: flex-end;
  }
  .aesirxsso .align-self-sm-center {
    align-self: center;
  }
  .aesirxsso .align-self-sm-baseline {
    align-self: baseline;
  }
  .aesirxsso .align-self-sm-stretch {
    align-self: stretch;
  }
  .aesirxsso .order-sm-first {
    order: -1;
  }
  .aesirxsso .order-sm-0 {
    order: 0;
  }
  .aesirxsso .order-sm-1 {
    order: 1;
  }
  .aesirxsso .order-sm-2 {
    order: 2;
  }
  .aesirxsso .order-sm-3 {
    order: 3;
  }
  .aesirxsso .order-sm-4 {
    order: 4;
  }
  .aesirxsso .order-sm-5 {
    order: 5;
  }
  .aesirxsso .order-sm-last {
    order: 6;
  }
  .aesirxsso .m-sm-0 {
    margin: 0;
  }
  .aesirxsso .m-sm-1 {
    margin: 0.25rem;
  }
  .aesirxsso .m-sm-2 {
    margin: 0.5rem;
  }
  .aesirxsso .m-sm-3 {
    margin: 1rem;
  }
  .aesirxsso .m-sm-4 {
    margin: 1.5rem;
  }
  .aesirxsso .m-sm-5 {
    margin: 3rem;
  }
  .aesirxsso .m-sm-auto {
    margin: auto;
  }
  .aesirxsso .mx-sm-0 {
    margin-right: 0;
    margin-left: 0;
  }
  .aesirxsso .mx-sm-1 {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
  .aesirxsso .mx-sm-2 {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
  .aesirxsso .mx-sm-3 {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .aesirxsso .mx-sm-4 {
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
  .aesirxsso .mx-sm-5 {
    margin-right: 3rem;
    margin-left: 3rem;
  }
  .aesirxsso .mx-sm-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxsso .my-sm-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .aesirxsso .my-sm-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .aesirxsso .my-sm-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .aesirxsso .my-sm-3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .aesirxsso .my-sm-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .aesirxsso .my-sm-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .aesirxsso .my-sm-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .aesirxsso .mt-sm-0 {
    margin-top: 0;
  }
  .aesirxsso .mt-sm-1 {
    margin-top: 0.25rem;
  }
  .aesirxsso .mt-sm-2 {
    margin-top: 0.5rem;
  }
  .aesirxsso .mt-sm-3 {
    margin-top: 1rem;
  }
  .aesirxsso .mt-sm-4 {
    margin-top: 1.5rem;
  }
  .aesirxsso .mt-sm-5 {
    margin-top: 3rem;
  }
  .aesirxsso .mt-sm-auto {
    margin-top: auto;
  }
  .aesirxsso .me-sm-0 {
    margin-right: 0;
  }
  .aesirxsso .me-sm-1 {
    margin-right: 0.25rem;
  }
  .aesirxsso .me-sm-2 {
    margin-right: 0.5rem;
  }
  .aesirxsso .me-sm-3 {
    margin-right: 1rem;
  }
  .aesirxsso .me-sm-4 {
    margin-right: 1.5rem;
  }
  .aesirxsso .me-sm-5 {
    margin-right: 3rem;
  }
  .aesirxsso .me-sm-auto {
    margin-right: auto;
  }
  .aesirxsso .mb-sm-0 {
    margin-bottom: 0;
  }
  .aesirxsso .mb-sm-1 {
    margin-bottom: 0.25rem;
  }
  .aesirxsso .mb-sm-2 {
    margin-bottom: 0.5rem;
  }
  .aesirxsso .mb-sm-3 {
    margin-bottom: 1rem;
  }
  .aesirxsso .mb-sm-4 {
    margin-bottom: 1.5rem;
  }
  .aesirxsso .mb-sm-5 {
    margin-bottom: 3rem;
  }
  .aesirxsso .mb-sm-auto {
    margin-bottom: auto;
  }
  .aesirxsso .ms-sm-0 {
    margin-left: 0;
  }
  .aesirxsso .ms-sm-1 {
    margin-left: 0.25rem;
  }
  .aesirxsso .ms-sm-2 {
    margin-left: 0.5rem;
  }
  .aesirxsso .ms-sm-3 {
    margin-left: 1rem;
  }
  .aesirxsso .ms-sm-4 {
    margin-left: 1.5rem;
  }
  .aesirxsso .ms-sm-5 {
    margin-left: 3rem;
  }
  .aesirxsso .ms-sm-auto {
    margin-left: auto;
  }
  .aesirxsso .m-sm-n1 {
    margin: -0.25rem;
  }
  .aesirxsso .m-sm-n2 {
    margin: -0.5rem;
  }
  .aesirxsso .m-sm-n3 {
    margin: -1rem;
  }
  .aesirxsso .m-sm-n4 {
    margin: -1.5rem;
  }
  .aesirxsso .m-sm-n5 {
    margin: -3rem;
  }
  .aesirxsso .mx-sm-n1 {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
  .aesirxsso .mx-sm-n2 {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .aesirxsso .mx-sm-n3 {
    margin-right: -1rem;
    margin-left: -1rem;
  }
  .aesirxsso .mx-sm-n4 {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }
  .aesirxsso .mx-sm-n5 {
    margin-right: -3rem;
    margin-left: -3rem;
  }
  .aesirxsso .my-sm-n1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .aesirxsso .my-sm-n2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .aesirxsso .my-sm-n3 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .aesirxsso .my-sm-n4 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .aesirxsso .my-sm-n5 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .aesirxsso .mt-sm-n1 {
    margin-top: -0.25rem;
  }
  .aesirxsso .mt-sm-n2 {
    margin-top: -0.5rem;
  }
  .aesirxsso .mt-sm-n3 {
    margin-top: -1rem;
  }
  .aesirxsso .mt-sm-n4 {
    margin-top: -1.5rem;
  }
  .aesirxsso .mt-sm-n5 {
    margin-top: -3rem;
  }
  .aesirxsso .me-sm-n1 {
    margin-right: -0.25rem;
  }
  .aesirxsso .me-sm-n2 {
    margin-right: -0.5rem;
  }
  .aesirxsso .me-sm-n3 {
    margin-right: -1rem;
  }
  .aesirxsso .me-sm-n4 {
    margin-right: -1.5rem;
  }
  .aesirxsso .me-sm-n5 {
    margin-right: -3rem;
  }
  .aesirxsso .mb-sm-n1 {
    margin-bottom: -0.25rem;
  }
  .aesirxsso .mb-sm-n2 {
    margin-bottom: -0.5rem;
  }
  .aesirxsso .mb-sm-n3 {
    margin-bottom: -1rem;
  }
  .aesirxsso .mb-sm-n4 {
    margin-bottom: -1.5rem;
  }
  .aesirxsso .mb-sm-n5 {
    margin-bottom: -3rem;
  }
  .aesirxsso .ms-sm-n1 {
    margin-left: -0.25rem;
  }
  .aesirxsso .ms-sm-n2 {
    margin-left: -0.5rem;
  }
  .aesirxsso .ms-sm-n3 {
    margin-left: -1rem;
  }
  .aesirxsso .ms-sm-n4 {
    margin-left: -1.5rem;
  }
  .aesirxsso .ms-sm-n5 {
    margin-left: -3rem;
  }
  .aesirxsso .p-sm-0 {
    padding: 0;
  }
  .aesirxsso .p-sm-1 {
    padding: 0.25rem;
  }
  .aesirxsso .p-sm-2 {
    padding: 0.5rem;
  }
  .aesirxsso .p-sm-3 {
    padding: 1rem;
  }
  .aesirxsso .p-sm-4 {
    padding: 1.5rem;
  }
  .aesirxsso .p-sm-5 {
    padding: 3rem;
  }
  .aesirxsso .px-sm-0 {
    padding-right: 0;
    padding-left: 0;
  }
  .aesirxsso .px-sm-1 {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .aesirxsso .px-sm-2 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .aesirxsso .px-sm-3 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .aesirxsso .px-sm-4 {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
  .aesirxsso .px-sm-5 {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .aesirxsso .py-sm-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .aesirxsso .py-sm-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .aesirxsso .py-sm-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .aesirxsso .py-sm-3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .aesirxsso .py-sm-4 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .aesirxsso .py-sm-5 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .aesirxsso .pt-sm-0 {
    padding-top: 0;
  }
  .aesirxsso .pt-sm-1 {
    padding-top: 0.25rem;
  }
  .aesirxsso .pt-sm-2 {
    padding-top: 0.5rem;
  }
  .aesirxsso .pt-sm-3 {
    padding-top: 1rem;
  }
  .aesirxsso .pt-sm-4 {
    padding-top: 1.5rem;
  }
  .aesirxsso .pt-sm-5 {
    padding-top: 3rem;
  }
  .aesirxsso .pe-sm-0 {
    padding-right: 0;
  }
  .aesirxsso .pe-sm-1 {
    padding-right: 0.25rem;
  }
  .aesirxsso .pe-sm-2 {
    padding-right: 0.5rem;
  }
  .aesirxsso .pe-sm-3 {
    padding-right: 1rem;
  }
  .aesirxsso .pe-sm-4 {
    padding-right: 1.5rem;
  }
  .aesirxsso .pe-sm-5 {
    padding-right: 3rem;
  }
  .aesirxsso .pb-sm-0 {
    padding-bottom: 0;
  }
  .aesirxsso .pb-sm-1 {
    padding-bottom: 0.25rem;
  }
  .aesirxsso .pb-sm-2 {
    padding-bottom: 0.5rem;
  }
  .aesirxsso .pb-sm-3 {
    padding-bottom: 1rem;
  }
  .aesirxsso .pb-sm-4 {
    padding-bottom: 1.5rem;
  }
  .aesirxsso .pb-sm-5 {
    padding-bottom: 3rem;
  }
  .aesirxsso .ps-sm-0 {
    padding-left: 0;
  }
  .aesirxsso .ps-sm-1 {
    padding-left: 0.25rem;
  }
  .aesirxsso .ps-sm-2 {
    padding-left: 0.5rem;
  }
  .aesirxsso .ps-sm-3 {
    padding-left: 1rem;
  }
  .aesirxsso .ps-sm-4 {
    padding-left: 1.5rem;
  }
  .aesirxsso .ps-sm-5 {
    padding-left: 3rem;
  }
  .aesirxsso .gap-sm-0 {
    gap: 0;
  }
  .aesirxsso .gap-sm-1 {
    gap: 0.25rem;
  }
  .aesirxsso .gap-sm-2 {
    gap: 0.5rem;
  }
  .aesirxsso .gap-sm-3 {
    gap: 1rem;
  }
  .aesirxsso .gap-sm-4 {
    gap: 1.5rem;
  }
  .aesirxsso .gap-sm-5 {
    gap: 3rem;
  }
  .aesirxsso .row-gap-sm-0 {
    row-gap: 0;
  }
  .aesirxsso .row-gap-sm-1 {
    row-gap: 0.25rem;
  }
  .aesirxsso .row-gap-sm-2 {
    row-gap: 0.5rem;
  }
  .aesirxsso .row-gap-sm-3 {
    row-gap: 1rem;
  }
  .aesirxsso .row-gap-sm-4 {
    row-gap: 1.5rem;
  }
  .aesirxsso .row-gap-sm-5 {
    row-gap: 3rem;
  }
  .aesirxsso .column-gap-sm-0 {
    column-gap: 0;
  }
  .aesirxsso .column-gap-sm-1 {
    column-gap: 0.25rem;
  }
  .aesirxsso .column-gap-sm-2 {
    column-gap: 0.5rem;
  }
  .aesirxsso .column-gap-sm-3 {
    column-gap: 1rem;
  }
  .aesirxsso .column-gap-sm-4 {
    column-gap: 1.5rem;
  }
  .aesirxsso .column-gap-sm-5 {
    column-gap: 3rem;
  }
  .aesirxsso .text-sm-start {
    text-align: left;
  }
  .aesirxsso .text-sm-end {
    text-align: right;
  }
  .aesirxsso .text-sm-center {
    text-align: center;
  }
}
@media (min-width: 768px) {
  .aesirxsso .float-md-start {
    float: left;
  }
  .aesirxsso .float-md-end {
    float: right;
  }
  .aesirxsso .float-md-none {
    float: none;
  }
  .aesirxsso .object-fit-md-contain {
    object-fit: contain;
  }
  .aesirxsso .object-fit-md-cover {
    object-fit: cover;
  }
  .aesirxsso .object-fit-md-fill {
    object-fit: fill;
  }
  .aesirxsso .object-fit-md-scale {
    object-fit: scale-down;
  }
  .aesirxsso .object-fit-md-none {
    object-fit: none;
  }
  .aesirxsso .d-md-inline {
    display: inline;
  }
  .aesirxsso .d-md-inline-block {
    display: inline-block;
  }
  .aesirxsso .d-md-block {
    display: block;
  }
  .aesirxsso .d-md-grid {
    display: grid;
  }
  .aesirxsso .d-md-inline-grid {
    display: inline-grid;
  }
  .aesirxsso .d-md-table {
    display: table;
  }
  .aesirxsso .d-md-table-row {
    display: table-row;
  }
  .aesirxsso .d-md-table-cell {
    display: table-cell;
  }
  .aesirxsso .d-md-flex {
    display: flex;
  }
  .aesirxsso .d-md-inline-flex {
    display: inline-flex;
  }
  .aesirxsso .d-md-none {
    display: none;
  }
  .aesirxsso .flex-md-fill {
    flex: 1 1 auto;
  }
  .aesirxsso .flex-md-row {
    flex-direction: row;
  }
  .aesirxsso .flex-md-column {
    flex-direction: column;
  }
  .aesirxsso .flex-md-row-reverse {
    flex-direction: row-reverse;
  }
  .aesirxsso .flex-md-column-reverse {
    flex-direction: column-reverse;
  }
  .aesirxsso .flex-md-grow-0 {
    flex-grow: 0;
  }
  .aesirxsso .flex-md-grow-1 {
    flex-grow: 1;
  }
  .aesirxsso .flex-md-shrink-0 {
    flex-shrink: 0;
  }
  .aesirxsso .flex-md-shrink-1 {
    flex-shrink: 1;
  }
  .aesirxsso .flex-md-wrap {
    flex-wrap: wrap;
  }
  .aesirxsso .flex-md-nowrap {
    flex-wrap: nowrap;
  }
  .aesirxsso .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .aesirxsso .justify-content-md-start {
    justify-content: flex-start;
  }
  .aesirxsso .justify-content-md-end {
    justify-content: flex-end;
  }
  .aesirxsso .justify-content-md-center {
    justify-content: center;
  }
  .aesirxsso .justify-content-md-between {
    justify-content: space-between;
  }
  .aesirxsso .justify-content-md-around {
    justify-content: space-around;
  }
  .aesirxsso .justify-content-md-evenly {
    justify-content: space-evenly;
  }
  .aesirxsso .align-items-md-start {
    align-items: flex-start;
  }
  .aesirxsso .align-items-md-end {
    align-items: flex-end;
  }
  .aesirxsso .align-items-md-center {
    align-items: center;
  }
  .aesirxsso .align-items-md-baseline {
    align-items: baseline;
  }
  .aesirxsso .align-items-md-stretch {
    align-items: stretch;
  }
  .aesirxsso .align-content-md-start {
    align-content: flex-start;
  }
  .aesirxsso .align-content-md-end {
    align-content: flex-end;
  }
  .aesirxsso .align-content-md-center {
    align-content: center;
  }
  .aesirxsso .align-content-md-between {
    align-content: space-between;
  }
  .aesirxsso .align-content-md-around {
    align-content: space-around;
  }
  .aesirxsso .align-content-md-stretch {
    align-content: stretch;
  }
  .aesirxsso .align-self-md-auto {
    align-self: auto;
  }
  .aesirxsso .align-self-md-start {
    align-self: flex-start;
  }
  .aesirxsso .align-self-md-end {
    align-self: flex-end;
  }
  .aesirxsso .align-self-md-center {
    align-self: center;
  }
  .aesirxsso .align-self-md-baseline {
    align-self: baseline;
  }
  .aesirxsso .align-self-md-stretch {
    align-self: stretch;
  }
  .aesirxsso .order-md-first {
    order: -1;
  }
  .aesirxsso .order-md-0 {
    order: 0;
  }
  .aesirxsso .order-md-1 {
    order: 1;
  }
  .aesirxsso .order-md-2 {
    order: 2;
  }
  .aesirxsso .order-md-3 {
    order: 3;
  }
  .aesirxsso .order-md-4 {
    order: 4;
  }
  .aesirxsso .order-md-5 {
    order: 5;
  }
  .aesirxsso .order-md-last {
    order: 6;
  }
  .aesirxsso .m-md-0 {
    margin: 0;
  }
  .aesirxsso .m-md-1 {
    margin: 0.25rem;
  }
  .aesirxsso .m-md-2 {
    margin: 0.5rem;
  }
  .aesirxsso .m-md-3 {
    margin: 1rem;
  }
  .aesirxsso .m-md-4 {
    margin: 1.5rem;
  }
  .aesirxsso .m-md-5 {
    margin: 3rem;
  }
  .aesirxsso .m-md-auto {
    margin: auto;
  }
  .aesirxsso .mx-md-0 {
    margin-right: 0;
    margin-left: 0;
  }
  .aesirxsso .mx-md-1 {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
  .aesirxsso .mx-md-2 {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
  .aesirxsso .mx-md-3 {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .aesirxsso .mx-md-4 {
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
  .aesirxsso .mx-md-5 {
    margin-right: 3rem;
    margin-left: 3rem;
  }
  .aesirxsso .mx-md-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxsso .my-md-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .aesirxsso .my-md-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .aesirxsso .my-md-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .aesirxsso .my-md-3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .aesirxsso .my-md-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .aesirxsso .my-md-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .aesirxsso .my-md-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .aesirxsso .mt-md-0 {
    margin-top: 0;
  }
  .aesirxsso .mt-md-1 {
    margin-top: 0.25rem;
  }
  .aesirxsso .mt-md-2 {
    margin-top: 0.5rem;
  }
  .aesirxsso .mt-md-3 {
    margin-top: 1rem;
  }
  .aesirxsso .mt-md-4 {
    margin-top: 1.5rem;
  }
  .aesirxsso .mt-md-5 {
    margin-top: 3rem;
  }
  .aesirxsso .mt-md-auto {
    margin-top: auto;
  }
  .aesirxsso .me-md-0 {
    margin-right: 0;
  }
  .aesirxsso .me-md-1 {
    margin-right: 0.25rem;
  }
  .aesirxsso .me-md-2 {
    margin-right: 0.5rem;
  }
  .aesirxsso .me-md-3 {
    margin-right: 1rem;
  }
  .aesirxsso .me-md-4 {
    margin-right: 1.5rem;
  }
  .aesirxsso .me-md-5 {
    margin-right: 3rem;
  }
  .aesirxsso .me-md-auto {
    margin-right: auto;
  }
  .aesirxsso .mb-md-0 {
    margin-bottom: 0;
  }
  .aesirxsso .mb-md-1 {
    margin-bottom: 0.25rem;
  }
  .aesirxsso .mb-md-2 {
    margin-bottom: 0.5rem;
  }
  .aesirxsso .mb-md-3 {
    margin-bottom: 1rem;
  }
  .aesirxsso .mb-md-4 {
    margin-bottom: 1.5rem;
  }
  .aesirxsso .mb-md-5 {
    margin-bottom: 3rem;
  }
  .aesirxsso .mb-md-auto {
    margin-bottom: auto;
  }
  .aesirxsso .ms-md-0 {
    margin-left: 0;
  }
  .aesirxsso .ms-md-1 {
    margin-left: 0.25rem;
  }
  .aesirxsso .ms-md-2 {
    margin-left: 0.5rem;
  }
  .aesirxsso .ms-md-3 {
    margin-left: 1rem;
  }
  .aesirxsso .ms-md-4 {
    margin-left: 1.5rem;
  }
  .aesirxsso .ms-md-5 {
    margin-left: 3rem;
  }
  .aesirxsso .ms-md-auto {
    margin-left: auto;
  }
  .aesirxsso .m-md-n1 {
    margin: -0.25rem;
  }
  .aesirxsso .m-md-n2 {
    margin: -0.5rem;
  }
  .aesirxsso .m-md-n3 {
    margin: -1rem;
  }
  .aesirxsso .m-md-n4 {
    margin: -1.5rem;
  }
  .aesirxsso .m-md-n5 {
    margin: -3rem;
  }
  .aesirxsso .mx-md-n1 {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
  .aesirxsso .mx-md-n2 {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .aesirxsso .mx-md-n3 {
    margin-right: -1rem;
    margin-left: -1rem;
  }
  .aesirxsso .mx-md-n4 {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }
  .aesirxsso .mx-md-n5 {
    margin-right: -3rem;
    margin-left: -3rem;
  }
  .aesirxsso .my-md-n1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .aesirxsso .my-md-n2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .aesirxsso .my-md-n3 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .aesirxsso .my-md-n4 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .aesirxsso .my-md-n5 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .aesirxsso .mt-md-n1 {
    margin-top: -0.25rem;
  }
  .aesirxsso .mt-md-n2 {
    margin-top: -0.5rem;
  }
  .aesirxsso .mt-md-n3 {
    margin-top: -1rem;
  }
  .aesirxsso .mt-md-n4 {
    margin-top: -1.5rem;
  }
  .aesirxsso .mt-md-n5 {
    margin-top: -3rem;
  }
  .aesirxsso .me-md-n1 {
    margin-right: -0.25rem;
  }
  .aesirxsso .me-md-n2 {
    margin-right: -0.5rem;
  }
  .aesirxsso .me-md-n3 {
    margin-right: -1rem;
  }
  .aesirxsso .me-md-n4 {
    margin-right: -1.5rem;
  }
  .aesirxsso .me-md-n5 {
    margin-right: -3rem;
  }
  .aesirxsso .mb-md-n1 {
    margin-bottom: -0.25rem;
  }
  .aesirxsso .mb-md-n2 {
    margin-bottom: -0.5rem;
  }
  .aesirxsso .mb-md-n3 {
    margin-bottom: -1rem;
  }
  .aesirxsso .mb-md-n4 {
    margin-bottom: -1.5rem;
  }
  .aesirxsso .mb-md-n5 {
    margin-bottom: -3rem;
  }
  .aesirxsso .ms-md-n1 {
    margin-left: -0.25rem;
  }
  .aesirxsso .ms-md-n2 {
    margin-left: -0.5rem;
  }
  .aesirxsso .ms-md-n3 {
    margin-left: -1rem;
  }
  .aesirxsso .ms-md-n4 {
    margin-left: -1.5rem;
  }
  .aesirxsso .ms-md-n5 {
    margin-left: -3rem;
  }
  .aesirxsso .p-md-0 {
    padding: 0;
  }
  .aesirxsso .p-md-1 {
    padding: 0.25rem;
  }
  .aesirxsso .p-md-2 {
    padding: 0.5rem;
  }
  .aesirxsso .p-md-3 {
    padding: 1rem;
  }
  .aesirxsso .p-md-4 {
    padding: 1.5rem;
  }
  .aesirxsso .p-md-5 {
    padding: 3rem;
  }
  .aesirxsso .px-md-0 {
    padding-right: 0;
    padding-left: 0;
  }
  .aesirxsso .px-md-1 {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .aesirxsso .px-md-2 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .aesirxsso .px-md-3 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .aesirxsso .px-md-4 {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
  .aesirxsso .px-md-5 {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .aesirxsso .py-md-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .aesirxsso .py-md-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .aesirxsso .py-md-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .aesirxsso .py-md-3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .aesirxsso .py-md-4 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .aesirxsso .py-md-5 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .aesirxsso .pt-md-0 {
    padding-top: 0;
  }
  .aesirxsso .pt-md-1 {
    padding-top: 0.25rem;
  }
  .aesirxsso .pt-md-2 {
    padding-top: 0.5rem;
  }
  .aesirxsso .pt-md-3 {
    padding-top: 1rem;
  }
  .aesirxsso .pt-md-4 {
    padding-top: 1.5rem;
  }
  .aesirxsso .pt-md-5 {
    padding-top: 3rem;
  }
  .aesirxsso .pe-md-0 {
    padding-right: 0;
  }
  .aesirxsso .pe-md-1 {
    padding-right: 0.25rem;
  }
  .aesirxsso .pe-md-2 {
    padding-right: 0.5rem;
  }
  .aesirxsso .pe-md-3 {
    padding-right: 1rem;
  }
  .aesirxsso .pe-md-4 {
    padding-right: 1.5rem;
  }
  .aesirxsso .pe-md-5 {
    padding-right: 3rem;
  }
  .aesirxsso .pb-md-0 {
    padding-bottom: 0;
  }
  .aesirxsso .pb-md-1 {
    padding-bottom: 0.25rem;
  }
  .aesirxsso .pb-md-2 {
    padding-bottom: 0.5rem;
  }
  .aesirxsso .pb-md-3 {
    padding-bottom: 1rem;
  }
  .aesirxsso .pb-md-4 {
    padding-bottom: 1.5rem;
  }
  .aesirxsso .pb-md-5 {
    padding-bottom: 3rem;
  }
  .aesirxsso .ps-md-0 {
    padding-left: 0;
  }
  .aesirxsso .ps-md-1 {
    padding-left: 0.25rem;
  }
  .aesirxsso .ps-md-2 {
    padding-left: 0.5rem;
  }
  .aesirxsso .ps-md-3 {
    padding-left: 1rem;
  }
  .aesirxsso .ps-md-4 {
    padding-left: 1.5rem;
  }
  .aesirxsso .ps-md-5 {
    padding-left: 3rem;
  }
  .aesirxsso .gap-md-0 {
    gap: 0;
  }
  .aesirxsso .gap-md-1 {
    gap: 0.25rem;
  }
  .aesirxsso .gap-md-2 {
    gap: 0.5rem;
  }
  .aesirxsso .gap-md-3 {
    gap: 1rem;
  }
  .aesirxsso .gap-md-4 {
    gap: 1.5rem;
  }
  .aesirxsso .gap-md-5 {
    gap: 3rem;
  }
  .aesirxsso .row-gap-md-0 {
    row-gap: 0;
  }
  .aesirxsso .row-gap-md-1 {
    row-gap: 0.25rem;
  }
  .aesirxsso .row-gap-md-2 {
    row-gap: 0.5rem;
  }
  .aesirxsso .row-gap-md-3 {
    row-gap: 1rem;
  }
  .aesirxsso .row-gap-md-4 {
    row-gap: 1.5rem;
  }
  .aesirxsso .row-gap-md-5 {
    row-gap: 3rem;
  }
  .aesirxsso .column-gap-md-0 {
    column-gap: 0;
  }
  .aesirxsso .column-gap-md-1 {
    column-gap: 0.25rem;
  }
  .aesirxsso .column-gap-md-2 {
    column-gap: 0.5rem;
  }
  .aesirxsso .column-gap-md-3 {
    column-gap: 1rem;
  }
  .aesirxsso .column-gap-md-4 {
    column-gap: 1.5rem;
  }
  .aesirxsso .column-gap-md-5 {
    column-gap: 3rem;
  }
  .aesirxsso .text-md-start {
    text-align: left;
  }
  .aesirxsso .text-md-end {
    text-align: right;
  }
  .aesirxsso .text-md-center {
    text-align: center;
  }
}
@media (min-width: 992px) {
  .aesirxsso .float-lg-start {
    float: left;
  }
  .aesirxsso .float-lg-end {
    float: right;
  }
  .aesirxsso .float-lg-none {
    float: none;
  }
  .aesirxsso .object-fit-lg-contain {
    object-fit: contain;
  }
  .aesirxsso .object-fit-lg-cover {
    object-fit: cover;
  }
  .aesirxsso .object-fit-lg-fill {
    object-fit: fill;
  }
  .aesirxsso .object-fit-lg-scale {
    object-fit: scale-down;
  }
  .aesirxsso .object-fit-lg-none {
    object-fit: none;
  }
  .aesirxsso .d-lg-inline {
    display: inline;
  }
  .aesirxsso .d-lg-inline-block {
    display: inline-block;
  }
  .aesirxsso .d-lg-block {
    display: block;
  }
  .aesirxsso .d-lg-grid {
    display: grid;
  }
  .aesirxsso .d-lg-inline-grid {
    display: inline-grid;
  }
  .aesirxsso .d-lg-table {
    display: table;
  }
  .aesirxsso .d-lg-table-row {
    display: table-row;
  }
  .aesirxsso .d-lg-table-cell {
    display: table-cell;
  }
  .aesirxsso .d-lg-flex {
    display: flex;
  }
  .aesirxsso .d-lg-inline-flex {
    display: inline-flex;
  }
  .aesirxsso .d-lg-none {
    display: none;
  }
  .aesirxsso .flex-lg-fill {
    flex: 1 1 auto;
  }
  .aesirxsso .flex-lg-row {
    flex-direction: row;
  }
  .aesirxsso .flex-lg-column {
    flex-direction: column;
  }
  .aesirxsso .flex-lg-row-reverse {
    flex-direction: row-reverse;
  }
  .aesirxsso .flex-lg-column-reverse {
    flex-direction: column-reverse;
  }
  .aesirxsso .flex-lg-grow-0 {
    flex-grow: 0;
  }
  .aesirxsso .flex-lg-grow-1 {
    flex-grow: 1;
  }
  .aesirxsso .flex-lg-shrink-0 {
    flex-shrink: 0;
  }
  .aesirxsso .flex-lg-shrink-1 {
    flex-shrink: 1;
  }
  .aesirxsso .flex-lg-wrap {
    flex-wrap: wrap;
  }
  .aesirxsso .flex-lg-nowrap {
    flex-wrap: nowrap;
  }
  .aesirxsso .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .aesirxsso .justify-content-lg-start {
    justify-content: flex-start;
  }
  .aesirxsso .justify-content-lg-end {
    justify-content: flex-end;
  }
  .aesirxsso .justify-content-lg-center {
    justify-content: center;
  }
  .aesirxsso .justify-content-lg-between {
    justify-content: space-between;
  }
  .aesirxsso .justify-content-lg-around {
    justify-content: space-around;
  }
  .aesirxsso .justify-content-lg-evenly {
    justify-content: space-evenly;
  }
  .aesirxsso .align-items-lg-start {
    align-items: flex-start;
  }
  .aesirxsso .align-items-lg-end {
    align-items: flex-end;
  }
  .aesirxsso .align-items-lg-center {
    align-items: center;
  }
  .aesirxsso .align-items-lg-baseline {
    align-items: baseline;
  }
  .aesirxsso .align-items-lg-stretch {
    align-items: stretch;
  }
  .aesirxsso .align-content-lg-start {
    align-content: flex-start;
  }
  .aesirxsso .align-content-lg-end {
    align-content: flex-end;
  }
  .aesirxsso .align-content-lg-center {
    align-content: center;
  }
  .aesirxsso .align-content-lg-between {
    align-content: space-between;
  }
  .aesirxsso .align-content-lg-around {
    align-content: space-around;
  }
  .aesirxsso .align-content-lg-stretch {
    align-content: stretch;
  }
  .aesirxsso .align-self-lg-auto {
    align-self: auto;
  }
  .aesirxsso .align-self-lg-start {
    align-self: flex-start;
  }
  .aesirxsso .align-self-lg-end {
    align-self: flex-end;
  }
  .aesirxsso .align-self-lg-center {
    align-self: center;
  }
  .aesirxsso .align-self-lg-baseline {
    align-self: baseline;
  }
  .aesirxsso .align-self-lg-stretch {
    align-self: stretch;
  }
  .aesirxsso .order-lg-first {
    order: -1;
  }
  .aesirxsso .order-lg-0 {
    order: 0;
  }
  .aesirxsso .order-lg-1 {
    order: 1;
  }
  .aesirxsso .order-lg-2 {
    order: 2;
  }
  .aesirxsso .order-lg-3 {
    order: 3;
  }
  .aesirxsso .order-lg-4 {
    order: 4;
  }
  .aesirxsso .order-lg-5 {
    order: 5;
  }
  .aesirxsso .order-lg-last {
    order: 6;
  }
  .aesirxsso .m-lg-0 {
    margin: 0;
  }
  .aesirxsso .m-lg-1 {
    margin: 0.25rem;
  }
  .aesirxsso .m-lg-2 {
    margin: 0.5rem;
  }
  .aesirxsso .m-lg-3 {
    margin: 1rem;
  }
  .aesirxsso .m-lg-4 {
    margin: 1.5rem;
  }
  .aesirxsso .m-lg-5 {
    margin: 3rem;
  }
  .aesirxsso .m-lg-auto {
    margin: auto;
  }
  .aesirxsso .mx-lg-0 {
    margin-right: 0;
    margin-left: 0;
  }
  .aesirxsso .mx-lg-1 {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
  .aesirxsso .mx-lg-2 {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
  .aesirxsso .mx-lg-3 {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .aesirxsso .mx-lg-4 {
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
  .aesirxsso .mx-lg-5 {
    margin-right: 3rem;
    margin-left: 3rem;
  }
  .aesirxsso .mx-lg-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxsso .my-lg-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .aesirxsso .my-lg-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .aesirxsso .my-lg-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .aesirxsso .my-lg-3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .aesirxsso .my-lg-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .aesirxsso .my-lg-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .aesirxsso .my-lg-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .aesirxsso .mt-lg-0 {
    margin-top: 0;
  }
  .aesirxsso .mt-lg-1 {
    margin-top: 0.25rem;
  }
  .aesirxsso .mt-lg-2 {
    margin-top: 0.5rem;
  }
  .aesirxsso .mt-lg-3 {
    margin-top: 1rem;
  }
  .aesirxsso .mt-lg-4 {
    margin-top: 1.5rem;
  }
  .aesirxsso .mt-lg-5 {
    margin-top: 3rem;
  }
  .aesirxsso .mt-lg-auto {
    margin-top: auto;
  }
  .aesirxsso .me-lg-0 {
    margin-right: 0;
  }
  .aesirxsso .me-lg-1 {
    margin-right: 0.25rem;
  }
  .aesirxsso .me-lg-2 {
    margin-right: 0.5rem;
  }
  .aesirxsso .me-lg-3 {
    margin-right: 1rem;
  }
  .aesirxsso .me-lg-4 {
    margin-right: 1.5rem;
  }
  .aesirxsso .me-lg-5 {
    margin-right: 3rem;
  }
  .aesirxsso .me-lg-auto {
    margin-right: auto;
  }
  .aesirxsso .mb-lg-0 {
    margin-bottom: 0;
  }
  .aesirxsso .mb-lg-1 {
    margin-bottom: 0.25rem;
  }
  .aesirxsso .mb-lg-2 {
    margin-bottom: 0.5rem;
  }
  .aesirxsso .mb-lg-3 {
    margin-bottom: 1rem;
  }
  .aesirxsso .mb-lg-4 {
    margin-bottom: 1.5rem;
  }
  .aesirxsso .mb-lg-5 {
    margin-bottom: 3rem;
  }
  .aesirxsso .mb-lg-auto {
    margin-bottom: auto;
  }
  .aesirxsso .ms-lg-0 {
    margin-left: 0;
  }
  .aesirxsso .ms-lg-1 {
    margin-left: 0.25rem;
  }
  .aesirxsso .ms-lg-2 {
    margin-left: 0.5rem;
  }
  .aesirxsso .ms-lg-3 {
    margin-left: 1rem;
  }
  .aesirxsso .ms-lg-4 {
    margin-left: 1.5rem;
  }
  .aesirxsso .ms-lg-5 {
    margin-left: 3rem;
  }
  .aesirxsso .ms-lg-auto {
    margin-left: auto;
  }
  .aesirxsso .m-lg-n1 {
    margin: -0.25rem;
  }
  .aesirxsso .m-lg-n2 {
    margin: -0.5rem;
  }
  .aesirxsso .m-lg-n3 {
    margin: -1rem;
  }
  .aesirxsso .m-lg-n4 {
    margin: -1.5rem;
  }
  .aesirxsso .m-lg-n5 {
    margin: -3rem;
  }
  .aesirxsso .mx-lg-n1 {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
  .aesirxsso .mx-lg-n2 {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .aesirxsso .mx-lg-n3 {
    margin-right: -1rem;
    margin-left: -1rem;
  }
  .aesirxsso .mx-lg-n4 {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }
  .aesirxsso .mx-lg-n5 {
    margin-right: -3rem;
    margin-left: -3rem;
  }
  .aesirxsso .my-lg-n1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .aesirxsso .my-lg-n2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .aesirxsso .my-lg-n3 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .aesirxsso .my-lg-n4 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .aesirxsso .my-lg-n5 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .aesirxsso .mt-lg-n1 {
    margin-top: -0.25rem;
  }
  .aesirxsso .mt-lg-n2 {
    margin-top: -0.5rem;
  }
  .aesirxsso .mt-lg-n3 {
    margin-top: -1rem;
  }
  .aesirxsso .mt-lg-n4 {
    margin-top: -1.5rem;
  }
  .aesirxsso .mt-lg-n5 {
    margin-top: -3rem;
  }
  .aesirxsso .me-lg-n1 {
    margin-right: -0.25rem;
  }
  .aesirxsso .me-lg-n2 {
    margin-right: -0.5rem;
  }
  .aesirxsso .me-lg-n3 {
    margin-right: -1rem;
  }
  .aesirxsso .me-lg-n4 {
    margin-right: -1.5rem;
  }
  .aesirxsso .me-lg-n5 {
    margin-right: -3rem;
  }
  .aesirxsso .mb-lg-n1 {
    margin-bottom: -0.25rem;
  }
  .aesirxsso .mb-lg-n2 {
    margin-bottom: -0.5rem;
  }
  .aesirxsso .mb-lg-n3 {
    margin-bottom: -1rem;
  }
  .aesirxsso .mb-lg-n4 {
    margin-bottom: -1.5rem;
  }
  .aesirxsso .mb-lg-n5 {
    margin-bottom: -3rem;
  }
  .aesirxsso .ms-lg-n1 {
    margin-left: -0.25rem;
  }
  .aesirxsso .ms-lg-n2 {
    margin-left: -0.5rem;
  }
  .aesirxsso .ms-lg-n3 {
    margin-left: -1rem;
  }
  .aesirxsso .ms-lg-n4 {
    margin-left: -1.5rem;
  }
  .aesirxsso .ms-lg-n5 {
    margin-left: -3rem;
  }
  .aesirxsso .p-lg-0 {
    padding: 0;
  }
  .aesirxsso .p-lg-1 {
    padding: 0.25rem;
  }
  .aesirxsso .p-lg-2 {
    padding: 0.5rem;
  }
  .aesirxsso .p-lg-3 {
    padding: 1rem;
  }
  .aesirxsso .p-lg-4 {
    padding: 1.5rem;
  }
  .aesirxsso .p-lg-5 {
    padding: 3rem;
  }
  .aesirxsso .px-lg-0 {
    padding-right: 0;
    padding-left: 0;
  }
  .aesirxsso .px-lg-1 {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .aesirxsso .px-lg-2 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .aesirxsso .px-lg-3 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .aesirxsso .px-lg-4 {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
  .aesirxsso .px-lg-5 {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .aesirxsso .py-lg-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .aesirxsso .py-lg-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .aesirxsso .py-lg-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .aesirxsso .py-lg-3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .aesirxsso .py-lg-4 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .aesirxsso .py-lg-5 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .aesirxsso .pt-lg-0 {
    padding-top: 0;
  }
  .aesirxsso .pt-lg-1 {
    padding-top: 0.25rem;
  }
  .aesirxsso .pt-lg-2 {
    padding-top: 0.5rem;
  }
  .aesirxsso .pt-lg-3 {
    padding-top: 1rem;
  }
  .aesirxsso .pt-lg-4 {
    padding-top: 1.5rem;
  }
  .aesirxsso .pt-lg-5 {
    padding-top: 3rem;
  }
  .aesirxsso .pe-lg-0 {
    padding-right: 0;
  }
  .aesirxsso .pe-lg-1 {
    padding-right: 0.25rem;
  }
  .aesirxsso .pe-lg-2 {
    padding-right: 0.5rem;
  }
  .aesirxsso .pe-lg-3 {
    padding-right: 1rem;
  }
  .aesirxsso .pe-lg-4 {
    padding-right: 1.5rem;
  }
  .aesirxsso .pe-lg-5 {
    padding-right: 3rem;
  }
  .aesirxsso .pb-lg-0 {
    padding-bottom: 0;
  }
  .aesirxsso .pb-lg-1 {
    padding-bottom: 0.25rem;
  }
  .aesirxsso .pb-lg-2 {
    padding-bottom: 0.5rem;
  }
  .aesirxsso .pb-lg-3 {
    padding-bottom: 1rem;
  }
  .aesirxsso .pb-lg-4 {
    padding-bottom: 1.5rem;
  }
  .aesirxsso .pb-lg-5 {
    padding-bottom: 3rem;
  }
  .aesirxsso .ps-lg-0 {
    padding-left: 0;
  }
  .aesirxsso .ps-lg-1 {
    padding-left: 0.25rem;
  }
  .aesirxsso .ps-lg-2 {
    padding-left: 0.5rem;
  }
  .aesirxsso .ps-lg-3 {
    padding-left: 1rem;
  }
  .aesirxsso .ps-lg-4 {
    padding-left: 1.5rem;
  }
  .aesirxsso .ps-lg-5 {
    padding-left: 3rem;
  }
  .aesirxsso .gap-lg-0 {
    gap: 0;
  }
  .aesirxsso .gap-lg-1 {
    gap: 0.25rem;
  }
  .aesirxsso .gap-lg-2 {
    gap: 0.5rem;
  }
  .aesirxsso .gap-lg-3 {
    gap: 1rem;
  }
  .aesirxsso .gap-lg-4 {
    gap: 1.5rem;
  }
  .aesirxsso .gap-lg-5 {
    gap: 3rem;
  }
  .aesirxsso .row-gap-lg-0 {
    row-gap: 0;
  }
  .aesirxsso .row-gap-lg-1 {
    row-gap: 0.25rem;
  }
  .aesirxsso .row-gap-lg-2 {
    row-gap: 0.5rem;
  }
  .aesirxsso .row-gap-lg-3 {
    row-gap: 1rem;
  }
  .aesirxsso .row-gap-lg-4 {
    row-gap: 1.5rem;
  }
  .aesirxsso .row-gap-lg-5 {
    row-gap: 3rem;
  }
  .aesirxsso .column-gap-lg-0 {
    column-gap: 0;
  }
  .aesirxsso .column-gap-lg-1 {
    column-gap: 0.25rem;
  }
  .aesirxsso .column-gap-lg-2 {
    column-gap: 0.5rem;
  }
  .aesirxsso .column-gap-lg-3 {
    column-gap: 1rem;
  }
  .aesirxsso .column-gap-lg-4 {
    column-gap: 1.5rem;
  }
  .aesirxsso .column-gap-lg-5 {
    column-gap: 3rem;
  }
  .aesirxsso .text-lg-start {
    text-align: left;
  }
  .aesirxsso .text-lg-end {
    text-align: right;
  }
  .aesirxsso .text-lg-center {
    text-align: center;
  }
}
@media (min-width: 1200px) {
  .aesirxsso .float-xl-start {
    float: left;
  }
  .aesirxsso .float-xl-end {
    float: right;
  }
  .aesirxsso .float-xl-none {
    float: none;
  }
  .aesirxsso .object-fit-xl-contain {
    object-fit: contain;
  }
  .aesirxsso .object-fit-xl-cover {
    object-fit: cover;
  }
  .aesirxsso .object-fit-xl-fill {
    object-fit: fill;
  }
  .aesirxsso .object-fit-xl-scale {
    object-fit: scale-down;
  }
  .aesirxsso .object-fit-xl-none {
    object-fit: none;
  }
  .aesirxsso .d-xl-inline {
    display: inline;
  }
  .aesirxsso .d-xl-inline-block {
    display: inline-block;
  }
  .aesirxsso .d-xl-block {
    display: block;
  }
  .aesirxsso .d-xl-grid {
    display: grid;
  }
  .aesirxsso .d-xl-inline-grid {
    display: inline-grid;
  }
  .aesirxsso .d-xl-table {
    display: table;
  }
  .aesirxsso .d-xl-table-row {
    display: table-row;
  }
  .aesirxsso .d-xl-table-cell {
    display: table-cell;
  }
  .aesirxsso .d-xl-flex {
    display: flex;
  }
  .aesirxsso .d-xl-inline-flex {
    display: inline-flex;
  }
  .aesirxsso .d-xl-none {
    display: none;
  }
  .aesirxsso .flex-xl-fill {
    flex: 1 1 auto;
  }
  .aesirxsso .flex-xl-row {
    flex-direction: row;
  }
  .aesirxsso .flex-xl-column {
    flex-direction: column;
  }
  .aesirxsso .flex-xl-row-reverse {
    flex-direction: row-reverse;
  }
  .aesirxsso .flex-xl-column-reverse {
    flex-direction: column-reverse;
  }
  .aesirxsso .flex-xl-grow-0 {
    flex-grow: 0;
  }
  .aesirxsso .flex-xl-grow-1 {
    flex-grow: 1;
  }
  .aesirxsso .flex-xl-shrink-0 {
    flex-shrink: 0;
  }
  .aesirxsso .flex-xl-shrink-1 {
    flex-shrink: 1;
  }
  .aesirxsso .flex-xl-wrap {
    flex-wrap: wrap;
  }
  .aesirxsso .flex-xl-nowrap {
    flex-wrap: nowrap;
  }
  .aesirxsso .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .aesirxsso .justify-content-xl-start {
    justify-content: flex-start;
  }
  .aesirxsso .justify-content-xl-end {
    justify-content: flex-end;
  }
  .aesirxsso .justify-content-xl-center {
    justify-content: center;
  }
  .aesirxsso .justify-content-xl-between {
    justify-content: space-between;
  }
  .aesirxsso .justify-content-xl-around {
    justify-content: space-around;
  }
  .aesirxsso .justify-content-xl-evenly {
    justify-content: space-evenly;
  }
  .aesirxsso .align-items-xl-start {
    align-items: flex-start;
  }
  .aesirxsso .align-items-xl-end {
    align-items: flex-end;
  }
  .aesirxsso .align-items-xl-center {
    align-items: center;
  }
  .aesirxsso .align-items-xl-baseline {
    align-items: baseline;
  }
  .aesirxsso .align-items-xl-stretch {
    align-items: stretch;
  }
  .aesirxsso .align-content-xl-start {
    align-content: flex-start;
  }
  .aesirxsso .align-content-xl-end {
    align-content: flex-end;
  }
  .aesirxsso .align-content-xl-center {
    align-content: center;
  }
  .aesirxsso .align-content-xl-between {
    align-content: space-between;
  }
  .aesirxsso .align-content-xl-around {
    align-content: space-around;
  }
  .aesirxsso .align-content-xl-stretch {
    align-content: stretch;
  }
  .aesirxsso .align-self-xl-auto {
    align-self: auto;
  }
  .aesirxsso .align-self-xl-start {
    align-self: flex-start;
  }
  .aesirxsso .align-self-xl-end {
    align-self: flex-end;
  }
  .aesirxsso .align-self-xl-center {
    align-self: center;
  }
  .aesirxsso .align-self-xl-baseline {
    align-self: baseline;
  }
  .aesirxsso .align-self-xl-stretch {
    align-self: stretch;
  }
  .aesirxsso .order-xl-first {
    order: -1;
  }
  .aesirxsso .order-xl-0 {
    order: 0;
  }
  .aesirxsso .order-xl-1 {
    order: 1;
  }
  .aesirxsso .order-xl-2 {
    order: 2;
  }
  .aesirxsso .order-xl-3 {
    order: 3;
  }
  .aesirxsso .order-xl-4 {
    order: 4;
  }
  .aesirxsso .order-xl-5 {
    order: 5;
  }
  .aesirxsso .order-xl-last {
    order: 6;
  }
  .aesirxsso .m-xl-0 {
    margin: 0;
  }
  .aesirxsso .m-xl-1 {
    margin: 0.25rem;
  }
  .aesirxsso .m-xl-2 {
    margin: 0.5rem;
  }
  .aesirxsso .m-xl-3 {
    margin: 1rem;
  }
  .aesirxsso .m-xl-4 {
    margin: 1.5rem;
  }
  .aesirxsso .m-xl-5 {
    margin: 3rem;
  }
  .aesirxsso .m-xl-auto {
    margin: auto;
  }
  .aesirxsso .mx-xl-0 {
    margin-right: 0;
    margin-left: 0;
  }
  .aesirxsso .mx-xl-1 {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
  .aesirxsso .mx-xl-2 {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
  .aesirxsso .mx-xl-3 {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .aesirxsso .mx-xl-4 {
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
  .aesirxsso .mx-xl-5 {
    margin-right: 3rem;
    margin-left: 3rem;
  }
  .aesirxsso .mx-xl-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxsso .my-xl-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .aesirxsso .my-xl-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .aesirxsso .my-xl-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .aesirxsso .my-xl-3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .aesirxsso .my-xl-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .aesirxsso .my-xl-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .aesirxsso .my-xl-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .aesirxsso .mt-xl-0 {
    margin-top: 0;
  }
  .aesirxsso .mt-xl-1 {
    margin-top: 0.25rem;
  }
  .aesirxsso .mt-xl-2 {
    margin-top: 0.5rem;
  }
  .aesirxsso .mt-xl-3 {
    margin-top: 1rem;
  }
  .aesirxsso .mt-xl-4 {
    margin-top: 1.5rem;
  }
  .aesirxsso .mt-xl-5 {
    margin-top: 3rem;
  }
  .aesirxsso .mt-xl-auto {
    margin-top: auto;
  }
  .aesirxsso .me-xl-0 {
    margin-right: 0;
  }
  .aesirxsso .me-xl-1 {
    margin-right: 0.25rem;
  }
  .aesirxsso .me-xl-2 {
    margin-right: 0.5rem;
  }
  .aesirxsso .me-xl-3 {
    margin-right: 1rem;
  }
  .aesirxsso .me-xl-4 {
    margin-right: 1.5rem;
  }
  .aesirxsso .me-xl-5 {
    margin-right: 3rem;
  }
  .aesirxsso .me-xl-auto {
    margin-right: auto;
  }
  .aesirxsso .mb-xl-0 {
    margin-bottom: 0;
  }
  .aesirxsso .mb-xl-1 {
    margin-bottom: 0.25rem;
  }
  .aesirxsso .mb-xl-2 {
    margin-bottom: 0.5rem;
  }
  .aesirxsso .mb-xl-3 {
    margin-bottom: 1rem;
  }
  .aesirxsso .mb-xl-4 {
    margin-bottom: 1.5rem;
  }
  .aesirxsso .mb-xl-5 {
    margin-bottom: 3rem;
  }
  .aesirxsso .mb-xl-auto {
    margin-bottom: auto;
  }
  .aesirxsso .ms-xl-0 {
    margin-left: 0;
  }
  .aesirxsso .ms-xl-1 {
    margin-left: 0.25rem;
  }
  .aesirxsso .ms-xl-2 {
    margin-left: 0.5rem;
  }
  .aesirxsso .ms-xl-3 {
    margin-left: 1rem;
  }
  .aesirxsso .ms-xl-4 {
    margin-left: 1.5rem;
  }
  .aesirxsso .ms-xl-5 {
    margin-left: 3rem;
  }
  .aesirxsso .ms-xl-auto {
    margin-left: auto;
  }
  .aesirxsso .m-xl-n1 {
    margin: -0.25rem;
  }
  .aesirxsso .m-xl-n2 {
    margin: -0.5rem;
  }
  .aesirxsso .m-xl-n3 {
    margin: -1rem;
  }
  .aesirxsso .m-xl-n4 {
    margin: -1.5rem;
  }
  .aesirxsso .m-xl-n5 {
    margin: -3rem;
  }
  .aesirxsso .mx-xl-n1 {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
  .aesirxsso .mx-xl-n2 {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .aesirxsso .mx-xl-n3 {
    margin-right: -1rem;
    margin-left: -1rem;
  }
  .aesirxsso .mx-xl-n4 {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }
  .aesirxsso .mx-xl-n5 {
    margin-right: -3rem;
    margin-left: -3rem;
  }
  .aesirxsso .my-xl-n1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .aesirxsso .my-xl-n2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .aesirxsso .my-xl-n3 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .aesirxsso .my-xl-n4 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .aesirxsso .my-xl-n5 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .aesirxsso .mt-xl-n1 {
    margin-top: -0.25rem;
  }
  .aesirxsso .mt-xl-n2 {
    margin-top: -0.5rem;
  }
  .aesirxsso .mt-xl-n3 {
    margin-top: -1rem;
  }
  .aesirxsso .mt-xl-n4 {
    margin-top: -1.5rem;
  }
  .aesirxsso .mt-xl-n5 {
    margin-top: -3rem;
  }
  .aesirxsso .me-xl-n1 {
    margin-right: -0.25rem;
  }
  .aesirxsso .me-xl-n2 {
    margin-right: -0.5rem;
  }
  .aesirxsso .me-xl-n3 {
    margin-right: -1rem;
  }
  .aesirxsso .me-xl-n4 {
    margin-right: -1.5rem;
  }
  .aesirxsso .me-xl-n5 {
    margin-right: -3rem;
  }
  .aesirxsso .mb-xl-n1 {
    margin-bottom: -0.25rem;
  }
  .aesirxsso .mb-xl-n2 {
    margin-bottom: -0.5rem;
  }
  .aesirxsso .mb-xl-n3 {
    margin-bottom: -1rem;
  }
  .aesirxsso .mb-xl-n4 {
    margin-bottom: -1.5rem;
  }
  .aesirxsso .mb-xl-n5 {
    margin-bottom: -3rem;
  }
  .aesirxsso .ms-xl-n1 {
    margin-left: -0.25rem;
  }
  .aesirxsso .ms-xl-n2 {
    margin-left: -0.5rem;
  }
  .aesirxsso .ms-xl-n3 {
    margin-left: -1rem;
  }
  .aesirxsso .ms-xl-n4 {
    margin-left: -1.5rem;
  }
  .aesirxsso .ms-xl-n5 {
    margin-left: -3rem;
  }
  .aesirxsso .p-xl-0 {
    padding: 0;
  }
  .aesirxsso .p-xl-1 {
    padding: 0.25rem;
  }
  .aesirxsso .p-xl-2 {
    padding: 0.5rem;
  }
  .aesirxsso .p-xl-3 {
    padding: 1rem;
  }
  .aesirxsso .p-xl-4 {
    padding: 1.5rem;
  }
  .aesirxsso .p-xl-5 {
    padding: 3rem;
  }
  .aesirxsso .px-xl-0 {
    padding-right: 0;
    padding-left: 0;
  }
  .aesirxsso .px-xl-1 {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .aesirxsso .px-xl-2 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .aesirxsso .px-xl-3 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .aesirxsso .px-xl-4 {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
  .aesirxsso .px-xl-5 {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .aesirxsso .py-xl-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .aesirxsso .py-xl-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .aesirxsso .py-xl-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .aesirxsso .py-xl-3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .aesirxsso .py-xl-4 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .aesirxsso .py-xl-5 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .aesirxsso .pt-xl-0 {
    padding-top: 0;
  }
  .aesirxsso .pt-xl-1 {
    padding-top: 0.25rem;
  }
  .aesirxsso .pt-xl-2 {
    padding-top: 0.5rem;
  }
  .aesirxsso .pt-xl-3 {
    padding-top: 1rem;
  }
  .aesirxsso .pt-xl-4 {
    padding-top: 1.5rem;
  }
  .aesirxsso .pt-xl-5 {
    padding-top: 3rem;
  }
  .aesirxsso .pe-xl-0 {
    padding-right: 0;
  }
  .aesirxsso .pe-xl-1 {
    padding-right: 0.25rem;
  }
  .aesirxsso .pe-xl-2 {
    padding-right: 0.5rem;
  }
  .aesirxsso .pe-xl-3 {
    padding-right: 1rem;
  }
  .aesirxsso .pe-xl-4 {
    padding-right: 1.5rem;
  }
  .aesirxsso .pe-xl-5 {
    padding-right: 3rem;
  }
  .aesirxsso .pb-xl-0 {
    padding-bottom: 0;
  }
  .aesirxsso .pb-xl-1 {
    padding-bottom: 0.25rem;
  }
  .aesirxsso .pb-xl-2 {
    padding-bottom: 0.5rem;
  }
  .aesirxsso .pb-xl-3 {
    padding-bottom: 1rem;
  }
  .aesirxsso .pb-xl-4 {
    padding-bottom: 1.5rem;
  }
  .aesirxsso .pb-xl-5 {
    padding-bottom: 3rem;
  }
  .aesirxsso .ps-xl-0 {
    padding-left: 0;
  }
  .aesirxsso .ps-xl-1 {
    padding-left: 0.25rem;
  }
  .aesirxsso .ps-xl-2 {
    padding-left: 0.5rem;
  }
  .aesirxsso .ps-xl-3 {
    padding-left: 1rem;
  }
  .aesirxsso .ps-xl-4 {
    padding-left: 1.5rem;
  }
  .aesirxsso .ps-xl-5 {
    padding-left: 3rem;
  }
  .aesirxsso .gap-xl-0 {
    gap: 0;
  }
  .aesirxsso .gap-xl-1 {
    gap: 0.25rem;
  }
  .aesirxsso .gap-xl-2 {
    gap: 0.5rem;
  }
  .aesirxsso .gap-xl-3 {
    gap: 1rem;
  }
  .aesirxsso .gap-xl-4 {
    gap: 1.5rem;
  }
  .aesirxsso .gap-xl-5 {
    gap: 3rem;
  }
  .aesirxsso .row-gap-xl-0 {
    row-gap: 0;
  }
  .aesirxsso .row-gap-xl-1 {
    row-gap: 0.25rem;
  }
  .aesirxsso .row-gap-xl-2 {
    row-gap: 0.5rem;
  }
  .aesirxsso .row-gap-xl-3 {
    row-gap: 1rem;
  }
  .aesirxsso .row-gap-xl-4 {
    row-gap: 1.5rem;
  }
  .aesirxsso .row-gap-xl-5 {
    row-gap: 3rem;
  }
  .aesirxsso .column-gap-xl-0 {
    column-gap: 0;
  }
  .aesirxsso .column-gap-xl-1 {
    column-gap: 0.25rem;
  }
  .aesirxsso .column-gap-xl-2 {
    column-gap: 0.5rem;
  }
  .aesirxsso .column-gap-xl-3 {
    column-gap: 1rem;
  }
  .aesirxsso .column-gap-xl-4 {
    column-gap: 1.5rem;
  }
  .aesirxsso .column-gap-xl-5 {
    column-gap: 3rem;
  }
  .aesirxsso .text-xl-start {
    text-align: left;
  }
  .aesirxsso .text-xl-end {
    text-align: right;
  }
  .aesirxsso .text-xl-center {
    text-align: center;
  }
}
@media (min-width: 1400px) {
  .aesirxsso .float-xxl-start {
    float: left;
  }
  .aesirxsso .float-xxl-end {
    float: right;
  }
  .aesirxsso .float-xxl-none {
    float: none;
  }
  .aesirxsso .object-fit-xxl-contain {
    object-fit: contain;
  }
  .aesirxsso .object-fit-xxl-cover {
    object-fit: cover;
  }
  .aesirxsso .object-fit-xxl-fill {
    object-fit: fill;
  }
  .aesirxsso .object-fit-xxl-scale {
    object-fit: scale-down;
  }
  .aesirxsso .object-fit-xxl-none {
    object-fit: none;
  }
  .aesirxsso .d-xxl-inline {
    display: inline;
  }
  .aesirxsso .d-xxl-inline-block {
    display: inline-block;
  }
  .aesirxsso .d-xxl-block {
    display: block;
  }
  .aesirxsso .d-xxl-grid {
    display: grid;
  }
  .aesirxsso .d-xxl-inline-grid {
    display: inline-grid;
  }
  .aesirxsso .d-xxl-table {
    display: table;
  }
  .aesirxsso .d-xxl-table-row {
    display: table-row;
  }
  .aesirxsso .d-xxl-table-cell {
    display: table-cell;
  }
  .aesirxsso .d-xxl-flex {
    display: flex;
  }
  .aesirxsso .d-xxl-inline-flex {
    display: inline-flex;
  }
  .aesirxsso .d-xxl-none {
    display: none;
  }
  .aesirxsso .flex-xxl-fill {
    flex: 1 1 auto;
  }
  .aesirxsso .flex-xxl-row {
    flex-direction: row;
  }
  .aesirxsso .flex-xxl-column {
    flex-direction: column;
  }
  .aesirxsso .flex-xxl-row-reverse {
    flex-direction: row-reverse;
  }
  .aesirxsso .flex-xxl-column-reverse {
    flex-direction: column-reverse;
  }
  .aesirxsso .flex-xxl-grow-0 {
    flex-grow: 0;
  }
  .aesirxsso .flex-xxl-grow-1 {
    flex-grow: 1;
  }
  .aesirxsso .flex-xxl-shrink-0 {
    flex-shrink: 0;
  }
  .aesirxsso .flex-xxl-shrink-1 {
    flex-shrink: 1;
  }
  .aesirxsso .flex-xxl-wrap {
    flex-wrap: wrap;
  }
  .aesirxsso .flex-xxl-nowrap {
    flex-wrap: nowrap;
  }
  .aesirxsso .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .aesirxsso .justify-content-xxl-start {
    justify-content: flex-start;
  }
  .aesirxsso .justify-content-xxl-end {
    justify-content: flex-end;
  }
  .aesirxsso .justify-content-xxl-center {
    justify-content: center;
  }
  .aesirxsso .justify-content-xxl-between {
    justify-content: space-between;
  }
  .aesirxsso .justify-content-xxl-around {
    justify-content: space-around;
  }
  .aesirxsso .justify-content-xxl-evenly {
    justify-content: space-evenly;
  }
  .aesirxsso .align-items-xxl-start {
    align-items: flex-start;
  }
  .aesirxsso .align-items-xxl-end {
    align-items: flex-end;
  }
  .aesirxsso .align-items-xxl-center {
    align-items: center;
  }
  .aesirxsso .align-items-xxl-baseline {
    align-items: baseline;
  }
  .aesirxsso .align-items-xxl-stretch {
    align-items: stretch;
  }
  .aesirxsso .align-content-xxl-start {
    align-content: flex-start;
  }
  .aesirxsso .align-content-xxl-end {
    align-content: flex-end;
  }
  .aesirxsso .align-content-xxl-center {
    align-content: center;
  }
  .aesirxsso .align-content-xxl-between {
    align-content: space-between;
  }
  .aesirxsso .align-content-xxl-around {
    align-content: space-around;
  }
  .aesirxsso .align-content-xxl-stretch {
    align-content: stretch;
  }
  .aesirxsso .align-self-xxl-auto {
    align-self: auto;
  }
  .aesirxsso .align-self-xxl-start {
    align-self: flex-start;
  }
  .aesirxsso .align-self-xxl-end {
    align-self: flex-end;
  }
  .aesirxsso .align-self-xxl-center {
    align-self: center;
  }
  .aesirxsso .align-self-xxl-baseline {
    align-self: baseline;
  }
  .aesirxsso .align-self-xxl-stretch {
    align-self: stretch;
  }
  .aesirxsso .order-xxl-first {
    order: -1;
  }
  .aesirxsso .order-xxl-0 {
    order: 0;
  }
  .aesirxsso .order-xxl-1 {
    order: 1;
  }
  .aesirxsso .order-xxl-2 {
    order: 2;
  }
  .aesirxsso .order-xxl-3 {
    order: 3;
  }
  .aesirxsso .order-xxl-4 {
    order: 4;
  }
  .aesirxsso .order-xxl-5 {
    order: 5;
  }
  .aesirxsso .order-xxl-last {
    order: 6;
  }
  .aesirxsso .m-xxl-0 {
    margin: 0;
  }
  .aesirxsso .m-xxl-1 {
    margin: 0.25rem;
  }
  .aesirxsso .m-xxl-2 {
    margin: 0.5rem;
  }
  .aesirxsso .m-xxl-3 {
    margin: 1rem;
  }
  .aesirxsso .m-xxl-4 {
    margin: 1.5rem;
  }
  .aesirxsso .m-xxl-5 {
    margin: 3rem;
  }
  .aesirxsso .m-xxl-auto {
    margin: auto;
  }
  .aesirxsso .mx-xxl-0 {
    margin-right: 0;
    margin-left: 0;
  }
  .aesirxsso .mx-xxl-1 {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
  .aesirxsso .mx-xxl-2 {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
  .aesirxsso .mx-xxl-3 {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .aesirxsso .mx-xxl-4 {
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }
  .aesirxsso .mx-xxl-5 {
    margin-right: 3rem;
    margin-left: 3rem;
  }
  .aesirxsso .mx-xxl-auto {
    margin-right: auto;
    margin-left: auto;
  }
  .aesirxsso .my-xxl-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .aesirxsso .my-xxl-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .aesirxsso .my-xxl-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .aesirxsso .my-xxl-3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .aesirxsso .my-xxl-4 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .aesirxsso .my-xxl-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  .aesirxsso .my-xxl-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .aesirxsso .mt-xxl-0 {
    margin-top: 0;
  }
  .aesirxsso .mt-xxl-1 {
    margin-top: 0.25rem;
  }
  .aesirxsso .mt-xxl-2 {
    margin-top: 0.5rem;
  }
  .aesirxsso .mt-xxl-3 {
    margin-top: 1rem;
  }
  .aesirxsso .mt-xxl-4 {
    margin-top: 1.5rem;
  }
  .aesirxsso .mt-xxl-5 {
    margin-top: 3rem;
  }
  .aesirxsso .mt-xxl-auto {
    margin-top: auto;
  }
  .aesirxsso .me-xxl-0 {
    margin-right: 0;
  }
  .aesirxsso .me-xxl-1 {
    margin-right: 0.25rem;
  }
  .aesirxsso .me-xxl-2 {
    margin-right: 0.5rem;
  }
  .aesirxsso .me-xxl-3 {
    margin-right: 1rem;
  }
  .aesirxsso .me-xxl-4 {
    margin-right: 1.5rem;
  }
  .aesirxsso .me-xxl-5 {
    margin-right: 3rem;
  }
  .aesirxsso .me-xxl-auto {
    margin-right: auto;
  }
  .aesirxsso .mb-xxl-0 {
    margin-bottom: 0;
  }
  .aesirxsso .mb-xxl-1 {
    margin-bottom: 0.25rem;
  }
  .aesirxsso .mb-xxl-2 {
    margin-bottom: 0.5rem;
  }
  .aesirxsso .mb-xxl-3 {
    margin-bottom: 1rem;
  }
  .aesirxsso .mb-xxl-4 {
    margin-bottom: 1.5rem;
  }
  .aesirxsso .mb-xxl-5 {
    margin-bottom: 3rem;
  }
  .aesirxsso .mb-xxl-auto {
    margin-bottom: auto;
  }
  .aesirxsso .ms-xxl-0 {
    margin-left: 0;
  }
  .aesirxsso .ms-xxl-1 {
    margin-left: 0.25rem;
  }
  .aesirxsso .ms-xxl-2 {
    margin-left: 0.5rem;
  }
  .aesirxsso .ms-xxl-3 {
    margin-left: 1rem;
  }
  .aesirxsso .ms-xxl-4 {
    margin-left: 1.5rem;
  }
  .aesirxsso .ms-xxl-5 {
    margin-left: 3rem;
  }
  .aesirxsso .ms-xxl-auto {
    margin-left: auto;
  }
  .aesirxsso .m-xxl-n1 {
    margin: -0.25rem;
  }
  .aesirxsso .m-xxl-n2 {
    margin: -0.5rem;
  }
  .aesirxsso .m-xxl-n3 {
    margin: -1rem;
  }
  .aesirxsso .m-xxl-n4 {
    margin: -1.5rem;
  }
  .aesirxsso .m-xxl-n5 {
    margin: -3rem;
  }
  .aesirxsso .mx-xxl-n1 {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }
  .aesirxsso .mx-xxl-n2 {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .aesirxsso .mx-xxl-n3 {
    margin-right: -1rem;
    margin-left: -1rem;
  }
  .aesirxsso .mx-xxl-n4 {
    margin-right: -1.5rem;
    margin-left: -1.5rem;
  }
  .aesirxsso .mx-xxl-n5 {
    margin-right: -3rem;
    margin-left: -3rem;
  }
  .aesirxsso .my-xxl-n1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }
  .aesirxsso .my-xxl-n2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }
  .aesirxsso .my-xxl-n3 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
  .aesirxsso .my-xxl-n4 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
  .aesirxsso .my-xxl-n5 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .aesirxsso .mt-xxl-n1 {
    margin-top: -0.25rem;
  }
  .aesirxsso .mt-xxl-n2 {
    margin-top: -0.5rem;
  }
  .aesirxsso .mt-xxl-n3 {
    margin-top: -1rem;
  }
  .aesirxsso .mt-xxl-n4 {
    margin-top: -1.5rem;
  }
  .aesirxsso .mt-xxl-n5 {
    margin-top: -3rem;
  }
  .aesirxsso .me-xxl-n1 {
    margin-right: -0.25rem;
  }
  .aesirxsso .me-xxl-n2 {
    margin-right: -0.5rem;
  }
  .aesirxsso .me-xxl-n3 {
    margin-right: -1rem;
  }
  .aesirxsso .me-xxl-n4 {
    margin-right: -1.5rem;
  }
  .aesirxsso .me-xxl-n5 {
    margin-right: -3rem;
  }
  .aesirxsso .mb-xxl-n1 {
    margin-bottom: -0.25rem;
  }
  .aesirxsso .mb-xxl-n2 {
    margin-bottom: -0.5rem;
  }
  .aesirxsso .mb-xxl-n3 {
    margin-bottom: -1rem;
  }
  .aesirxsso .mb-xxl-n4 {
    margin-bottom: -1.5rem;
  }
  .aesirxsso .mb-xxl-n5 {
    margin-bottom: -3rem;
  }
  .aesirxsso .ms-xxl-n1 {
    margin-left: -0.25rem;
  }
  .aesirxsso .ms-xxl-n2 {
    margin-left: -0.5rem;
  }
  .aesirxsso .ms-xxl-n3 {
    margin-left: -1rem;
  }
  .aesirxsso .ms-xxl-n4 {
    margin-left: -1.5rem;
  }
  .aesirxsso .ms-xxl-n5 {
    margin-left: -3rem;
  }
  .aesirxsso .p-xxl-0 {
    padding: 0;
  }
  .aesirxsso .p-xxl-1 {
    padding: 0.25rem;
  }
  .aesirxsso .p-xxl-2 {
    padding: 0.5rem;
  }
  .aesirxsso .p-xxl-3 {
    padding: 1rem;
  }
  .aesirxsso .p-xxl-4 {
    padding: 1.5rem;
  }
  .aesirxsso .p-xxl-5 {
    padding: 3rem;
  }
  .aesirxsso .px-xxl-0 {
    padding-right: 0;
    padding-left: 0;
  }
  .aesirxsso .px-xxl-1 {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .aesirxsso .px-xxl-2 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .aesirxsso .px-xxl-3 {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .aesirxsso .px-xxl-4 {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
  .aesirxsso .px-xxl-5 {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .aesirxsso .py-xxl-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .aesirxsso .py-xxl-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .aesirxsso .py-xxl-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .aesirxsso .py-xxl-3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .aesirxsso .py-xxl-4 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .aesirxsso .py-xxl-5 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .aesirxsso .pt-xxl-0 {
    padding-top: 0;
  }
  .aesirxsso .pt-xxl-1 {
    padding-top: 0.25rem;
  }
  .aesirxsso .pt-xxl-2 {
    padding-top: 0.5rem;
  }
  .aesirxsso .pt-xxl-3 {
    padding-top: 1rem;
  }
  .aesirxsso .pt-xxl-4 {
    padding-top: 1.5rem;
  }
  .aesirxsso .pt-xxl-5 {
    padding-top: 3rem;
  }
  .aesirxsso .pe-xxl-0 {
    padding-right: 0;
  }
  .aesirxsso .pe-xxl-1 {
    padding-right: 0.25rem;
  }
  .aesirxsso .pe-xxl-2 {
    padding-right: 0.5rem;
  }
  .aesirxsso .pe-xxl-3 {
    padding-right: 1rem;
  }
  .aesirxsso .pe-xxl-4 {
    padding-right: 1.5rem;
  }
  .aesirxsso .pe-xxl-5 {
    padding-right: 3rem;
  }
  .aesirxsso .pb-xxl-0 {
    padding-bottom: 0;
  }
  .aesirxsso .pb-xxl-1 {
    padding-bottom: 0.25rem;
  }
  .aesirxsso .pb-xxl-2 {
    padding-bottom: 0.5rem;
  }
  .aesirxsso .pb-xxl-3 {
    padding-bottom: 1rem;
  }
  .aesirxsso .pb-xxl-4 {
    padding-bottom: 1.5rem;
  }
  .aesirxsso .pb-xxl-5 {
    padding-bottom: 3rem;
  }
  .aesirxsso .ps-xxl-0 {
    padding-left: 0;
  }
  .aesirxsso .ps-xxl-1 {
    padding-left: 0.25rem;
  }
  .aesirxsso .ps-xxl-2 {
    padding-left: 0.5rem;
  }
  .aesirxsso .ps-xxl-3 {
    padding-left: 1rem;
  }
  .aesirxsso .ps-xxl-4 {
    padding-left: 1.5rem;
  }
  .aesirxsso .ps-xxl-5 {
    padding-left: 3rem;
  }
  .aesirxsso .gap-xxl-0 {
    gap: 0;
  }
  .aesirxsso .gap-xxl-1 {
    gap: 0.25rem;
  }
  .aesirxsso .gap-xxl-2 {
    gap: 0.5rem;
  }
  .aesirxsso .gap-xxl-3 {
    gap: 1rem;
  }
  .aesirxsso .gap-xxl-4 {
    gap: 1.5rem;
  }
  .aesirxsso .gap-xxl-5 {
    gap: 3rem;
  }
  .aesirxsso .row-gap-xxl-0 {
    row-gap: 0;
  }
  .aesirxsso .row-gap-xxl-1 {
    row-gap: 0.25rem;
  }
  .aesirxsso .row-gap-xxl-2 {
    row-gap: 0.5rem;
  }
  .aesirxsso .row-gap-xxl-3 {
    row-gap: 1rem;
  }
  .aesirxsso .row-gap-xxl-4 {
    row-gap: 1.5rem;
  }
  .aesirxsso .row-gap-xxl-5 {
    row-gap: 3rem;
  }
  .aesirxsso .column-gap-xxl-0 {
    column-gap: 0;
  }
  .aesirxsso .column-gap-xxl-1 {
    column-gap: 0.25rem;
  }
  .aesirxsso .column-gap-xxl-2 {
    column-gap: 0.5rem;
  }
  .aesirxsso .column-gap-xxl-3 {
    column-gap: 1rem;
  }
  .aesirxsso .column-gap-xxl-4 {
    column-gap: 1.5rem;
  }
  .aesirxsso .column-gap-xxl-5 {
    column-gap: 3rem;
  }
  .aesirxsso .text-xxl-start {
    text-align: left;
  }
  .aesirxsso .text-xxl-end {
    text-align: right;
  }
  .aesirxsso .text-xxl-center {
    text-align: center;
  }
}
@media (min-width: 1200px) {
  .aesirxsso .fs-1 {
    font-size: 2.5rem;
  }
  .aesirxsso .fs-2 {
    font-size: 2rem;
  }
  .aesirxsso .fs-3 {
    font-size: 1.75rem;
  }
  .aesirxsso .fs-4 {
    font-size: 1.5rem;
  }
}
@media print {
  .aesirxsso .d-print-inline {
    display: inline;
  }
  .aesirxsso .d-print-inline-block {
    display: inline-block;
  }
  .aesirxsso .d-print-block {
    display: block;
  }
  .aesirxsso .d-print-grid {
    display: grid;
  }
  .aesirxsso .d-print-inline-grid {
    display: inline-grid;
  }
  .aesirxsso .d-print-table {
    display: table;
  }
  .aesirxsso .d-print-table-row {
    display: table-row;
  }
  .aesirxsso .d-print-table-cell {
    display: table-cell;
  }
  .aesirxsso .d-print-flex {
    display: flex;
  }
  .aesirxsso .d-print-inline-flex {
    display: inline-flex;
  }
  .aesirxsso .d-print-none {
    display: none;
  }
}
.aesirxsso :root {
  --aesirxsso-breakpoint-xs: 0;
  --aesirxsso-breakpoint-sm: 576px;
  --aesirxsso-breakpoint-md: 768px;
  --aesirxsso-breakpoint-lg: 992px;
  --aesirxsso-breakpoint-xl: 1200px;
  --aesirxsso-breakpoint-xxl: 1400px;
}
.aesirxsso .row {
  --aesirxsso-gutter-x: 1.5rem;
  --aesirxsso-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--aesirxsso-gutter-y));
  margin-right: calc(-0.5 * var(--aesirxsso-gutter-x));
  margin-left: calc(-0.5 * var(--aesirxsso-gutter-x));
}
.aesirxsso .row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--aesirxsso-gutter-x) * 0.5);
  padding-left: calc(var(--aesirxsso-gutter-x) * 0.5);
  margin-top: var(--aesirxsso-gutter-y);
}
.aesirxsso .col {
  flex: 1 0 0%;
}
.aesirxsso .row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}
.aesirxsso .row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}
.aesirxsso .row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}
.aesirxsso .row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.aesirxsso .row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}
.aesirxsso .row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}
.aesirxsso .row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.aesirxsso .col-auto {
  flex: 0 0 auto;
  width: auto;
}
.aesirxsso .col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}
.aesirxsso .col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.aesirxsso .col-3 {
  flex: 0 0 auto;
  width: 25%;
}
.aesirxsso .col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.aesirxsso .col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}
.aesirxsso .col-6 {
  flex: 0 0 auto;
  width: 50%;
}
.aesirxsso .col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}
.aesirxsso .col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}
.aesirxsso .col-9 {
  flex: 0 0 auto;
  width: 75%;
}
.aesirxsso .col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}
.aesirxsso .col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}
.aesirxsso .col-12 {
  flex: 0 0 auto;
  width: 100%;
}
.aesirxsso .offset-1 {
  margin-left: 8.33333333%;
}
.aesirxsso .offset-2 {
  margin-left: 16.66666667%;
}
.aesirxsso .offset-3 {
  margin-left: 25%;
}
.aesirxsso .offset-4 {
  margin-left: 33.33333333%;
}
.aesirxsso .offset-5 {
  margin-left: 41.66666667%;
}
.aesirxsso .offset-6 {
  margin-left: 50%;
}
.aesirxsso .offset-7 {
  margin-left: 58.33333333%;
}
.aesirxsso .offset-8 {
  margin-left: 66.66666667%;
}
.aesirxsso .offset-9 {
  margin-left: 75%;
}
.aesirxsso .offset-10 {
  margin-left: 83.33333333%;
}
.aesirxsso .offset-11 {
  margin-left: 91.66666667%;
}
.aesirxsso .g-0,
.aesirxsso .gx-0 {
  --aesirxsso-gutter-x: 0;
}
.aesirxsso .g-0,
.aesirxsso .gy-0 {
  --aesirxsso-gutter-y: 0;
}
.aesirxsso .g-1,
.aesirxsso .gx-1 {
  --aesirxsso-gutter-x: 0.25rem;
}
.aesirxsso .g-1,
.aesirxsso .gy-1 {
  --aesirxsso-gutter-y: 0.25rem;
}
.aesirxsso .g-2,
.aesirxsso .gx-2 {
  --aesirxsso-gutter-x: 0.5rem;
}
.aesirxsso .g-2,
.aesirxsso .gy-2 {
  --aesirxsso-gutter-y: 0.5rem;
}
.aesirxsso .g-3,
.aesirxsso .gx-3 {
  --aesirxsso-gutter-x: 1rem;
}
.aesirxsso .g-3,
.aesirxsso .gy-3 {
  --aesirxsso-gutter-y: 1rem;
}
.aesirxsso .g-4,
.aesirxsso .gx-4 {
  --aesirxsso-gutter-x: 1.5rem;
}
.aesirxsso .g-4,
.aesirxsso .gy-4 {
  --aesirxsso-gutter-y: 1.5rem;
}
.aesirxsso .g-5,
.aesirxsso .gx-5 {
  --aesirxsso-gutter-x: 3rem;
}
.aesirxsso .g-5,
.aesirxsso .gy-5 {
  --aesirxsso-gutter-y: 3rem;
}
@media (min-width: 576px) {
  .aesirxsso .col-sm {
    flex: 1 0 0%;
  }
  .aesirxsso .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxsso .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxsso .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxsso .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxsso .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxsso .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .aesirxsso .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxsso .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxsso .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .aesirxsso .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxsso .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxsso .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxsso .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .aesirxsso .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxsso .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .aesirxsso .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .aesirxsso .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .aesirxsso .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .aesirxsso .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .aesirxsso .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxsso .offset-sm-0 {
    margin-left: 0;
  }
  .aesirxsso .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .aesirxsso .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .aesirxsso .offset-sm-3 {
    margin-left: 25%;
  }
  .aesirxsso .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .aesirxsso .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .aesirxsso .offset-sm-6 {
    margin-left: 50%;
  }
  .aesirxsso .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .aesirxsso .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .aesirxsso .offset-sm-9 {
    margin-left: 75%;
  }
  .aesirxsso .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .aesirxsso .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .aesirxsso .g-sm-0,
  .aesirxsso .gx-sm-0 {
    --aesirxsso-gutter-x: 0;
  }
  .aesirxsso .g-sm-0,
  .aesirxsso .gy-sm-0 {
    --aesirxsso-gutter-y: 0;
  }
  .aesirxsso .g-sm-1,
  .aesirxsso .gx-sm-1 {
    --aesirxsso-gutter-x: 0.25rem;
  }
  .aesirxsso .g-sm-1,
  .aesirxsso .gy-sm-1 {
    --aesirxsso-gutter-y: 0.25rem;
  }
  .aesirxsso .g-sm-2,
  .aesirxsso .gx-sm-2 {
    --aesirxsso-gutter-x: 0.5rem;
  }
  .aesirxsso .g-sm-2,
  .aesirxsso .gy-sm-2 {
    --aesirxsso-gutter-y: 0.5rem;
  }
  .aesirxsso .g-sm-3,
  .aesirxsso .gx-sm-3 {
    --aesirxsso-gutter-x: 1rem;
  }
  .aesirxsso .g-sm-3,
  .aesirxsso .gy-sm-3 {
    --aesirxsso-gutter-y: 1rem;
  }
  .aesirxsso .g-sm-4,
  .aesirxsso .gx-sm-4 {
    --aesirxsso-gutter-x: 1.5rem;
  }
  .aesirxsso .g-sm-4,
  .aesirxsso .gy-sm-4 {
    --aesirxsso-gutter-y: 1.5rem;
  }
  .aesirxsso .g-sm-5,
  .aesirxsso .gx-sm-5 {
    --aesirxsso-gutter-x: 3rem;
  }
  .aesirxsso .g-sm-5,
  .aesirxsso .gy-sm-5 {
    --aesirxsso-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .aesirxsso .col-md {
    flex: 1 0 0%;
  }
  .aesirxsso .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxsso .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxsso .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxsso .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxsso .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxsso .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .aesirxsso .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxsso .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxsso .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .aesirxsso .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxsso .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxsso .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxsso .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .aesirxsso .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxsso .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .aesirxsso .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .aesirxsso .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .aesirxsso .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .aesirxsso .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .aesirxsso .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxsso .offset-md-0 {
    margin-left: 0;
  }
  .aesirxsso .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .aesirxsso .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .aesirxsso .offset-md-3 {
    margin-left: 25%;
  }
  .aesirxsso .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .aesirxsso .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .aesirxsso .offset-md-6 {
    margin-left: 50%;
  }
  .aesirxsso .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .aesirxsso .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .aesirxsso .offset-md-9 {
    margin-left: 75%;
  }
  .aesirxsso .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .aesirxsso .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .aesirxsso .g-md-0,
  .aesirxsso .gx-md-0 {
    --aesirxsso-gutter-x: 0;
  }
  .aesirxsso .g-md-0,
  .aesirxsso .gy-md-0 {
    --aesirxsso-gutter-y: 0;
  }
  .aesirxsso .g-md-1,
  .aesirxsso .gx-md-1 {
    --aesirxsso-gutter-x: 0.25rem;
  }
  .aesirxsso .g-md-1,
  .aesirxsso .gy-md-1 {
    --aesirxsso-gutter-y: 0.25rem;
  }
  .aesirxsso .g-md-2,
  .aesirxsso .gx-md-2 {
    --aesirxsso-gutter-x: 0.5rem;
  }
  .aesirxsso .g-md-2,
  .aesirxsso .gy-md-2 {
    --aesirxsso-gutter-y: 0.5rem;
  }
  .aesirxsso .g-md-3,
  .aesirxsso .gx-md-3 {
    --aesirxsso-gutter-x: 1rem;
  }
  .aesirxsso .g-md-3,
  .aesirxsso .gy-md-3 {
    --aesirxsso-gutter-y: 1rem;
  }
  .aesirxsso .g-md-4,
  .aesirxsso .gx-md-4 {
    --aesirxsso-gutter-x: 1.5rem;
  }
  .aesirxsso .g-md-4,
  .aesirxsso .gy-md-4 {
    --aesirxsso-gutter-y: 1.5rem;
  }
  .aesirxsso .g-md-5,
  .aesirxsso .gx-md-5 {
    --aesirxsso-gutter-x: 3rem;
  }
  .aesirxsso .g-md-5,
  .aesirxsso .gy-md-5 {
    --aesirxsso-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .aesirxsso .col-lg {
    flex: 1 0 0%;
  }
  .aesirxsso .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxsso .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxsso .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxsso .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxsso .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxsso .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .aesirxsso .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxsso .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxsso .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .aesirxsso .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxsso .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxsso .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxsso .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .aesirxsso .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxsso .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .aesirxsso .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .aesirxsso .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .aesirxsso .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .aesirxsso .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .aesirxsso .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxsso .offset-lg-0 {
    margin-left: 0;
  }
  .aesirxsso .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .aesirxsso .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .aesirxsso .offset-lg-3 {
    margin-left: 25%;
  }
  .aesirxsso .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .aesirxsso .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .aesirxsso .offset-lg-6 {
    margin-left: 50%;
  }
  .aesirxsso .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .aesirxsso .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .aesirxsso .offset-lg-9 {
    margin-left: 75%;
  }
  .aesirxsso .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .aesirxsso .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .aesirxsso .g-lg-0,
  .aesirxsso .gx-lg-0 {
    --aesirxsso-gutter-x: 0;
  }
  .aesirxsso .g-lg-0,
  .aesirxsso .gy-lg-0 {
    --aesirxsso-gutter-y: 0;
  }
  .aesirxsso .g-lg-1,
  .aesirxsso .gx-lg-1 {
    --aesirxsso-gutter-x: 0.25rem;
  }
  .aesirxsso .g-lg-1,
  .aesirxsso .gy-lg-1 {
    --aesirxsso-gutter-y: 0.25rem;
  }
  .aesirxsso .g-lg-2,
  .aesirxsso .gx-lg-2 {
    --aesirxsso-gutter-x: 0.5rem;
  }
  .aesirxsso .g-lg-2,
  .aesirxsso .gy-lg-2 {
    --aesirxsso-gutter-y: 0.5rem;
  }
  .aesirxsso .g-lg-3,
  .aesirxsso .gx-lg-3 {
    --aesirxsso-gutter-x: 1rem;
  }
  .aesirxsso .g-lg-3,
  .aesirxsso .gy-lg-3 {
    --aesirxsso-gutter-y: 1rem;
  }
  .aesirxsso .g-lg-4,
  .aesirxsso .gx-lg-4 {
    --aesirxsso-gutter-x: 1.5rem;
  }
  .aesirxsso .g-lg-4,
  .aesirxsso .gy-lg-4 {
    --aesirxsso-gutter-y: 1.5rem;
  }
  .aesirxsso .g-lg-5,
  .aesirxsso .gx-lg-5 {
    --aesirxsso-gutter-x: 3rem;
  }
  .aesirxsso .g-lg-5,
  .aesirxsso .gy-lg-5 {
    --aesirxsso-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .aesirxsso .col-xl {
    flex: 1 0 0%;
  }
  .aesirxsso .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxsso .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxsso .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxsso .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxsso .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxsso .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .aesirxsso .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxsso .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxsso .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .aesirxsso .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxsso .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxsso .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxsso .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .aesirxsso .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxsso .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .aesirxsso .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .aesirxsso .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .aesirxsso .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .aesirxsso .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .aesirxsso .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxsso .offset-xl-0 {
    margin-left: 0;
  }
  .aesirxsso .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .aesirxsso .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .aesirxsso .offset-xl-3 {
    margin-left: 25%;
  }
  .aesirxsso .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .aesirxsso .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .aesirxsso .offset-xl-6 {
    margin-left: 50%;
  }
  .aesirxsso .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .aesirxsso .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .aesirxsso .offset-xl-9 {
    margin-left: 75%;
  }
  .aesirxsso .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .aesirxsso .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .aesirxsso .g-xl-0,
  .aesirxsso .gx-xl-0 {
    --aesirxsso-gutter-x: 0;
  }
  .aesirxsso .g-xl-0,
  .aesirxsso .gy-xl-0 {
    --aesirxsso-gutter-y: 0;
  }
  .aesirxsso .g-xl-1,
  .aesirxsso .gx-xl-1 {
    --aesirxsso-gutter-x: 0.25rem;
  }
  .aesirxsso .g-xl-1,
  .aesirxsso .gy-xl-1 {
    --aesirxsso-gutter-y: 0.25rem;
  }
  .aesirxsso .g-xl-2,
  .aesirxsso .gx-xl-2 {
    --aesirxsso-gutter-x: 0.5rem;
  }
  .aesirxsso .g-xl-2,
  .aesirxsso .gy-xl-2 {
    --aesirxsso-gutter-y: 0.5rem;
  }
  .aesirxsso .g-xl-3,
  .aesirxsso .gx-xl-3 {
    --aesirxsso-gutter-x: 1rem;
  }
  .aesirxsso .g-xl-3,
  .aesirxsso .gy-xl-3 {
    --aesirxsso-gutter-y: 1rem;
  }
  .aesirxsso .g-xl-4,
  .aesirxsso .gx-xl-4 {
    --aesirxsso-gutter-x: 1.5rem;
  }
  .aesirxsso .g-xl-4,
  .aesirxsso .gy-xl-4 {
    --aesirxsso-gutter-y: 1.5rem;
  }
  .aesirxsso .g-xl-5,
  .aesirxsso .gx-xl-5 {
    --aesirxsso-gutter-x: 3rem;
  }
  .aesirxsso .g-xl-5,
  .aesirxsso .gy-xl-5 {
    --aesirxsso-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .aesirxsso .col-xxl {
    flex: 1 0 0%;
  }
  .aesirxsso .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxsso .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxsso .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxsso .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxsso .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxsso .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .aesirxsso .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxsso .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .aesirxsso .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .aesirxsso .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .aesirxsso .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .aesirxsso .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .aesirxsso .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .aesirxsso .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .aesirxsso .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .aesirxsso .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .aesirxsso .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .aesirxsso .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .aesirxsso .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .aesirxsso .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .aesirxsso .offset-xxl-0 {
    margin-left: 0;
  }
  .aesirxsso .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .aesirxsso .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .aesirxsso .offset-xxl-3 {
    margin-left: 25%;
  }
  .aesirxsso .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .aesirxsso .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .aesirxsso .offset-xxl-6 {
    margin-left: 50%;
  }
  .aesirxsso .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .aesirxsso .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .aesirxsso .offset-xxl-9 {
    margin-left: 75%;
  }
  .aesirxsso .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .aesirxsso .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .aesirxsso .g-xxl-0,
  .aesirxsso .gx-xxl-0 {
    --aesirxsso-gutter-x: 0;
  }
  .aesirxsso .g-xxl-0,
  .aesirxsso .gy-xxl-0 {
    --aesirxsso-gutter-y: 0;
  }
  .aesirxsso .g-xxl-1,
  .aesirxsso .gx-xxl-1 {
    --aesirxsso-gutter-x: 0.25rem;
  }
  .aesirxsso .g-xxl-1,
  .aesirxsso .gy-xxl-1 {
    --aesirxsso-gutter-y: 0.25rem;
  }
  .aesirxsso .g-xxl-2,
  .aesirxsso .gx-xxl-2 {
    --aesirxsso-gutter-x: 0.5rem;
  }
  .aesirxsso .g-xxl-2,
  .aesirxsso .gy-xxl-2 {
    --aesirxsso-gutter-y: 0.5rem;
  }
  .aesirxsso .g-xxl-3,
  .aesirxsso .gx-xxl-3 {
    --aesirxsso-gutter-x: 1rem;
  }
  .aesirxsso .g-xxl-3,
  .aesirxsso .gy-xxl-3 {
    --aesirxsso-gutter-y: 1rem;
  }
  .aesirxsso .g-xxl-4,
  .aesirxsso .gx-xxl-4 {
    --aesirxsso-gutter-x: 1.5rem;
  }
  .aesirxsso .g-xxl-4,
  .aesirxsso .gy-xxl-4 {
    --aesirxsso-gutter-y: 1.5rem;
  }
  .aesirxsso .g-xxl-5,
  .aesirxsso .gx-xxl-5 {
    --aesirxsso-gutter-x: 3rem;
  }
  .aesirxsso .g-xxl-5,
  .aesirxsso .gy-xxl-5 {
    --aesirxsso-gutter-y: 3rem;
  }
}
.aesirxsso .fs-18 {
  font-size: 18px;
}
.aesirxsso .fs-14 {
  font-size: 14px;
}
.aesirxsso .fs-12 {
  font-size: 12px;
}
.aesirxsso .mb-20px {
  margin-bottom: 20px;
}
.aesirxsso .mb-18px {
  margin-bottom: 18px;
}
.aesirxsso .cursor-pointer {
  cursor: pointer;
}
.aesirxsso.aesirxsso-rounded .form-control {
  border-radius: 50px;
}
.aesirxsso.aesirxsso-rounded .btn {
  border-radius: 50px;
}
.aesirxsso.aesirxsso-rounded .username_left {
  border-bottom-left-radius: 50px;
  border-top-left-radius: 50px;
}
.aesirxsso .form-control {
  padding: 13px;
}
.aesirxsso .btn {
  min-height: 48px;
}
.aesirxsso .btn:not(.btn-ethereum, .btn-concordium) {
  padding: 13px 24px;
}
.aesirxsso .btn:hover.text-white {
  color: #fff;
}
.aesirxsso .btn:disabled, .aesirxsso .btn.disabled {
  opacity: 1;
  background: #a5a4b5;
  color: #fff;
  border-color: transparent;
}
.aesirxsso .line {
  position: relative;
}
.aesirxsso .line::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  top: 50%;
  left: 0;
  background-color: #e9e9e9;
}
.aesirxsso .bg-success-light {
  background-color: #d1fae5;
  color: #0f674c;
}
.aesirxsso .btn-outline {
  border-color: #e9e9e9;
  color: #132342;
}
.aesirxsso .btn-outline:hover {
  border-color: #000;
}
.aesirxsso .back-button {
  margin-bottom: 32px;
}
.aesirxsso .modal-content {
  border: 0;
}
.aesirxsso .btn-close {
  position: absolute;
  top: 32px;
  right: 32px;
  z-index: 1;
}
.aesirxsso .custom-loading {
  background: rgba(255, 255, 255, 0.25);
}
.aesirxsso .text-inherit {
  color: inherit !important;
}
.aesirxsso + .modal-backdrop {
  z-index: 1056;
}
.aesirxsso + .modal-backdrop + .modal {
  z-index: 1057;
}
.aesirxsso .modal-dialog-centered {
  min-height: 100%;
}
.aesirxsso.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1055;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
.aesirxsso .popover-dark .popover {
  background-color: #222328;
  border-color: #222328;
  color: #fff;
  border-radius: 6px;
}
.aesirxsso .popover-dark .popover-body {
  color: #fff;
}
.aesirxsso .popover-dark .popover-arrow::after {
  border-top-color: #222328;
}
.aesirxsso .username_left {
  margin-left: 1px;
  height: 47px;
  width: 47px;
}

.modal-backdrop {
  --aesirxsso-backdrop-zindex: 1050;
  --aesirxsso-backdrop-bg: #000;
  --aesirxsso-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--aesirxsso-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--aesirxsso-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--aesirxsso-backdrop-opacity);
}

.aesirxsso-register .modal-dialog {
  height: 100%;
}

body {
  --wcm-z-index: 1060;
}

.modal-sso-open .wcm-overlay {
  z-index: 1060;
}

@media (max-width: 991.98px) {
  .aesirxsso .modal-dialog {
    max-width: 100%;
    height: 100%;
    margin: 0;
  }
  .aesirxsso .modal-dialog .modal-content {
    height: 100%;
  }
  .aesirxsso .modal-dialog .modal-content .modal-body {
    display: flex;
    align-items: center;
  }
  .aesirxsso.aesirxsso-register .btn-close {
    filter: none;
  }
  .aesirxsso .btn-close {
    filter: invert(1);
  }
}
[data-bs-theme=dark] .aesirxsso .border,
[data-bs-theme=dark] .aesirxsso .border-bottom,
[data-bs-theme=dark] .aesirxsso .border-top,
[data-bs-theme=dark] .aesirxsso .border-start,
[data-bs-theme=dark] .aesirxsso .border-end {
  border-color: var(--aesirxsso-border-color);
}
[data-bs-theme=dark] .aesirxsso .btn-dark {
  border-color: var(--aesirxsso-dark-border-subtle);
  background-color: var(--aesirxsso-dark-bg-subtle);
}
[data-bs-theme=dark] .aesirxsso .line::before {
  background-color: var(--aesirxsso-border-color);
}
[data-bs-theme=dark] .aesirxsso .btn-outline {
  border-color: #e9e9e9;
  color: #fff;
}
[data-bs-theme=dark] .aesirxsso .btn-outline:hover {
  border-color: #fff;
}
[data-bs-theme=dark] .aesirxsso .btn-close {
  filter: none;
}
[data-bs-theme=dark] .aesirxsso .back-button img {
  filter: invert(1);
}
[data-bs-theme=dark] .aesirxsso .twitter-icon {
  filter: invert(1);
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css));

// src/SSOButton/images/privacy_icon.png
var privacy_icon_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABOCAMAAABxGDr5AAAC61BMVEUAAAADA5fy8/0riucCAo73+f4LX/3z9vvz+P719/319/0Bcv4AAJQKZP4VbfcKZP4HEZb4+f75+v0ifO8viOL3+PsCAo4DA4709vwPZPwNY/319/3z9fsKaf0QbPcHEpoLdPgUdPwRZPT3+f3z9fwNaPoxid/39/0DA5IpddHk5/cwit4LZf0UaPn4+v4xh9/3+P/y9fr2+f4Rc/gtgdYjZcb3+P6cp9y8zvMsfNYyjuL2+P66v+UZRrfp7fobS7vP0+70+Pr4+v/h4/UVOK9ARrNji90vhdvG0fRobL/4+v75+/4KWv8dVan3+f7B1v8cUqgbTqfB1P4aS6bx9f72+f4XQ6Tz9/4ZSKUbUKjD1/8VPaLF1//19/77/P8SNaDA0vwYRaUFEJYNJZwIFZjt8v7P3/+9z/kTOKEKHZq6y/cPK57V4v8WP6MJG5nZ5f/H2f/N3f/g6v4PYfy+0PoOKJ3j7P/L3P8ZSaYRMZ8EDJUKXf/v9P6/0fu8zffb5/+6yvUUOqIQLZ4MIpvR4P/r8f7p7/7C0fYGEpcfXLEMH5sIF5jX5P8PYP6DneuCld+Ck9wQLp/n7v/d6P/T4f/G0/eDm+gWQaTI2v+CmeSAqf+/zvXG1/wZb/WDpPSDovGEoewcXb0RM6C0zf/m7PvR3fmCj9Ynbv/L2v3L2PnJ1PWRquuDl+J4h9Eja//D1PoTaPm1xvOswPAre89iccomcMZaZ8UkasBRX8CWuP/e5vvY4/vb5fmuw/cjfu+FneMhdOKBj9kuhNcmddAbYckiYrcDCZSuyP94pP9rm/9Zj/8+ff/V3/miuvSQrPMqhugdV6270f9ll/9OiP83eP8hav+7yfCPqfAhevCasu8rguCNod96k92GmdwZZdsbZtJDTrg3QrNxn/9Fgv+lwvyQr/eJqfUaauOiseKCleGFldg+Yb4cT7c2TbMwOq4qM6ghL6YbJqZjjdhFbcVHUbtEVrYfPq0iLakPJ54w5mA2AAAASnRSTlMAByAgCn/fQBDfryAQv6CfIt+fYD8wLhjvz6+fkHNgQkAQ+u/QkIlfFOPi4N/fv3Vvb0/v7+bf09HFwL+yq6CZinBvZWBbWlZDQBTmtxUAAAf3SURBVFjD7JTLSxtRFIdNSIiRLqrUVtCdgtaFrS7aQkvpg5Z2Gq6QTggVI9lEoQQmCZJsonERJ5txk0SQxEUhCRoFRTcl6t5nF74KxZ26cN2/oOfcO85VByfx0UWhv6viQPJ955x7kqr/+XdSXW+z1Vf9pdisHQTTXGe+/cK76pqJQIggEDzWWzXUv+kgCEc0FRBS23pLM2myNzQTRPMwR63txjPprGlw6difNEOd+UaFt7j4TDgcjxpy7WuotqqF41G5Z4LPTFBr7boG3my/MBWN3sclqoHYW69cPeDPFs7xPAI3eFquOKUaja4H8zbQoV60p/EqBiuMXs/uY6cPfy9eBCENnRXjH8PaqHhN4UyhAMFMcSaIxyHVVNhCvessnKKCRw5HhuL7KPw8/9RgN1e2Oki/sC8Zh8MxFVOf9RFoKhJUPyEanguE2BQYMsK56JuwV5dfHd29qltOW5BcBA5G/XxQP39ZTdnVObc4lIw8D0ShLbi1eDwuVSFoM3LZyqwOg/OyAY0skYa2kBajohiN4rOmELR3PDdeHQHCRwJlU3R4dyeTKZVyudwYGNZGMT6fL0oVLnWbWbcus9Hq1AoQXriIhQLI6TiXqd2NtbXScc7Zjwq3mzcBb3xtsDqA1yrHwoE9KstyUlotZdZ2NjY35+ZUBXftHR1rTUBI3eX8VoEF6So8mUyGw6FQKJVKxSBSTAo6D5G7sbELujH8NxdVx0S7MOBbGZ3iowgPIxvAkiQpiuI/zTZ2cagoUiwVSgdWJRmugo0J0mi4+mw2osjowAYygNPpeDze3w8/LOsgmNv2+yVUhMNJedTHmjDmE1Y9FC/LWLkkIRqpQZbIaXL7YFiPx0HBDSjwWC/nNxF2szCbZBjoih/ZDDsRmZgIwJkIwF8MbSHXH0/7YU7c4Dbg2yjfLVJ8TPHDSCiaAnsvZpW2EISpUUOIGnxuow9wIyG4OT45H1paTgN9GtkM16NL7w4I9nPBIDSh0DHl5dGo4Tdck8cj+vJ5xG8VpqenJwMauFuXnp7VPYdjbztCDX5paSmUl1+W+fJvAf5KYXlpq1AsTmKcTk7UKzKl3t5AIBJBw/LyysrKhyrjmN62A3/8a6FQHJ+fn/c6Md0GgTmhApotFLbGn5lMZfiWO6/at2Z+Li4UxxPZgcGhobIKvApotFgsJhbfW4wFJpOl7cHHF8D/NbuYyA4PD4DC60XBJQ4nDbSaSMz8+P3wnsVUpvy2u/fvv3t6cnJwMLswMzICBugBFRj0MCySWbzeoaHBgWw2u/Dty+fvjyxl+H/aJ5cQpeIojBeBm5gmKIoJphcURUWLalEQbYI2CooghouLeqGrohsTNCl8LHyRj4WKiGUuWuQIU6PmpnGaxtnVzKqpaaaZWVT0Lnou+879T/cuxCtU0GY+EUHh9zvfOdftm7ft2nX6be3Z4mK7ejsSCNipxEUoEGgkLAIy2BcvXLliDzwuVr+Yjbq7+9f3559553O8r71ZHMk9XTWQ4jKugSosBAb5ArHt9ivFwJ3qQt5g1Osa5/ryz74TfA7rz2+1N6lCcu5eNhsQHbBAgxBYIkci9nsPX7y8Xm6/DTrNXp3u+Aal+4K/60ReqIQ8YVe8dTOdKuTK1TvFW8UABTzxhQTskayIvoZcL5fbCxXBSQU6pxQLHNh8UOcMcigQd/Gf6jCMFHK5ZPXh7WIkeysbiUSy+AD53tOXAF8HOpnMtdvp7xnBRHzt2FbFBZ3UGg0mgUMBm4uPfmrW7qfTJCnkksny3NwjhCZGCJwrFEZGFuqt9xlPhmP8zn4l/v6O3mvOm2hD1rgtwVv4lWbt5s37sKReMwuSE8GpVLrWXP7wORpN2MIe3ypfc0hhQUcb53V6Iwm4jMNKFXiLhf+4XIcDFqqSSr1OgXy/3lr5zF+anr5kifKuuNXho/3ozms1kwr8Q1qtKDCYcAOxgivBRy1I/OOH5VarWa83m62vKz/ilmmgEQvhMX6Iw/OjF/m9n6ANkxoSYEUGJ3aUcTBDgoeDckkOkcGORvkE4TE+W48if+tMDAKtju2IKsAQhoIckESZhoHxBdgu0K3Ac8G8WVyPZmZjb757ngRyBc6XcUBBDhssTEPcBMhA2+JhomeAx79LHL8zvq73ftzq0gOpAgzoAEWIOcKwIKAi8XgYaKvH4wiBLpicBuCJP3ZM4b5DarV7vDG7WoEZBIGr+HwhksAiBWQHsSucEATdbMRxgY/NDIDTe0FqGCbu0plRgTpAITq4SsWXyZAm5AiFAAaZ4wTAQTcYvQyvGRsdXqeQLSo1UpqPiRWoAynyeSeKwAINhYGDhHbmDZjdqGd4jO+n8yqcYBNVwBmYgUpAYf4tkeIUyQb8gtGJTniM76b1KBt2+GlJTxqzGkmh93qZRQ6RjYyNgE742Lh/dz8+lnRELZ2BFKJDtBi9JCIukWU2o3ePr3yG0fmOBgpZQh4Ji2ApMpuN37X9fmfQUGQLPHgTWELLmXQPSoS+hkF2hjFmkDQStzuNJ93j9z/DODr0T+xGY6Kk7jG+8hn8pYm7CorZG1NLr0qjbtTtGr//Ga6qKe7SxANydKOf7yUyi/L4ygY4Rkuvni9N3RAzNbVE5KtAyzmM8f/GQPH7r1L8DCzHr9oxvEeBomjYOQBFr/j3Dg0O75bYf6rYNARH99D7dmIp/yZ7dg/v2zEwpFK5VarDA4P7dmLotaxlLf8zvwCXqKMEZnMZaQAAAABJRU5ErkJggg==";

// src/SSOButton/images/arrow_left.svg
var arrow_left_default = 'data:image/svg+xml,<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M8.04954 14.9605C8.27448 15.1748 8.63053 15.1661 8.8448 14.9412C9.05906 14.7162 9.05041 14.3602 8.82546 14.1459L4.1369 9.67997L15.1875 9.67997C15.4982 9.67997 15.75 9.42813 15.75 9.11747C15.75 8.80681 15.4982 8.55497 15.1875 8.55497L4.13683 8.55497L8.82546 4.08894C9.0504 3.87468 9.05906 3.51863 8.8448 3.29368C8.63053 3.06874 8.27448 3.06008 8.04954 3.27434L2.48534 8.57437C2.35864 8.69505 2.28368 8.84898 2.26045 9.00901C2.25359 9.04411 2.25 9.08037 2.25 9.11747C2.25 9.15464 2.25361 9.19098 2.26049 9.22613C2.28377 9.38607 2.35872 9.53989 2.48534 9.6605L8.04954 14.9605Z" fill="%23222328"/>%0A</svg>%0A';

// src/SSOButton/images/login_bg.png
var login_bg_default = "data:image/png;base64,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";

// src/SSOButton/images/cancel.svg
var cancel_default = 'data:image/svg+xml,<?xml version="1.0" encoding="iso-8859-1"?>%0D%0A<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->%0D%0A<svg fill="%23fff" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"%0D%0A%09 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">%0D%0A<g>%0D%0A%09<g>%0D%0A%09%09<path d="M256,0C115.39,0,0,115.39,0,256s115.39,256,256,256s256-115.39,256-256S396.61,0,256,0z M383.28,340.858l-42.422,42.422%0D%0A%09%09%09L256,298.422l-84.858,84.858l-42.422-42.422L213.578,256l-84.858-84.858l42.422-42.422L256,213.578l84.858-84.858l42.422,42.422%0D%0A%09%09%09L298.422,256L383.28,340.858z"/>%0D%0A%09</g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A<g>%0D%0A</g>%0D%0A</svg>%0D%0A';

// src/SSOButton/Providers/Concordium/index.tsx
import React9, { useEffect as useEffect3, useState as useState4 } from "react";
import { toast as toast5 } from "react-toastify";
import {
  TESTNET,
  MAINNET,
  WithWalletConnector,
  useConnection,
  useConnect,
  useGrpcClient
} from "@concordium/react-components";

// src/SSOButton/Providers/Concordium/config.tsx
import {
  BrowserWalletConnector,
  CONCORDIUM_WALLET_CONNECT_PROJECT_ID,
  WalletConnectConnector,
  ephemeralConnectorType
} from "@concordium/react-components";
var WALLET_CONNECT_OPTS = {
  projectId: CONCORDIUM_WALLET_CONNECT_PROJECT_ID,
  metadata: {
    name: "AesirX SSO",
    description: "AesirX SSO is our Open Source Single Sign On service.",
    url: "#",
    icons: [""]
  }
};
var BROWSER_WALLET = ephemeralConnectorType(BrowserWalletConnector.create);
var WALLET_CONNECT = ephemeralConnectorType(
  WalletConnectConnector.create.bind(void 0, WALLET_CONNECT_OPTS)
);

// src/SSOButton/Providers/Concordium/connect.tsx
import React from "react";

// src/SSOButton/images/concordium.png
var concordium_default = "data:image/png;base64,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";

// src/SSOButton/Providers/Concordium/connect.tsx
import { isMobile, isDesktop } from "react-device-detect";
import { Col, Row } from "react-bootstrap";
var ConnectConcordium = ({
  isConnecting,
  handleOnConnect,
  activeConnectorError,
  activeConnectorType,
  activeConnector,
  noLogin,
  disabled
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "" }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { lg: `${noLogin ? "6" : "12"}` }, isDesktop ? /* @__PURE__ */ React.createElement(
    "button",
    {
      disabled: isConnecting || disabled,
      type: "button",
      className: `btn btn-dark btn-concordium fw-medium text-nowrap py-2 px-4 fs-18 lh-sm text-white d-flex align-items-center justify-content-start w-100 ${noLogin ? "mb-3 mb-lg-0" : "mb-3"}`,
      onClick: () => handleOnConnect(BROWSER_WALLET, "browser")
    },
    isConnecting ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "spinner-border spinner-border-sm me-1",
        role: "status",
        "aria-hidden": "true"
      }
    ), "Connecting") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "img",
      {
        src: concordium_default,
        className: "me-3 align-text-bottom",
        alt: "Concordium",
        width: 24
      }
    ), "Browser Wallet")
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: `btn btn-dark btn-concordium flex-grow-1 fw-medium py-2 px-4 fs-18 lh-sm text-white d-flex align-items-center justify-content-start w-100`,
      onClick: () => handleOnConnect(WALLET_CONNECT, "walletconnect"),
      disabled: isConnecting || disabled
    },
    !activeConnectorError && activeConnectorType && !activeConnector ? /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "spinner-border spinner-border-sm me-1",
        role: "status",
        "aria-hidden": "true"
      }
    ) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "d-flex text-start align-items-center" }, /* @__PURE__ */ React.createElement("p", { className: "mb-0 fs-18 text-nowrap pe-3 me-3 border-end text-nowrap" }, "QR Code"), /* @__PURE__ */ React.createElement("p", { className: "mb-0 fs-12" }, "Concordium or CryptoX Mobile Wallets")))
  ))))), isMobile && /* @__PURE__ */ React.createElement("div", { className: "bg-success-light p-3 mt-3 fs-14 text-start" }, /* @__PURE__ */ React.createElement("p", { className: "mb-1 fw-bold" }, "Note for Concordium/CryptoX Mobile Wallet:"), /* @__PURE__ */ React.createElement("p", { className: "mb-0" }, "Please connect & sign your signature on the app then switch back to the browser to continue")));
};
var connect_default = ConnectConcordium;

// src/SSOButton/Providers/Concordium/sign.tsx
import React5, { useContext as useContext2, useState as useState2 } from "react";

// src/Hooks/useWallet.ts
import { toast } from "react-toastify";
import axios2 from "axios";

// src/utils/index.tsx
import axios from "axios";
import Bowser from "bowser";

// src/lib/envHelper.ts
var getHashKey = () => {
  let value = null;
  try {
    if (typeof process.env != "undefined") {
      value = process.env.SECURE_LOCAL_STORAGE_HASH_KEY || process.env.REACT_APP_SECURE_LOCAL_STORAGE_HASH_KEY || process.env.NEXT_PUBLIC_SECURE_LOCAL_STORAGE_HASH_KEY || process.env.VITE_SECURE_LOCAL_STORAGE_HASH_KEY;
    } else {
      console.warn(`react-secure-storage : process is not defined! Just a warning!`);
    }
  } catch (ex) {
    return null;
  }
  return value;
};
var getStoragePrefix = () => {
  let value = null;
  try {
    if (typeof process.env != "undefined") {
      value = process.env.SECURE_LOCAL_STORAGE_PREFIX || process.env.REACT_APP_SECURE_LOCAL_STORAGE_PREFIX || process.env.NEXT_PUBLIC_SECURE_LOCAL_STORAGE_PREFIX || process.env.VITE_SECURE_LOCAL_STORAGE_PREFIX;
    } else {
      console.warn(`react-secure-storage : process is not defined! Just a warning!`);
    }
  } catch (ex) {
    return null;
  }
  return value;
};
var getDisabledKeys = () => {
  let value = null;
  try {
    if (typeof process.env != "undefined") {
      value = process.env.SECURE_LOCAL_STORAGE_DISABLED_KEYS || process.env.REACT_APP_SECURE_LOCAL_STORAGE_DISABLED_KEYS || process.env.NEXT_PUBLIC_SECURE_LOCAL_STORAGE_DISABLED_KEYS || process.env.VITE_SECURE_LOCAL_STORAGE_DISABLED_KEYS;
    } else {
      console.warn(`react-secure-storage : process is not defined! Just a warning!`);
    }
  } catch (ex) {
    return null;
  }
  return value;
};
var envHelper = {
  getHashKey,
  getStoragePrefix,
  getDisabledKeys
};
var envHelper_default = envHelper;

// src/lib/fingerpint.lib.ts
var import_murmurhash3_gc = __toESM(require_murmurhash3_gc());

// src/lib/utils.ts
var FINGERPRINT_KEYS = {
  USERAGENT: "UserAgent",
  SCREEN_PRINT: "ScreenPrint",
  PLUGINS: "Plugins",
  FONTS: "Fonts",
  LOCAL_STORAGE: "LocalStorage",
  SESSION_STORAGE: "SessionStorage",
  TIMEZONE: "TimeZone",
  LANGUAGE: "Language",
  SYSTEM_LANGUAGE: "SystemLanguage",
  COOKIE: "Cookie",
  CANVAS: "Canvas",
  HOSTNAME: "Hostname"
};
var getDisabledKeys2 = () => {
  const DISABLED_KEYS = envHelper_default.getDisabledKeys() || "";
  if (DISABLED_KEYS === "")
    return [];
  const allOptions = [
    FINGERPRINT_KEYS.USERAGENT,
    FINGERPRINT_KEYS.SCREEN_PRINT,
    FINGERPRINT_KEYS.PLUGINS,
    FINGERPRINT_KEYS.FONTS,
    FINGERPRINT_KEYS.LOCAL_STORAGE,
    FINGERPRINT_KEYS.SESSION_STORAGE,
    FINGERPRINT_KEYS.TIMEZONE,
    FINGERPRINT_KEYS.LANGUAGE,
    FINGERPRINT_KEYS.SYSTEM_LANGUAGE,
    FINGERPRINT_KEYS.COOKIE,
    FINGERPRINT_KEYS.CANVAS,
    FINGERPRINT_KEYS.HOSTNAME
  ];
  const response = [];
  DISABLED_KEYS.split("|").forEach((key) => {
    if (key === "") {
      console.log("test");
    } else if (allOptions.includes(key))
      response.push(key);
    else
      console.warn(
        `react-secure-storage : ${key} is not present in the available disabled keys options! Please go through the documentation`
      );
  });
  return response;
};

// src/lib/fingerpint.lib.ts
var ClientJS = class {
  //
  // MAIN METHODS
  //
  // Get Fingerprint.  Return a 32-bit integer representing the browsers fingerprint.
  getFingerprint() {
    const bar = "|";
    const disabledKeys = getDisabledKeys2();
    let key = "";
    if (!disabledKeys.includes(FINGERPRINT_KEYS.USERAGENT)) {
      key += navigator.userAgent + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.HOSTNAME)) {
      key += window.location.hostname + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.SCREEN_PRINT)) {
      key += this.getScreenPrint() + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.PLUGINS)) {
      key += this.getPlugins() + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.FONTS)) {
      key += this.getFonts() + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.LOCAL_STORAGE)) {
      key += this.isLocalStorage() + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.SESSION_STORAGE)) {
      key += this.isSessionStorage() + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.TIMEZONE)) {
      key += this.getTimeZone() + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.LANGUAGE)) {
      key += this.getLanguage() + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.SYSTEM_LANGUAGE)) {
      key += this.getSystemLanguage() + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.COOKIE)) {
      key += this.isCookie() + bar;
    }
    if (!disabledKeys.includes(FINGERPRINT_KEYS.CANVAS)) {
      key += this.getCanvasPrint();
    }
    if (key.endsWith(bar))
      key = key.substring(0, key.length - 1);
    const seed = 256;
    return (0, import_murmurhash3_gc.default)(key, seed);
  }
  //
  // SCREEN METHODS
  //
  // Get Screen Print.  Return a string containing screen information.
  getScreenPrint() {
    return "Color Depth: " + this.getColorDepth() + ", Device XDPI: " + this.getDeviceXDPI() + ", Device YDPI: " + this.getDeviceYDPI();
  }
  // Get Color Depth.  Return a string containing the color depth.
  getColorDepth() {
    return window.screen.colorDepth;
  }
  // Get Current Resolution.  Return a string containing the current resolution.
  getCurrentResolution() {
    return window.screen.width + "x" + window.screen.height;
  }
  // Get Available Resolution.  Return a string containing the available resolution.
  getAvailableResolution() {
    return window.screen.availWidth + "x" + window.screen.availHeight;
  }
  // Get Device XPDI.  Return a string containing the device XPDI.
  getDeviceXDPI() {
    return "";
  }
  // Get Device YDPI.  Return a string containing the device YDPI.
  getDeviceYDPI() {
    return "";
  }
  //
  // PLUGIN METHODS
  //
  // Get Plugins.  Return a string containing a list of installed plugins.
  getPlugins() {
    let pluginsList = "";
    for (let i = 0; i < navigator.plugins.length; i++) {
      if (i === navigator.plugins.length - 1) {
        pluginsList += navigator.plugins[i].name;
      } else {
        pluginsList += navigator.plugins[i].name + ", ";
      }
    }
    return pluginsList;
  }
  //
  // FONT METHODS
  //
  // Get Fonts.  Return a string containing a list of installed fonts.
  getFonts() {
    const fontString = "";
    return fontString;
  }
  //
  // STORAGE METHODS
  //
  // Is Local Storage.  Check if local storage is enabled.
  isLocalStorage() {
    try {
      return !!localStorage;
    } catch (e) {
      return true;
    }
  }
  // Is Session Storage.  Check if session storage is enabled.
  isSessionStorage() {
    try {
      return !!sessionStorage;
    } catch (e) {
      return true;
    }
  }
  // Is Cookie.  Check if cookies are enabled.
  isCookie() {
    return navigator.cookieEnabled;
  }
  //
  // TIME METHODS
  //
  // Get Time Zone.  Return a string containing the time zone.
  getTimeZone() {
    const rightNow = /* @__PURE__ */ new Date();
    let myNumber, formattedNumber, result;
    myNumber = String(-(rightNow.getTimezoneOffset() / 60));
    if (myNumber < 0) {
      myNumber = myNumber * -1;
      formattedNumber = ("0" + myNumber).slice(-2);
      result = "-" + formattedNumber;
    } else {
      formattedNumber = ("0" + myNumber).slice(-2);
      result = "+" + formattedNumber;
    }
    return result;
  }
  //
  // LANGUAGE METHODS
  //
  // Get Language.  Return a string containing the user language.
  getLanguage() {
    return navigator.language;
  }
  // Get System Language.  Return a string containing the system language.
  getSystemLanguage() {
    return navigator.language || window.navigator.language;
  }
  // Get Canvas Print.  Return a string containing the canvas URI data.
  getCanvasPrint() {
    const canvas = document.createElement("canvas");
    let ctx;
    try {
      ctx = canvas.getContext("2d");
    } catch (e) {
      return "";
    }
    const txt = "ClientJS,org <canvas> 1.0";
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);
    return canvas.toDataURL();
  }
};
var clientJS = new ClientJS();
var fingerpint_lib_default = clientJS;

// src/lib/fingerprint.ts
var HASH_KEY = "E86E2612010258B35137";
var getFingerprint = () => {
  const HASH_KEY_CUSTOM = envHelper_default.getHashKey() || HASH_KEY;
  if (typeof window === "undefined")
    return HASH_KEY_CUSTOM;
  return fingerpint_lib_default.getFingerprint() + HASH_KEY_CUSTOM;
};
var fingerprint_default = getFingerprint;

// src/utils/index.tsx
import { env } from "aesirx-lib";
var shortenString = (str, first = 6, last = 4) => {
  return str?.substring(0, first) + "..." + str?.substring(str.length - last);
};
var getClientApp = () => {
  console.log("env", env);
  const endpoint = window["aesirxEndpoint"] ? window["aesirxEndpoint"] : env.REACT_APP_ENDPOINT_URL || env.NEXT_PUBLIC_ENDPOINT_URL || "https://api.aesirx.io";
  const client_id = window["aesirxClientID"] ? window["aesirxClientID"] : env.REACT_APP_SSO_CLIENT_ID || env.NEXT_PUBLIC_SSO_CLIENT_ID || "";
  const client_secret = window["aesirxClientSecret"] ? window["aesirxClientSecret"] : env.REACT_APP_SSO_CLIENT_SECRET || env.NEXT_PUBLIC_SSO_CLIENT_SECRET || "";
  const network2 = env.REACT_APP_SSO_CONCORDIUM_NETWORK || env.NEXT_PUBLIC_CONCORDIUM_NETWORK || "mainnet";
  const web3Endpoint = window["web3Endpoint"] ? window["web3Endpoint"] : env.REACT_APP_WEB3_API_ENDPOINT || env.NEXT_PUBLIC_WEB3_API_ENDPOINT || "https://web3id.backend.aesirx.io:8001";
  const dappEndpoint = window["dappEndpoint"] ? window["dappEndpoint"] : env.REACT_APP_WEB3_DAPP_URL || env.NEXT_PUBLIC_DAPP_URL || "https://dapp.shield.aesirx.io";
  const partnerEndpoint = window["partnerEndpoint"] ? window["partnerEndpoint"] : env.REACT_APP_PARTNERS_URL || env.NEXT_PUBLIC_PARTNERS_URL || "https://partners.aesirx.io";
  const socketEndpoint = window["socketEndpoint"] ? window["socketEndpoint"] : process.env.REACT_APP_SOCKET_URL || process.env.NEXT_PUBLIC_SOCKET_URL || "https://socket.aesirx.io";
  const registerForm = {
    username: window["registerUsername"] ? window["registerUsername"] : env.REACT_APP_USERNAME || env.NEXT_PUBLIC_USERNAME || 55,
    first_name: window["registerFirstname"] ? window["registerFirstname"] : env.REACT_APP_FIRSTNAME || env.NEXT_PUBLIC_FIRSTNAME || 53,
    last_name: window["registerLastname"] ? window["registerLastname"] : env.REACT_APP_LASTNAME || env.NEXT_PUBLIC_LASTNAME || 66,
    product: window["registerProduct"] ? window["registerProduct"] : env.REACT_APP_PRODUCT || env.NEXT_PUBLIC_PRODUCT || 54,
    email: window["registerEmail"] ? window["registerEmail"] : env.REACT_APP_EMAIL || env.NEXT_PUBLIC_EMAIL || 56,
    organization: window["registerOrganization"] ? window["registerOrganization"] : env.REACT_APP_ORGANIZATION || env.NEXT_PUBLIC_ORGANIZATION || 57,
    message: window["registerMessage"] ? window["registerMessage"] : env.REACT_APP_MESSAGE || env.NEXT_PUBLIC_MESSAGE || 58,
    order_id: window["registerOrderid"] ? window["registerOrderid"] : env.REACT_APP_ORDER_ID || env.NEXT_PUBLIC_ORDER_ID || 64,
    code: window["registerCode"] ? window["registerCode"] : env.REACT_APP_CODE || env.NEXT_PUBLIC_CODE || 65
  };
  return {
    endpoint,
    client_id,
    client_secret,
    network: network2,
    web3Endpoint,
    dappEndpoint,
    registerForm,
    partnerEndpoint,
    socketEndpoint
  };
};
var getChallenge = async (walletAccount) => {
  const { web3Endpoint } = getClientApp();
  try {
    return (await axios.get(`${web3Endpoint}/challenge?account=${walletAccount}`)).data?.challenge;
  } catch (error) {
    console.log("getChallenge", error);
    throw error;
  }
};
var getStatement = async () => {
  const { web3Endpoint } = getClientApp();
  try {
    return (await axios.get(`${web3Endpoint}/statement`)).data;
  } catch (error) {
    console.log("getChallenge", error);
    throw error;
  }
};
var verifyProof = async (challenge, proof) => {
  const { web3Endpoint } = getClientApp();
  try {
    return (await axios.post(
      `${web3Endpoint}/prove`,
      {
        challenge,
        proof
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )).data?.result;
  } catch (error) {
    console.log("getChallenge", error);
    throw error;
  }
};
var validateWeb3Id = async (id) => {
  const { web3Endpoint } = getClientApp();
  try {
    return !(await axios.get(`${web3Endpoint}/preregistration/checkid/${id}`)).data.result;
  } catch (error) {
    return false;
  }
};
var validateEmail = async (email) => {
  const { endpoint, web3Endpoint } = getClientApp();
  try {
    const [validateOnWeb3id, validateOnAesirx] = await Promise.all([
      !(await axios.get(`${web3Endpoint}/preregistration/checkemail/${email}`)).data.result,
      !(await axios.post(
        `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=member&task=checkEmailIsUsed&api=hal`,
        {
          email
        }
      )).data.result
    ]);
    return validateOnWeb3id && validateOnAesirx;
  } catch (error) {
    return false;
  }
};
var createMember = async (bodyData) => {
  const { endpoint } = getClientApp();
  try {
    const url = `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=member&api=hal`;
    const rs = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bodyData)
    });
    console.log("createMember", bodyData);
    if (rs?.ok === false) {
      throw await rs.json();
    }
    return await rs.json();
  } catch (error) {
    console.log("createMember", error);
    throw error;
  }
};
var login = async (username, password) => {
  const { partnerEndpoint } = getClientApp();
  try {
    const url = `${partnerEndpoint}/api/auth/login`;
    const rs = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({ username, password })
    });
    const data = await rs.json();
    return data;
  } catch (error) {
    console.log("login error", error);
    throw error;
  }
};
var autoRegisterWeb3id = async (data, clientJwt, signedNonce, walletAccount, isLinkWallet) => {
  const { dappEndpoint } = getClientApp();
  try {
    return await axios.post(`${dappEndpoint}/api/autocreate`, {
      data,
      clientJwt,
      signedNonce,
      walletAccount,
      isLinkWallet
    });
  } catch (error) {
    console.log("autoRegisterWeb3id", error);
    throw error;
  }
};
var mintWeb3ID = async (jwt) => {
  const { web3Endpoint } = getClientApp();
  try {
    return await axios.post(
      `${web3Endpoint}/aesirx/account/mint`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + jwt
        }
      }
    );
  } catch (error) {
    console.log("mintWeb3ID", error);
    throw error;
  }
};
var linkAesirXAccount = async (web3id, jwt) => {
  const { web3Endpoint } = getClientApp();
  await axios.put(
    `${web3Endpoint}/preregistration/aesirx/${web3id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwt
      }
    }
  );
};
var checkWalletAccount = async (account, wallet) => {
  const { web3Endpoint } = getClientApp();
  try {
    return await axios.get(
      `${web3Endpoint}/preregistration/checkaccount/${account}?wallet=${wallet}`
    );
  } catch (error) {
    console.log("checkWalletAccount", error);
    throw error;
  }
};
var getPreregistration = async (jwt) => {
  const { web3Endpoint } = getClientApp();
  return await axios.get(`${web3Endpoint}/preregistration/aesirx`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + jwt
    }
  });
};
var getMember = async (accessToken) => {
  const { endpoint } = getClientApp();
  try {
    const member = await axios.get(
      `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=persona&api=hal&task=getTokenByUser`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken
        }
      }
    );
    if (member?.data?.result?.member_id) {
      const data = await axios.get(
        `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=member&api=hal&id=${member?.data?.result?.member_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken
          }
        }
      );
      return data?.data;
    }
  } catch (error) {
    console.log("getMember", error);
    throw error;
  }
};
var updateMember = async (bodyData, accessToken) => {
  const { endpoint } = getClientApp();
  try {
    const response = await axios.put(
      `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=member&api=hal`,
      bodyData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`
        }
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
var connectWallet = async (address, walletType, accessToken, userName) => {
  try {
    const { endpoint } = getClientApp();
    const response = await axios.post(
      `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=member&task=setWallet&api=hal`,
      {
        wallet: walletType,
        publicAddress: address,
        username: userName
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken
        }
      }
    );
    return response?.data;
  } catch (error) {
    console.log("connectWalletError", error);
    throw error;
  }
};
var removeWallet = async (address, walletType, accessToken, userName) => {
  try {
    const { endpoint } = getClientApp();
    const response = await axios.post(
      `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=member&task=deleteWallet&api=hal`,
      {
        wallet: walletType,
        publicAddress: address,
        username: userName
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken
        }
      }
    );
    return response?.data;
  } catch (error) {
    console.log("removeWalletError", error);
    throw error;
  }
};
var createRequestV2 = (endpoint, task) => {
  return `${endpoint}/visitor/v2/${task}`;
};
var trackEvent = async (endpoint, referer, data) => {
  const allow = sessionStorage.getItem("aesirx-analytics-allow");
  if (allow === "0") {
    return null;
  }
  const { location: location2, document: document2 } = window;
  referer = referer ? location2.protocol + "//" + location2.host + referer : document2.referrer.split("?")[0];
  const url = location2.protocol + "//" + location2.host + location2.pathname;
  const user_agent = window.navigator.userAgent;
  const browser = Bowser.parse(window.navigator.userAgent);
  const browser_name = browser?.browser?.name;
  const browser_version = browser?.browser?.version ?? "0";
  const lang = window.navigator["userLanguage"] || window.navigator.language;
  const device = browser?.platform?.model ?? browser?.platform?.type;
  const ip = "";
  const fingerprint = fingerprint_default();
  const headers = { type: "application/json" };
  const blobData = new Blob(
    [
      JSON.stringify({
        fingerprint,
        url,
        ...referer !== "/" && referer && {
          referer
        },
        user_agent,
        ip,
        browser_name,
        browser_version,
        lang,
        device,
        ...data
      })
    ],
    headers
  );
  const responseStart = navigator.sendBeacon(createRequestV2(endpoint, "start"), blobData);
  return responseStart;
};
var paymentStripeSubscription = async (product_id, metadata) => {
  try {
    const { partnerEndpoint } = getClientApp();
    return await axios.post(`${partnerEndpoint}/api/stripe/checkout`, {
      product_id,
      metadata
    });
  } catch (error) {
    console.log("checkout link error", error);
    throw error;
  }
};

// src/Hooks/useWallet.ts
var useWallet = (wallet, publicAddress) => {
  const { endpoint } = getClientApp();
  const getWalletNonce = async () => {
    try {
      const reqAuthFormData = {
        publicAddress,
        wallet,
        text: `Login with nonce: {}`
      };
      const config = {
        method: "post",
        url: `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=member&task=getWalletNonce&api=hal`,
        headers: {
          "Content-Type": "application/json"
        },
        data: reqAuthFormData
      };
      const { data } = await axios2(config);
      if (data.result) {
        return data.result;
      }
      throw false;
    } catch (error) {
      return false;
    }
  };
  const verifySignature = async (wallet2, publicAddress2, signature) => {
    try {
      const returnParams = new URLSearchParams(window.location.search)?.get("return");
      const channelTypeParams = new URLSearchParams(window.location.search)?.get("channel_type");
      const organisationParams = new URLSearchParams(window.location.search)?.get("organisationId");
      const reqAuthFormData = {
        wallet: wallet2,
        publicAddress: publicAddress2,
        signature,
        ...channelTypeParams && { channel_type: channelTypeParams },
        ...returnParams && { return: returnParams },
        ...organisationParams && { organisationId: organisationParams }
      };
      const config = {
        method: "post",
        url: `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=member&task=walletLogin&api=hal&return=${returnParams ?? null}`,
        headers: {
          "Content-Type": "application/json"
        },
        data: reqAuthFormData
      };
      const { data } = await axios2(config);
      if (data?.result) {
        return data?.result;
      } else {
        throw false;
      }
    } catch (error) {
      console.log(error);
      toast("Wrong authentication", { closeOnClick: false });
      return false;
    }
  };
  return { getWalletNonce, verifySignature };
};
var useWallet_default = useWallet;

// src/SSOButton/Providers/Concordium/sign.tsx
import { toast as toast4 } from "react-toastify";

// src/SSOButton/Providers/CreateAccount/index.tsx
import React4, { Suspense, useCallback, useEffect as useEffect2, useState } from "react";
import { toast as toast3 } from "react-toastify";
import { Button, Col as Col2, Form as Form2, Row as Row2 } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { debounce } from "lodash";
import axios3 from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

// src/SSOButton/Providers/CreateAccount/CustomField.tsx
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React2, { useRef } from "react";
import { Form, OverlayTrigger, Popover } from "react-bootstrap";

// src/SSOButton/images/circle_info.svg
var circle_info_default = 'data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M9.00008 17.3337C4.39758 17.3337 0.666748 13.6028 0.666748 9.00033C0.666748 4.39783 4.39758 0.666992 9.00008 0.666992C13.6026 0.666992 17.3334 4.39783 17.3334 9.00033C17.3334 13.6028 13.6026 17.3337 9.00008 17.3337ZM9.00008 15.667C10.7682 15.667 12.4639 14.9646 13.7141 13.7144C14.9644 12.4641 15.6667 10.7684 15.6667 9.00033C15.6667 7.23222 14.9644 5.53652 13.7141 4.28628C12.4639 3.03604 10.7682 2.33366 9.00008 2.33366C7.23197 2.33366 5.53628 3.03604 4.28604 4.28628C3.03579 5.53652 2.33341 7.23222 2.33341 9.00033C2.33341 10.7684 3.03579 12.4641 4.28604 13.7144C5.53628 14.9646 7.23197 15.667 9.00008 15.667ZM8.16675 4.83366H9.83342V6.50033H8.16675V4.83366ZM8.16675 8.16699H9.83342V13.167H8.16675V8.16699Z" fill="%23222328"/>%0A</svg>%0A';

// src/SSOButton/Providers/CreateAccount/CustomField.tsx
var CustomField = ({
  formik,
  field,
  isShowEmail,
  isProduct = false,
  defaultProduct,
  hideDefaultProduct,
  productOptions
}) => {
  const { registerForm } = getClientApp();
  const fieldName = field.fieldtype == "email" ? `field${field.fieldId}_1_email` : `field${field.fieldId}_1`;
  if (field.fieldtype === "hidden") {
    return null;
  }
  if (field.name == "Order ID" || field.name === "Message") {
    return null;
  }
  if (field.fieldId?.toString() === registerForm?.product?.toString() && !isProduct || field.fieldId?.toString() === registerForm?.first_name?.toString() || field.fieldId?.toString() === registerForm?.last_name?.toString() || field.fieldId?.toString() === registerForm?.organization?.toString() || !isShowEmail && field.fieldId?.toString() === registerForm?.email?.toString()) {
    return null;
  }
  let listOptions = field?.fieldOptions;
  if (productOptions?.length !== 0 && field.fieldtype === "select") {
    listOptions = field?.fieldOptions.filter(
      (product) => productOptions.includes(product.value)
    );
  }
  const ref2 = useRef(null);
  return /* @__PURE__ */ React2.createElement(
    Form.Group,
    {
      className: `mb-3 w-100 ${hideDefaultProduct && field.fieldtype === "select" ? "d-none" : ""}`
    },
    /* @__PURE__ */ React2.createElement(
      "div",
      {
        className: "d-flex align-items-center justify-content-between mb-2 popover-dark",
        ref: ref2
      },
      /* @__PURE__ */ React2.createElement(Form.Label, { className: "mb-0" }, field.name, field.required == "1" && /* @__PURE__ */ React2.createElement("span", { className: "text-danger" }, "*")),
      field.fieldId == registerForm.username && /* @__PURE__ */ React2.createElement(
        OverlayTrigger,
        {
          trigger: "hover",
          key: "top",
          placement: "auto-end",
          container: ref2,
          overlay: /* @__PURE__ */ React2.createElement(Popover, { id: `popover-positioned-top` }, /* @__PURE__ */ React2.createElement(Popover.Body, null, /* @__PURE__ */ React2.createElement("p", { className: "mb-0" }, "Your Username is your Shield of Privacy ID (SoP ID) that you use across all AesirX services. It helps to anonymize and pseudonymize data to protect your privacy. Note: it cannot be changed later and the @handle is public.")))
        },
        /* @__PURE__ */ React2.createElement("img", { src: circle_info_default, alt: "circle_info Icon", width: "16px", height: "16px" })
      )
    ),
    /* @__PURE__ */ React2.createElement("div", { className: "position-relative" }, field.fieldId == registerForm.username && /* @__PURE__ */ React2.createElement(
      "div",
      {
        className: `position-absolute top-50 translate-middle-y bg-gray-stroke-2 d-flex justify-content-center align-items-center text-primary username_left`
      },
      "@"
    ), field.fieldtype === "textarea" ? /* @__PURE__ */ React2.createElement(
      Form.Control,
      {
        as: field.fieldtype,
        rows: 3,
        name: fieldName,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values[fieldName],
        className: `py-13px lh-sm ${formik.touched[fieldName] && formik.errors[fieldName] ? "border-danger" : ""}`
      }
    ) : field.fieldtype === "select" ? /* @__PURE__ */ React2.createElement(
      Form.Select,
      {
        name: fieldName,
        disabled: defaultProduct,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        className: `py-13px lh-sm ${formik.touched[fieldName] && formik.errors[fieldName] ? "border-danger" : ""}`,
        defaultValue: defaultProduct ? defaultProduct : "default"
      },
      /* @__PURE__ */ React2.createElement("option", { disabled: true, value: "default" }, "--Choose your product--"),
      listOptions?.map((item) => {
        return /* @__PURE__ */ React2.createElement("option", { id: item.id, key: item?.id, value: item?.value }, item?.label, " ", item?.price ? !parseInt(item?.price) ? "Free" : `$${parseInt(item?.price)}` : null);
      })
    ) : /* @__PURE__ */ React2.createElement(
      Form.Control,
      {
        type: field.fieldtype,
        name: fieldName,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values[fieldName],
        className: `py-13px lh-sm ${formik.touched[fieldName] && formik.errors[fieldName] ? "border-danger" : ""}  ${field.fieldId == registerForm.username ? "ps-5" : ""}`
      }
    )),
    formik.touched[fieldName] && formik.errors[fieldName] ? /* @__PURE__ */ React2.createElement("p", { className: "mt-2 mb-0 p-0 border-0 text-danger d-flex align-items-center" }, /* @__PURE__ */ React2.createElement(FontAwesomeIcon, { icon: faCircleExclamation, width: 14, height: 14 }), /* @__PURE__ */ React2.createElement("span", { className: "fs-7 fw-semibold ms-2 lh-1" }, formik.errors[fieldName])) : null
  );
};
var CustomField_default = CustomField;

// src/SSOButton/Providers/CreateAccount/FriendlyCaptcha.tsx
import React3, { useEffect, useRef as useRef2 } from "react";
import { WidgetInstance } from "friendly-challenge";
import { toast as toast2 } from "react-toastify";
var FriendlyCaptcha = ({ setCaptcha }) => {
  const captchaRef = useRef2(null);
  const widget = useRef2();
  useEffect(() => {
    if (!widget.current && captchaRef.current) {
      widget.current = new WidgetInstance(captchaRef.current, {
        doneCallback: (solution) => {
          setCaptcha(solution);
        },
        errorCallback: (err) => {
          console.log(err);
          toast2.error("There was an error when trying to solve the Captcha.");
        },
        startMode: "none"
      });
    }
    return () => {
      if (widget.current != void 0)
        widget.current.reset();
    };
  }, [captchaRef]);
  return /* @__PURE__ */ React3.createElement(
    "div",
    {
      ref: captchaRef,
      className: "frc-captcha",
      "data-sitekey": process.env.NEXT_PUBLIC_FRIENDLY_CAPTCHA
    }
  );
};
var FriendlyCaptcha_default = FriendlyCaptcha;

// src/SSOButton/Providers/CreateAccount/index.tsx
import { stringMessage } from "@concordium/react-components";
import { detectConcordiumProvider } from "@concordium/browser-wallet-api-helpers";
import io from "socket.io-client";
import { AccountAddress, ConcordiumGRPCClient } from "@concordium/web-sdk";
import { env as env2 } from "aesirx-lib";
var socket;
var listCol = [12, 12, 12, 12, 12, 12, 12, 12, 12];
var CreateAccount = ({
  formID = 10,
  setShow,
  setIsExist,
  setIsAccountExist,
  accountAddress,
  connection,
  wallet,
  noLogin,
  isNoWallet = false,
  packagesData = {},
  productOptions = [],
  productName,
  socialType = {},
  isRequireEmail,
  hideDefaultProduct = false,
  isRequireConcordium = false,
  defaultValues = [],
  alertButton = {
    isShow: false,
    handleClick: void 0,
    alertWarning: void 0
  }
}) => {
  const [sending, setSending] = useState(false);
  const [captcha, setCaptcha] = useState();
  const [loading, setLoading] = useState("");
  const { registerForm, endpoint, web3Endpoint, partnerEndpoint, socketEndpoint } = getClientApp();
  const debouncedCheckWeb3Id = useCallback(debounce(validateWeb3Id, 200), []);
  const debouncedCheckEmail = useCallback(debounce(validateEmail, 200), []);
  const [data, setData] = useState([]);
  const [fetch2, setFetch] = useState(true);
  const [walletState, setWalletState] = useState({
    wallet,
    accountAddress,
    connection
  });
  const [showCreateButton, setShowCreateButton] = useState(isRequireConcordium ? false : true);
  const [signatureLinkAccount, setSignatureLinkAccount] = useState("");
  const getNonce = async (accountAddress2, connection2, text) => {
    if (walletState?.wallet === "concordium") {
      const nonce = (await axios3.get(`${web3Endpoint}/account/${accountAddress2}/nonce?text=${text}`)).data.nonce;
      const signature = await connection2.signMessage(accountAddress2, stringMessage(`${nonce}`));
      const signedNonce = Buffer.from(
        typeof signature === "object" && signature !== null ? JSON.stringify(signature) : signature,
        "utf-8"
      ).toString("base64");
      return signedNonce;
    } else {
      return "";
    }
  };
  useEffect2(() => {
    (async () => {
      if (fetch2) {
        try {
          const response = await axios3.get(
            `${endpoint}/index.php?option=com_redform&webserviceVersion=1.0.0&webserviceClient=site&id=${formID}&api=hal`
          );
          if (response?.status === 200) {
            setData(response.data?.fields);
            setFetch(false);
          }
        } catch (error) {
          console.log("GetForm Error", error);
          setFetch(false);
        }
      }
    })();
  }, []);
  const [isSellix, setIsSellix] = useState(false);
  const [product, setProduct] = useState();
  const [shareLink, setShareLink] = useState("");
  const [affiliateLink, setAffiliateLink] = useState("");
  const [staffId, setStaffId] = useState("");
  const defaultProduct = packagesData?.default_web3_product ? packagesData?.default_web3_product?.toLowerCase() : "";
  const license = {
    product: packagesData?.license_package ? packagesData?.license_package?.toLowerCase() : "",
    sellix_id: packagesData?.sellix_id,
    product_name: productName,
    period: packagesData?.license_period ?? "monthly",
    scan_type: packagesData?.scan_type,
    number_domains: packagesData?.number_domains
  };
  const generateInitialValue = (data2) => {
    const initialValue = {};
    data2?.forEach((item) => {
      let defaultValue = "";
      if (defaultValues?.length) {
        defaultValue = defaultValues.find((field) => field.id == item.fieldId)?.value ?? "";
      }
      if (item.fieldtype == "email") {
        initialValue[`field${item.fieldId}_1_email`] = "";
      } else if (item.fieldtype == "select") {
        initialValue[`field${item.fieldId}_1`] = Object.keys(packagesData).length || productOptions.length ? defaultProduct : "";
      } else {
        initialValue[`field${item.fieldId}_1`] = defaultValue;
      }
    });
    return initialValue;
  };
  const generateValidationSchema = (data2) => {
    const validationSchema = {};
    data2?.forEach((item) => {
      if (item.required == "1" && item?.fieldId?.toString() !== registerForm.product?.toString()) {
        switch (item.fieldtype) {
          case "email":
            if (!walletState?.accountAddress && !Object.keys(socialType).length) {
              if (item?.fieldId?.toString() == registerForm.email?.toString()) {
                validationSchema[`field${item.fieldId}_1_email`] = Yup.string().email(`Please enter valid email`).required(`Please enter your ${item.name}`).test(
                  "unique",
                  "This Email is already taken",
                  async (value) => await debouncedCheckEmail(value)
                );
              } else {
                validationSchema[`field${item.fieldId}_1_email`] = Yup.string().email(`Please enter valid email`).required(`Please enter your ${item.name}`);
              }
            }
            break;
          case "username":
            validationSchema[`field${item.fieldId}_1`] = Yup.string().min(3, `Your ${item.name} is too short`).max(30, `Your ${item.name} is too long`).matches(/^[a-zA-Z0-9_]{3,20}$/, "Your username is not in the correct format").required(`Please enter your ${item.name}`);
            break;
          case "select":
            if (Object.keys(packagesData).length || productOptions.length) {
              validationSchema[`field${item.fieldId}_1`] = Yup.string().required(
                `Please select ${item.name}`
              );
            }
            break;
          default:
            if (item.fieldId == registerForm.username) {
              validationSchema[`field${item.fieldId}_1`] = Yup.string().min(3, `Your ${item.name} is too short`).max(30, `Your ${item.name} is too long`).test(
                "is_@",
                "Will automatically add @ before your Username. Please delete it.",
                (value) => value?.charAt(0) ? value?.charAt(0) !== "@" : true
              ).test(
                "unique",
                "This Username is already taken",
                async (value) => await debouncedCheckWeb3Id(`@${value}`)
              ).matches(/^[a-zA-Z0-9_]{3,20}$/, "Your Username is not in the correct format").required(`Please enter your Username`);
              break;
            }
            validationSchema[`field${item.fieldId}_1`] = Yup.string().test(
              "isUrl",
              "URL is not allowed",
              (value) => {
                const urlRegex = /^(?:(?:https?|ftp):\/\/|\b(?:[a-z\d]+\.))[^\s()<>]+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()[\]{};:'".,<>?«»“”‘’])*$/gi;
                const isUrl = urlRegex.test(value);
                return !isUrl;
              }
            );
            break;
        }
      }
    });
    return validationSchema;
  };
  const formik = useFormik({
    initialValues: generateInitialValue(data),
    enableReinitialize: true,
    validateOnMount: true,
    validationSchema: Yup.object(generateValidationSchema(data)),
    onSubmit: async (values) => {
      let isSuccess = true;
      setSending(true);
      try {
        const verify = await axios3.post(`${partnerEndpoint}/api/verifyform`, {
          solution: captcha
        });
        if (!verify?.data?.success) {
          const message = verify?.data?.errors?.[0] ? verify?.data?.errors?.[0].replaceAll("_", " ") : "Something went wrong please try again or contact us!";
          toast3.error(message);
          return;
        }
        setLoading("sign");
        const signedNonce = await getNonce(
          walletState?.accountAddress,
          walletState?.connection,
          "Create AesirX Account: {}"
        );
        const data2 = { ...values };
        data2.form_id = formID;
        data2[`field${registerForm.username}_1`] = "@" + data2[`field${registerForm.username}_1`];
        data2[`field${registerForm.product}_1`] = "community";
        const fpPromise = FingerprintJS.load({ monitoring: false });
        const fp = await fpPromise;
        const result = await fp.get();
        data2.visitorId = result.visitorId;
        const apiData = {
          id: data2[`field${registerForm.username}_1`],
          orderId: data2[`field${registerForm.order_id}_1`] ?? "",
          product: data2[`field${registerForm.product}_1`],
          organization: data2[`field${registerForm.organization}_1`] ? data2[`field${registerForm.organization}_1`] : data2[`field${registerForm.email}_1_email`],
          ...data2[`field${registerForm.email}_1_email`] && {
            email: data2[`field${registerForm.email}_1_email`],
            organization: data2[`field${registerForm.email}_1_email`]
          },
          message: data2[`field${registerForm.message}_1`] ?? "",
          visitorId: result.visitorId,
          ...shareLink && {
            refShare2Earn: shareLink
          },
          ...affiliateLink && {
            refAffiliate2Earn: affiliateLink
          }
        };
        console.log("apiData", apiData);
        const crypto = window["crypto"] || window["msCrypto"];
        const array = new Uint32Array(1);
        crypto.getRandomValues(array);
        const passwordGenerate = array[0];
        const member = {
          username: data2[`field${registerForm.email}_1_email`] ? data2[`field${registerForm.email}_1_email`] : Object.keys(socialType)?.length ? `${socialType?.id}` : `${walletState?.accountAddress}`,
          password: passwordGenerate,
          email: data2[`field${registerForm.email}_1_email`] ? data2[`field${registerForm.email}_1_email`] : Object.keys(socialType)?.length ? `${socialType?.id}@aesirx.io` : `${walletState?.accountAddress}@aesirx.io`,
          organisation: data2[`field${registerForm.email}_1_email`] ? data2[`field${registerForm.email}_1_email`] : Object.keys(socialType)?.length ? `${socialType?.id}` : `${walletState?.accountAddress}`,
          block: 0,
          ...walletState?.wallet === "concordium" ? { wallet_concordium: walletState?.accountAddress } : { wallet_metamask: walletState?.accountAddress },
          ...Object.keys(socialType)?.length ? { [`social_${socialType?.type}`]: socialType?.id } : {},
          web3id: data2[`field${registerForm.username}_1`]
        };
        try {
          setLoading("saving");
          const response = await autoRegisterWeb3id(
            apiData,
            "",
            signedNonce,
            walletState?.accountAddress,
            walletState?.wallet === "concordium" ? true : false
          );
          if (response) {
            const createResponse = await createMember(member);
            const { jwt, access_token } = await login(member?.email, member?.password);
            await linkAesirXAccount(apiData.id, jwt);
            const redFormData = {
              form_id: formID,
              [`field${registerForm.username}_1`]: data2[`field${registerForm.username}_1`],
              [`field${registerForm.first_name}_1`]: data2[`field${registerForm.first_name}_1`],
              [`field${registerForm.last_name}_1`]: data2[`field${registerForm.last_name}_1`],
              [`field${registerForm.product}_1`]: data2[`field${registerForm.product}_1`],
              [`field${registerForm.email}_1[email]`]: data2[`field${registerForm.email}_1_email`] ? data2[`field${registerForm.email}_1_email`] : Object.keys(socialType).length ? `${socialType?.id}@aesirx.io` : `${walletState?.accountAddress}@aesirx.io`,
              [`field${registerForm.organization}_1`]: data2[`field${registerForm.organization}_1`],
              [`field${registerForm.message}_1`]: data2[`field${registerForm.message}_1`],
              [`field${registerForm.order_id}_1`]: data2[`field${registerForm.order_id}_1`] ?? ""
            };
            const formData = new FormData();
            for (const key in redFormData) {
              formData.append(key, redFormData[key] ?? "");
            }
            try {
              await axios3.post(`${partnerEndpoint}/api/registersso`, {
                username: member.username,
                buyer_id: createResponse?.result?.user_id,
                userToken: access_token,
                member_id: createResponse?.result?.id,
                web3id: data2[`field${registerForm.username}_1`]
              });
            } catch (error) {
              console.log("register sso error", error);
            }
            await axios3.post(
              `${endpoint}/index.php?option=com_redform&task=redform.save&format=json`,
              formData
            );
            if (walletState?.wallet === "concordium") {
              toast3.success(
                `Thank you for signing up, ${data2[`field${registerForm.username}_1`]}! You can now log in to access all of our features and benefits.`
              );
              setIsExist && setIsExist(true);
              setIsAccountExist && setIsAccountExist({ status: true, type: "metamask" });
            } else {
              try {
                await mintWeb3ID(jwt);
              } catch (error) {
                console.log("mint web3 error", error);
              }
              if (walletState?.wallet || Object.keys(socialType).length) {
                toast3.success(
                  `Thank you for signing up, ${data2[`field${registerForm.username}_1`]}! You can now log in to access all of our features and benefits.`
                );
              } else {
                toast3.success(
                  "Please check your email (also check your SPAM folder) to finalize your AesirX Single Sign On account and continue your registration for AesirX Shield of Privacy"
                );
              }
              try {
                await trackEvent(
                  env2.REACT_APP_ENDPOINT_ANALYTICS_URL || env2.NEXT_PUBLIC_ENDPOINT_ANALYTICS_URL || "https://api.analytics.aesirx.io",
                  location.pathname,
                  {
                    event_name: "Sign Up",
                    event_type: "conversion",
                    attributes: [
                      { name: "sop_id", value: data2[`field${registerForm.username}_1`] },
                      ...walletState?.wallet === "concordium" ? [{ name: "type", value: walletState?.wallet }] : [{ name: "type", value: "email" }]
                    ]
                  }
                );
              } catch (error) {
                console.error("error", error);
              }
              setIsExist && setIsExist(true);
              setIsAccountExist && setIsAccountExist({ status: true, type: "metamask" });
            }
          }
        } catch (error) {
          console.log(error);
          toast3.error(error?.response?.data?.error || error?.message);
        }
      } catch (error) {
        isSuccess = false;
        console.log("Submit Error", error);
        toast3.error(error?.response?.data?.error || error?._messages[0]?.message || error?.message);
      }
      setLoading("");
      setShow && setShow(!isSuccess);
      setSending(false);
    }
  });
  const reorderArr = (i, arr) => {
    return [...arr.slice(i), ...arr.slice(0, i)];
  };
  const reorderedArr = reorderArr(4, data);
  const [proof, setProof] = useState(false);
  const handleProof = async () => {
    try {
      const challenge = await getChallenge(walletState?.accountAddress ?? "");
      const statement = await getStatement();
      const provider = await detectConcordiumProvider();
      const client = new ConcordiumGRPCClient(provider.grpcTransport);
      const accountAddr = AccountAddress.fromBase58(walletState?.accountAddress);
      const accountInfo = await client.getAccountInfo(accountAddr);
      const nationality = accountInfo?.accountCredentials[0]?.value?.contents?.commitments?.cmmAttributes?.nationality;
      const countryOfResidence = accountInfo?.accountCredentials[0]?.value?.contents?.commitments?.cmmAttributes?.countryOfResidence;
      if (!nationality) {
        if (countryOfResidence) {
          statement[0].attributeTag = "countryOfResidence";
        } else {
          statement[0].attributeTag = "idDocIssuer";
        }
      }
      const proof2 = await provider.requestIdProof(
        walletState?.accountAddress ?? "",
        statement,
        challenge
      );
      const re = await verifyProof(challenge, proof2);
      if (re) {
        setProof(true);
      }
      return true;
    } catch (error) {
      setProof(false);
      return false;
    }
  };
  useEffect2(() => {
    if (formik.values[`field${registerForm.product}_1`] && formik.values[`field${registerForm.product}_1`] !== "community") {
      setIsSellix(true);
      setProduct(
        data.filter((item) => item.fieldtype === "select")?.[0].fieldOptions?.find(
          (product2) => product2.value == formik.values[`field${registerForm.product}_1`]
        )
      );
    } else {
      setIsSellix(false);
    }
  }, [formik.values]);
  useEffect2(() => {
    if (window) {
      const search = window.location.search;
      const params = new URLSearchParams(search);
      const refShare2EarnUrl = params.get("ref") || sessionStorage.getItem("share2earnRef");
      const refAffiliate2EarnUrl = params.get("refaffiliate") || sessionStorage.getItem("affiliateRef");
      const refStaffId = params.get("refstaff") || sessionStorage.getItem("staffRef");
      setStaffId(refStaffId);
      setShareLink(refShare2EarnUrl);
      setAffiliateLink(refAffiliate2EarnUrl);
    }
  }, []);
  useEffect2(() => {
    if (formik.values[`field${registerForm.username}_1`] && formik.values[`field${registerForm.email}_1_email`]) {
      const createSocketServer = async () => {
        await axios3.get(`${socketEndpoint}/api/socket`);
      };
      createSocketServer();
      if (!socket && socketEndpoint) {
        socket = io(socketEndpoint, {
          reconnection: true,
          secure: true,
          rejectUnauthorized: false,
          transports: ["polling"]
        });
      }
      socket.on("connect", () => {
        socket.on("web3id-update", async (msg) => {
          const web3id = formik.values[`field${registerForm.username}_1`] ? `@${formik.values[`field${registerForm.username}_1`].trim()}` : `@${formik.values[`field${registerForm.username}_1`]}`;
          if (msg?.id === web3id) {
            const list = document.getElementById("sellix-container");
            list && list?.removeChild(list.lastChild);
            toast3.success(
              "Please check your email (also check your SPAM folder) to finalize your AesirX Single Sign On account and continue your registration for AesirX Shield of Privacy"
            );
            try {
              await trackEvent(
                env2.REACT_APP_ENDPOINT_ANALYTICS_URL || env2.NEXT_PUBLIC_ENDPOINT_ANALYTICS_URL || "https://api.analytics.aesirx.io",
                location.pathname,
                {
                  event_name: msg?.trackEventName,
                  event_type: "conversion",
                  attributes: msg?.trackAttributes ?? []
                }
              );
            } catch (error) {
              console.error("error", error);
            }
            setShow && setShow(false);
          }
        });
      });
    }
  }, [
    formik.values[`field${registerForm.username}_1`],
    formik.values[`field${registerForm.email}_1_email`]
  ]);
  const handleStripe = async () => {
    try {
      const metadata = {
        package: formik.values[`field${registerForm.product}_1`],
        form_id: formID,
        requested_username: formik.values[`field${registerForm.username}_1`] ? `@${formik.values[`field${registerForm.username}_1`].trim()}` : `@${formik.values[`field${registerForm.username}_1`]}`,
        firstname: formik.values[`field${registerForm.first_name}_1`],
        surname: formik.values[`field${registerForm.last_name}_1`],
        product: formik.values[`field${registerForm.product}_1`],
        email: formik.values[`field${registerForm.email}_1_email`],
        organization: formik.values[`field${registerForm.organization}_1`],
        message: formik.values[`field${registerForm.message}_1`],
        share_link: shareLink,
        affiliate_link: affiliateLink,
        staff_id: staffId,
        license_period: license?.period,
        license_package: license?.product,
        license_package_name: license?.product_name,
        scan_type: license?.scan_type,
        number_domains: license?.number_domains,
        signature: signatureLinkAccount,
        account_address: walletState?.accountAddress
      };
      const productId = license?.sellix_id ? license?.sellix_id : product?.sku;
      const result = await paymentStripeSubscription(productId, metadata);
      window.open(result?.data?.url, "_blank");
    } catch (error) {
      toast3.error("Something is wrong. Please try again or contact us");
    }
  };
  return /* @__PURE__ */ React4.createElement(React4.Fragment, null, !walletState?.accountAddress && !isNoWallet && /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement("div", { className: "line text-center" }, /* @__PURE__ */ React4.createElement("span", { className: "bg-white px-2 position-relative text-dark" }, "or"))), noLogin && !proof && walletState?.wallet === "concordium" && !isRequireConcordium && /* @__PURE__ */ React4.createElement("div", { className: "d-flex mb-3" }, /* @__PURE__ */ React4.createElement(
    Button,
    {
      variant: "dark",
      className: "fw-medium py-2 px-4 fs-18 lh-sm text-white",
      onClick: () => {
        handleProof();
      }
    },
    "Authorize"
  ), /* @__PURE__ */ React4.createElement("span", { className: "text-danger" }, "*")), !fetch2 ? data ? /* @__PURE__ */ React4.createElement(Form2, { onSubmit: formik.handleSubmit }, loading && /* @__PURE__ */ React4.createElement("div", { className: "custom-loading position-absolute top-50 start-50 translate-middle z-1 w-100 h-100 d-flex align-items-center justify-content-center" }, /* @__PURE__ */ React4.createElement(
    "span",
    {
      className: "spinner-border spinner-border-lg me-1",
      role: "status",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React4.createElement(Row2, null, reorderedArr.map((field, index) => {
    return /* @__PURE__ */ React4.createElement(Col2, { key: index, md: listCol[index] }, /* @__PURE__ */ React4.createElement(
      CustomField_default,
      {
        field,
        formik,
        defaultProduct,
        hideDefaultProduct,
        productOptions,
        isShowEmail: (walletState?.accountAddress || Object.keys(socialType).length) && !isRequireEmail ? false : true,
        isProduct: Object.keys(packagesData).length || productOptions?.length ? true : false
      }
    ));
  })), /* @__PURE__ */ React4.createElement(Form2.Check, { className: "mb-10px fs-7", type: "checkbox", id: "check-subsribe" }, /* @__PURE__ */ React4.createElement(Form2.Check.Input, { type: "checkbox", required: true }), /* @__PURE__ */ React4.createElement(Form2.Check.Label, null, "Accept", " ", /* @__PURE__ */ React4.createElement(
    "a",
    {
      className: "fw-semibold text-inherit",
      target: "_blank",
      href: "https://aesirx.io/terms-conditions",
      rel: "noreferrer"
    },
    "Terms"
  ), " ", "&", " ", /* @__PURE__ */ React4.createElement(
    "a",
    {
      className: "fw-semibold text-inherit",
      target: "_blank",
      href: "https://aesirx.io/privacy-policy",
      rel: "noreferrer"
    },
    "Privacy Policy"
  ), " ")), /* @__PURE__ */ React4.createElement("div", { className: "d-flex align-items-start flex-wrap" }, /* @__PURE__ */ React4.createElement("div", { className: `me-4 mb-2 ${isRequireConcordium ? "w-100" : ""}` }, /* @__PURE__ */ React4.createElement(FriendlyCaptcha_default, { setCaptcha })), isRequireConcordium && !showCreateButton && /* @__PURE__ */ React4.createElement("div", { className: "w-auto" }, /* @__PURE__ */ React4.createElement(Suspense, { fallback: /* @__PURE__ */ React4.createElement(React4.Fragment, null, "Loading...") }, /* @__PURE__ */ React4.createElement(
    Concordium_default,
    {
      noSignUpForm: true,
      setWalletState,
      setIsAccountExist: () => {
      },
      disabled: !formik.isValid,
      setExpand: async () => {
        const signedNonce = await getNonce(
          walletState?.accountAddress,
          walletState?.connection,
          "Create AesirX Account: {}"
        );
        if (signedNonce) {
          setSignatureLinkAccount(signedNonce);
          signedNonce && setShowCreateButton(true);
        }
      }
    }
  ))), showCreateButton && /* @__PURE__ */ React4.createElement(React4.Fragment, null, !isSellix && !license?.sellix_id ? /* @__PURE__ */ React4.createElement(
    Button,
    {
      disabled: sending || !captcha || !formik.isValid || noLogin && !proof && walletState?.wallet === "concordium",
      type: "submit",
      variant: "success",
      className: "fw-semibold text-white px-4 py-13px lh-sm w-100"
    },
    sending ? "Creating..." : "Create account"
  ) : !captcha || !formik.isValid ? /* @__PURE__ */ React4.createElement(
    Button,
    {
      disabled: sending || !captcha || !formik.isValid || noLogin && !proof && walletState?.wallet === "concordium",
      type: "submit",
      variant: "success",
      className: "fw-semibold text-white px-4 py-13px lh-sm w-100"
    },
    sending ? "Sending" : "Proceed to Purchase"
  ) : alertButton?.isShow && alertButton?.handleClick ? /* @__PURE__ */ React4.createElement(
    Button,
    {
      onClick: alertButton?.handleClick,
      variant: "success",
      className: "fw-semibold text-white px-4 py-13px lh-sm w-100"
    },
    "Proceed to Purchase"
  ) : /* @__PURE__ */ React4.createElement("div", { key: product?.sku }, /* @__PURE__ */ React4.createElement(
    Button,
    {
      disabled: sending || !captcha || !formik.isValid,
      onClick: handleStripe,
      variant: "success",
      className: "fw-semibold text-white px-4 py-13px lh-sm w-100"
    },
    sending ? "Sending" : "Proceed to Purchase"
  )), alertButton?.alertWarning && alertButton?.alertWarning))) : /* @__PURE__ */ React4.createElement("p", { className: "mb-0 text-danger fw-medium" }, "Apologies, an error occurred while retrieving the data.") : "Get data...");
};
var CreateAccount_default = CreateAccount;

// src/SSOButton/Providers/Concordium/sign.tsx
import { stringMessage as stringMessage2 } from "@concordium/react-components";
import { isMobile as isMobile2 } from "react-device-detect";
var SignMessageConcordium = ({
  account,
  connection,
  setIsAccountExist,
  setExpand,
  setAccountInfo,
  noSignUpForm
}) => {
  const [status, setStatus] = useState2("");
  const [isExist, setIsExist] = useState2(true);
  const [proof, setProof] = useState2(false);
  const [loading, setLoading] = useState2(false);
  const [show, setShow] = useState2(false);
  const wallet = "concordium";
  const { noCreateAccount, isSignUpForm, handleOnData, toggle, isRequireEmail } = useContext2(SSOModalContext);
  const { getWalletNonce, verifySignature } = useWallet_default(wallet, account);
  const handleConnect = async () => {
    setStatus("connect");
    const nonce = await getWalletNonce();
    if (nonce) {
      try {
        setStatus("sign");
        const signature = await connection.signMessage(account, stringMessage2(`${nonce}`));
        const convertedSignature = typeof signature === "object" && signature !== null ? signature : JSON.parse(signature);
        if (signature) {
          const data = await verifySignature(wallet, account, convertedSignature);
          if (isRequireEmail) {
            const member = await getMember(data?.access_token);
            if (!member?.email || /@aesirx\.io$/.test(member?.email) && (member?.wallet_concordium && member?.email?.includes(member?.wallet_concordium) || member?.wallet_metamask && member?.email?.includes(member?.wallet_metamask))) {
              setExpand("require-email");
              setAccountInfo({ data, memberId: member?.member_id });
            } else {
              handleOnData({ ...data, loginType: "concordium" });
            }
          } else {
            handleOnData({ ...data, loginType: "concordium" });
          }
        }
      } catch (error) {
        toast4(error.message);
      }
    } else {
      !noCreateAccount && setIsExist(false);
      setIsAccountExist({ status: false, type: "concordium" });
    }
    setStatus("");
  };
  const handleCreate = async () => {
    setStatus("loading");
    try {
      const checkAccount = await checkWalletAccount(account, wallet);
      if (!checkAccount?.data?.result) {
        if (!proof) {
          const responseProof = await handleProof();
          if (responseProof) {
            setShow(true);
            setExpand("wallet-concordium");
          }
        } else {
          setShow(true);
          setExpand("wallet-concordium");
        }
      } else {
        toast4.error("You've already created an account with this wallet.");
      }
      setStatus("");
    } catch (error) {
      console.log(error);
      setStatus("");
      toast4.error(error?.response?.data?.error || error?.message);
    }
  };
  const handleProof = async () => {
    setLoading(true);
    try {
      const challenge = await getChallenge(account ?? "");
      const statement = await getStatement();
      const formattedStatement = [
        {
          statement,
          idQualifier: {
            type: "cred",
            issuers: [0, 1, 2, 3, 4]
          }
        }
      ];
      const presentation = await connection.requestVerifiablePresentation(
        challenge,
        formattedStatement
      );
      if (presentation) {
        setProof(true);
        setLoading(false);
      }
      return true;
    } catch (error) {
      setProof(false);
      setLoading(false);
      return false;
    }
  };
  const handleSuccess = async () => {
    setShow(false);
    setExpand("wallet");
    setIsAccountExist({ status: true, type: "" });
  };
  return /* @__PURE__ */ React5.createElement(React5.Fragment, null, show && !noSignUpForm ? /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement("div", { className: "text-start" }, /* @__PURE__ */ React5.createElement(
    "div",
    {
      className: "cursor-pointer fw-medium fs-14 d-inline-flex align-items-center back-button text-primary",
      onClick: () => {
        setShow(false);
        setExpand("wallet");
        setIsAccountExist({ status: true, type: "" });
      }
    },
    /* @__PURE__ */ React5.createElement("img", { src: arrow_left_default, alt: "Back Icon", className: "me-1" }),
    "Back"
  )), /* @__PURE__ */ React5.createElement("div", { className: "text-primary" }, /* @__PURE__ */ React5.createElement(
    CreateAccount_default,
    {
      setShow: isSignUpForm ? toggle : handleSuccess,
      setIsExist,
      setIsAccountExist,
      accountAddress: account,
      connection,
      wallet: "concordium",
      isRequireEmail
    }
  ))) : /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(
    "button",
    {
      disabled: status !== "" || loading,
      type: "button",
      className: "btn btn-dark btn-concordium w-100 fw-medium py-2 px-4 fs-18 lh-sm text-white d-flex align-items-center text-start",
      onClick: () => {
        !isExist || isSignUpForm ? handleCreate() : handleConnect();
      }
    },
    status ? /* @__PURE__ */ React5.createElement("div", { className: "d-flex align-items-center" }, /* @__PURE__ */ React5.createElement(
      "span",
      {
        className: "spinner-border spinner-border-sm me-1",
        role: "status",
        "aria-hidden": "true"
      }
    ), /* @__PURE__ */ React5.createElement("span", { className: "ms-1" }, status === "sign" ? `Please sign message on the wallet ${isMobile2 ? "and wait for verification." : ""}` : status === "loading" ? "Connecting..." : `Please wait to connect...`)) : !isExist || isSignUpForm ? /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(
      "img",
      {
        src: concordium_default,
        className: "me-3 align-text-bottom",
        alt: "Concordium logo",
        width: 24
      }
    ), loading ? /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(
      "span",
      {
        className: "spinner-border spinner-border-sm me-1",
        role: "status",
        "aria-hidden": "true"
      }
    ), /* @__PURE__ */ React5.createElement("span", { className: "ms-1" }, !proof ? "Authorizing" : "Loading...")) : /* @__PURE__ */ React5.createElement(React5.Fragment, null, "Create account via Concordium (", account && shortenString(account), ")")) : /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(
      "img",
      {
        src: concordium_default,
        className: "me-3 align-text-bottom",
        alt: "Concordium logo",
        width: 24
      }
    ), "Sign in via Concordium (", account && shortenString(account), ")")
  )));
};
var sign_default = SignMessageConcordium;

// src/SSOButton/Providers/Concordium/index.tsx
import secureLocalStorage from "react-secure-storage";

// src/components/ComponentTags.tsx
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { FontAwesomeIcon as FontAwesomeIcon3 } from "@fortawesome/react-fontawesome";
import React8 from "react";

// src/components/ButtonCopy.tsx
import React7 from "react";
import { FontAwesomeIcon as FontAwesomeIcon2 } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";

// src/SSOButton/images/copy_icon.png
var copy_icon_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADTSURBVHgB7ZOxDcIwFEQv3/SwAYYg4ZINYANWgAlgA8QEwAQwStjANCgRJMoGDIDsTygSSGQKEkqu8j/53smSP9BQXtWQUkkhsPoUYGadJNEun1vVC0S85IxrgSPcjQs5UKf0GgYlwLOZCDNmdMhDkMbhwQXo9dREMGRRmB+EsCPPQxdfqgAYUAc1RGioP6AOgLhtDN3y8fUTyWi2tGHiuWXa9H21d+UZCAB7yufSLvT94Tazppm5doUNkU4vZ/3ulXYhiaOl9JXO3jV2AXC3AX6tB0nbPJJGhFMrAAAAAElFTkSuQmCC";

// src/components/ButtonCopy.tsx
import { useState as useState3 } from "react";

// src/components/ImageIcon.tsx
import React6 from "react";
var ImageIcon = ({ width, height, src, className }) => {
  return /* @__PURE__ */ React6.createElement(
    "span",
    {
      className: `icon-image d-inline-block align-text-bottom ${className}`,
      style: {
        width: `${width ?? 24}px`,
        height: `${height ?? 24}px`,
        WebkitMaskImage: `url(${src})`,
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskSize: "contain"
      }
    }
  );
};
var ImageIcon_default = ImageIcon;

// src/components/ButtonCopy.tsx
function ButtonCopy({ content, className, text, isBlack = false, isReplaceClass, iconClass }) {
  const [copy, setCopy] = useState3(false);
  const handleCopy = (content2) => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1500);
    navigator.clipboard.writeText(content2);
  };
  const customClass = isReplaceClass ? className : `fs-8 lh-base font-opensans fw-bold btn btn-success text-body cursor-copy ${className}`;
  return /* @__PURE__ */ React7.createElement("button", { onClick: () => handleCopy(content), disabled: copy, className: customClass }, !copy ? /* @__PURE__ */ React7.createElement(React7.Fragment, null, text, " ", isBlack ? /* @__PURE__ */ React7.createElement("div", { className: "d-flex align-items-center" }, /* @__PURE__ */ React7.createElement(
    ImageIcon_default,
    {
      className: iconClass || "icon-primary",
      src: copy_icon_default,
      width: 16,
      height: 16
    }
  )) : /* @__PURE__ */ React7.createElement(FontAwesomeIcon2, { icon: faCopy, width: 16, height: 16, className: "text-body" })) : "COPIED!");
}
var ButtonCopy_default = ButtonCopy;

// src/components/ComponentTags.tsx
var ComponentTags = ({ title, value, className, contentCopy }) => {
  return /* @__PURE__ */ React8.createElement(
    "div",
    {
      className: `custom_tags border text-dark rounded-1 mb-0 py-1 px-20px d-flex justify-content-between fw-semibold ${className}`
    },
    /* @__PURE__ */ React8.createElement("span", { className: "d-flex align-items-center" }, /* @__PURE__ */ React8.createElement(
      FontAwesomeIcon3,
      {
        icon: faCheckCircle,
        width: 16,
        height: 16,
        className: "text-success me-1"
      }
    ), title),
    /* @__PURE__ */ React8.createElement("p", { className: "mb-0" }, value, " ", contentCopy && /* @__PURE__ */ React8.createElement(
      ButtonCopy_default,
      {
        content: contentCopy,
        isBlack: true,
        className: "bg-transparent border-0 text-dark px-1"
      }
    ))
  );
};
var ComponentTags_default = ComponentTags;

// src/SSOButton/Providers/Concordium/index.tsx
import { BlockHash } from "@concordium/web-sdk";
var SSOConcordiumProvider = ({
  setIsAccountExist,
  setExpand,
  setAccountInfo,
  noLogin,
  setAccountAddress,
  setConnection,
  setWalletType,
  noSignUpForm = false,
  setWalletState,
  disabled
}) => {
  const { network: network2 } = getClientApp();
  return /* @__PURE__ */ React9.createElement(WithWalletConnector, { network: network2 === "testnet" ? TESTNET : MAINNET }, (props) => /* @__PURE__ */ React9.createElement(
    ConcordiumApp,
    {
      ...props,
      setIsAccountExist,
      setExpand,
      setAccountInfo,
      noLogin,
      setAccountAddress,
      setConnectionProvider: setConnection,
      setWalletType,
      noSignUpForm,
      setWalletState,
      disabled
    }
  ));
};
var ConcordiumApp = (props) => {
  const {
    activeConnectorType,
    activeConnector,
    activeConnectorError,
    network: network2,
    connectedAccounts,
    genesisHashes,
    setActiveConnectorType,
    setIsAccountExist,
    setExpand,
    setAccountInfo,
    noLogin,
    setAccountAddress,
    setConnectionProvider,
    setWalletType,
    noSignUpForm,
    setWalletState,
    disabled
  } = props;
  const { connection, setConnection, account, genesisHash } = useConnection(
    connectedAccounts,
    genesisHashes
  );
  const { connect, connectError, isConnecting } = useConnect(activeConnector, setConnection);
  const [rpcGenesisHash, setRpcGenesisHash] = useState4();
  const [rpcError, setRpcError] = useState4("");
  const rpc = useGrpcClient(network2);
  useEffect3(() => {
    if (rpc) {
      setRpcGenesisHash(void 0);
      rpc.getConsensusStatus().then((status) => {
        return status.genesisBlock;
      }).then((hash) => {
        const { network: network3 } = getClientApp();
        let r = false;
        switch (network3) {
          case "testnet":
            r = BlockHash.toHexString(hash) === TESTNET.genesisHash;
            break;
          default:
            r = BlockHash.toHexString(hash) === MAINNET.genesisHash;
        }
        if (!r) {
          const { network: network4 } = getClientApp();
          throw new Error(`Please change the network to ${network4} in Wallet`);
        }
        setRpcGenesisHash(hash);
        setRpcError("");
      }).catch((err) => {
        setRpcGenesisHash(void 0);
        toast5(err.message);
        setRpcError(err.message);
      });
    }
  }, [rpc]);
  useEffect3(() => {
    if (activeConnector) {
      connect();
    }
  }, [activeConnector]);
  useEffect3(() => {
    if (setAccountAddress) {
      if (account && connection) {
        setAccountAddress(account);
        setConnectionProvider(connection);
        setWalletType("concordium");
      } else {
        setAccountAddress("");
        setConnectionProvider(null);
        setWalletType("");
      }
    }
    if (setWalletState) {
      if (account && connection) {
        setWalletState({ wallet: "concordium", accountAddress: account, connection });
      }
    }
  }, [account, connection]);
  useEffect3(() => {
    if (connectError && connectError !== "A listener indicated an asynchronous response by returning true, but the message channel closed before a response was received") {
      toast5(connectError);
    }
  }, [connectError]);
  const handleOnConnect = async (connectorType, name) => {
    secureLocalStorage.setItem("concordium", name);
    await setActiveConnectorType(connectorType);
  };
  return /* @__PURE__ */ React9.createElement(React9.Fragment, null, !account || rpcError ? /* @__PURE__ */ React9.createElement(
    connect_default,
    {
      isConnecting,
      handleOnConnect,
      activeConnectorError,
      activeConnectorType,
      activeConnector,
      noLogin,
      disabled
    }
  ) : /* @__PURE__ */ React9.createElement(React9.Fragment, null, rpcGenesisHash ? noLogin ? /* @__PURE__ */ React9.createElement(
    ComponentTags_default,
    {
      className: "mb-12px",
      title: "Account Connected:",
      value: shortenString(account, 20, 5),
      contentCopy: account
    }
  ) : /* @__PURE__ */ React9.createElement(
    sign_default,
    {
      account,
      connection,
      setIsAccountExist,
      setExpand,
      setAccountInfo,
      noSignUpForm,
      setWalletState
    }
  ) : /* @__PURE__ */ React9.createElement("button", { className: "btn btn-dark" }, /* @__PURE__ */ React9.createElement(
    "span",
    {
      className: "spinner-border spinner-border-sm me-1",
      role: "status",
      "aria-hidden": "true"
    }
  ))), activeConnectorError && /* @__PURE__ */ React9.createElement("div", { className: "mt-1 fs-7 text-danger text-start" }, "Connector error: ", activeConnectorError, "."), rpcError && /* @__PURE__ */ React9.createElement("div", { className: "mt-1 fs-7 text-danger text-start" }, "RPC error: ", rpcError));
};
var Concordium_default = SSOConcordiumProvider;

// src/SSOButton/Providers/Ethereum/index.tsx
import React12, { useEffect as useEffect4 } from "react";
import { configureChains, createConfig, WagmiConfig, useAccount as useAccount2 } from "wagmi";
import { EthereumClient, w3mConnectors, w3mProvider } from "@web3modal/ethereum";
import {
  arbitrum,
  arbitrumGoerli,
  aurora,
  auroraTestnet,
  avalanche,
  avalancheFuji,
  baseGoerli,
  bronos,
  bronosTestnet,
  bsc,
  bscTestnet,
  canto,
  celo,
  celoAlfajores,
  crossbell,
  evmos,
  evmosTestnet,
  fantom,
  fantomTestnet,
  filecoin,
  filecoinCalibration,
  filecoinHyperspace,
  foundry,
  gnosis,
  gnosisChiado,
  goerli,
  hardhat,
  harmonyOne,
  iotex,
  iotexTestnet,
  localhost,
  mainnet,
  metis,
  metisGoerli,
  moonbaseAlpha,
  moonbeam,
  moonriver,
  okc,
  optimism,
  optimismGoerli,
  polygon,
  polygonMumbai,
  polygonZkEvmTestnet,
  sepolia,
  taraxa,
  taraxaTestnet,
  telos,
  telosTestnet,
  zkSync,
  zkSyncTestnet
} from "wagmi/chains";
import { Web3Modal } from "@web3modal/react";

// src/SSOButton/Providers/Ethereum/sign.tsx
import React10, { useContext as useContext3, useState as useState5 } from "react";
import { useSignMessage } from "wagmi";
import { verifyMessage } from "ethers";
import { useAccount } from "wagmi";

// src/SSOButton/images/ethereum_logo.png
var ethereum_logo_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAhCAYAAAA2/OAtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAI/SURBVHgBxVY9SEJRFD6vokgIAqea3uTUIDS5Ra4GtbiqY1POLRkEDSHmFE3RFi4NOrXkFARGDkLkotEQ/QiBYBSFfUfPq+fzvvd8JvTBx33v3nM+z73n3PMkGhDtdjtKowQE42AJDNIoACEdrIloBvS5+YyROzZAXZ5ZMOLm4CjKUWJIWqbDmA/QsKLAuc38Cg0jysmh321bEcB6mLyIyra3yBkRu6TZRZoi+ygNsGB0IFH8+iqGGA2GkCppqkgz5A1xR1H8Kp+jTt7gh19P7WomQR1DTeH0IPMn4Au4CM5YbFrgjqZpDX6ZMC2kFGIlGRnvYFWogwvgvKxx0uJg+kdUajImjnfgrUlMhbpwRiLnZHHtBhBtVcPDLCYuwSZYEWEVroQqGOKTYJYjnQPz1H9OXsABFcFPcHoM4d7gYRe8oL/hCaxwsjTJOuGljmc/dW+JqhnbbZ+jrMP/Q/x9nZLCyz4PYFbEQ9TtRH4H0U5SYd+UHhCR4HKGKCfrWoxTWDiWeTbkbuQzifK5PYOPsPuSbsV2b9St1Za5+IMm4TqYgEFRtsROU+AZeC9iAdmNcfc3jeLvAQyT7V4cGWeOcVxGvpbr4KGJ6mtqEuZuv2SZToF7chTLchwGyojwwE1Up+5nRLcsqbLP201bt93X+jj7GBI0GHKqc1R2fk4Qhiw5Iw+7smrB9sMHB/40l22WG1gv2Pm6faLXwFfLHPfOtJOTo6ic77ZluqCsR69ARZzKf6k4jQp8jaXI/fRf+AaHjRu6xDEXQwAAAABJRU5ErkJggg==";

// src/SSOButton/Providers/Ethereum/sign.tsx
import { toast as toast6 } from "react-toastify";
var SignMessage = ({ setIsAccountExist, setExpand, setAccountInfo }) => {
  const wallet = "metamask";
  const { address, connector } = useAccount();
  const { getWalletNonce, verifySignature } = useWallet_default(wallet, address);
  const [status, setStatus] = useState5("");
  const { noCreateAccount, isSignUpForm, handleOnData, toggle, isRequireEmail } = useContext3(SSOModalContext);
  const [isExist, setIsExist] = useState5(true);
  const [show, setShow] = useState5(false);
  const { isLoading, signMessage } = useSignMessage({
    async onSuccess(data, variables) {
      const address2 = verifyMessage(variables.message, data);
      const res = await verifySignature(wallet, address2, data);
      if (isRequireEmail) {
        const member = await getMember(res?.access_token);
        if (!member?.email || /@aesirx\.io$/.test(member?.email) && (member?.wallet_concordium && member?.email?.includes(member?.wallet_concordium) || member?.wallet_metamask && member?.email?.includes(member?.wallet_metamask))) {
          setExpand("require-email");
          setAccountInfo({ data: res, memberId: member?.member_id });
        } else {
          handleOnData({ ...res, loginType: "metamask" });
        }
      } else {
        handleOnData({ ...res, loginType: "metamask" });
      }
    }
  });
  const handleSignMessage = async () => {
    setStatus("connect");
    const nonce = await getWalletNonce();
    if (nonce) {
      setStatus("sign");
      signMessage({ message: `${nonce}` });
    } else {
      !noCreateAccount && setIsExist(false);
      setIsAccountExist({ status: false, type: "metamask" });
    }
    setStatus("");
  };
  const handleSuccess = async () => {
    setShow(false);
    setExpand("wallet");
    setIsAccountExist({ status: true, type: "" });
  };
  return /* @__PURE__ */ React10.createElement(React10.Fragment, null, show ? /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement("div", { className: "text-start" }, /* @__PURE__ */ React10.createElement(
    "div",
    {
      className: "cursor-pointer fw-medium fs-14 d-inline-flex align-items-center back-button text-primary",
      onClick: () => {
        setShow(false);
        setExpand("wallet");
        setIsAccountExist({ status: true, type: "" });
      }
    },
    /* @__PURE__ */ React10.createElement("img", { src: arrow_left_default, alt: "Back Icon", className: "me-1" }),
    "Back"
  )), /* @__PURE__ */ React10.createElement("div", { className: "text-primary" }, /* @__PURE__ */ React10.createElement(
    CreateAccount_default,
    {
      setShow: isSignUpForm ? toggle : handleSuccess,
      setIsExist,
      setIsAccountExist,
      accountAddress: address,
      connection: connector,
      wallet: "metamask",
      isRequireEmail
    }
  ))) : /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(
    "button",
    {
      disabled: isLoading,
      className: "btn btn-ethereum fw-medium px-4 fs-18 lh-sm w-100 btn-secondary text-white d-flex align-items-center text-start",
      onClick: async () => {
        if (!isExist || isSignUpForm) {
          setStatus("loading");
          try {
            const checkAccount = await checkWalletAccount(address, wallet);
            if (!checkAccount?.data?.result) {
              setShow(true);
              setExpand("wallet-metamask");
            } else {
              toast6.error("You've already created an account with this wallet.");
            }
            setStatus("");
          } catch (error) {
            setStatus("");
            console.log(error);
            toast6.error(error?.response?.data?.error || error?.message);
          }
        } else {
          handleSignMessage();
        }
      }
    },
    status ? /* @__PURE__ */ React10.createElement("div", { className: "d-flex align-items-center" }, /* @__PURE__ */ React10.createElement(
      "span",
      {
        className: "spinner-border spinner-border-sm me-1",
        role: "status",
        "aria-hidden": "true"
      }
    ), /* @__PURE__ */ React10.createElement("span", { className: "ms-1" }, status === "sign" ? `Please sign message via ${connector?.name}` : status === "loading" ? "Connecting..." : `Please wait to connect... via ${connector?.name}`)) : !isExist || isSignUpForm ? /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement("img", { className: "me-3", src: ethereum_logo_default, alt: "Ethereum Logo" }), "Create account via ", connector?.name, " (", address && shortenString(address), ")") : /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement("img", { className: "me-3", src: ethereum_logo_default, alt: "Ethereum Logo" }), "Sign in via ", connector?.name, " (", address && shortenString(address), ")")
  )));
};
var sign_default2 = SignMessage;

// src/SSOButton/Providers/Ethereum/connect.tsx
import { useWeb3Modal } from "@web3modal/react";
import React11, { useState as useState6 } from "react";
var ConnectMetamask = () => {
  const [loading, setLoading] = useState6(false);
  const { open: open2 } = useWeb3Modal();
  async function onOpen() {
    setLoading(true);
    await open2();
    setLoading(false);
  }
  return /* @__PURE__ */ React11.createElement(
    "button",
    {
      onClick: onOpen,
      disabled: loading,
      className: "btn btn-ethereum fw-medium px-4 fs-18 lh-sm w-100 btn-secondary text-white d-flex align-items-center justify-content-start"
    },
    loading ? /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(
      "span",
      {
        className: "spinner-border spinner-border-sm me-1",
        role: "status",
        "aria-hidden": "true"
      }
    ), "Waiting for signing...") : /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement("img", { className: "me-3", src: ethereum_logo_default, alt: "Ethereum Logo" }), "Ethereum wallets")
  );
};
var connect_default2 = ConnectMetamask;

// src/SSOButton/Providers/Ethereum/index.tsx
import { CONCORDIUM_WALLET_CONNECT_PROJECT_ID as CONCORDIUM_WALLET_CONNECT_PROJECT_ID2 } from "@concordium/react-components";
var chains = [
  arbitrum,
  arbitrumGoerli,
  aurora,
  auroraTestnet,
  avalanche,
  avalancheFuji,
  baseGoerli,
  bronos,
  bronosTestnet,
  bsc,
  bscTestnet,
  canto,
  celo,
  celoAlfajores,
  crossbell,
  evmos,
  evmosTestnet,
  fantom,
  fantomTestnet,
  filecoin,
  filecoinCalibration,
  filecoinHyperspace,
  foundry,
  gnosis,
  gnosisChiado,
  goerli,
  hardhat,
  harmonyOne,
  iotex,
  iotexTestnet,
  localhost,
  mainnet,
  metis,
  metisGoerli,
  moonbaseAlpha,
  moonbeam,
  moonriver,
  okc,
  optimism,
  optimismGoerli,
  polygon,
  polygonMumbai,
  polygonZkEvmTestnet,
  sepolia,
  taraxa,
  taraxaTestnet,
  telos,
  telosTestnet,
  zkSync,
  zkSyncTestnet
];
var projectId = CONCORDIUM_WALLET_CONNECT_PROJECT_ID2;
var { publicClient, webSocketPublicClient } = configureChains(chains, [
  w3mProvider({ projectId })
]);
var wagmiConfig = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, chains }),
  publicClient,
  webSocketPublicClient
});
var ethereumClient = new EthereumClient(wagmiConfig, chains);
var SSOEthereumProvider = ({
  setIsAccountExist,
  setExpand,
  noLogin,
  accountAddress,
  setAccountAddress,
  setConnection,
  setWalletType,
  setAccountInfo
}) => {
  return /* @__PURE__ */ React12.createElement(React12.Fragment, null, /* @__PURE__ */ React12.createElement(WagmiConfig, { config: wagmiConfig }, /* @__PURE__ */ React12.createElement(
    SSOEthereumApp,
    {
      setIsAccountExist,
      setExpand,
      noLogin,
      accountAddress,
      setAccountAddress,
      setConnection,
      setWalletType,
      setAccountInfo
    }
  )), /* @__PURE__ */ React12.createElement(Web3Modal, { projectId, ethereumClient }));
};
var SSOEthereumApp = ({
  setIsAccountExist,
  setExpand,
  noLogin,
  accountAddress,
  setAccountAddress,
  setConnection,
  setWalletType,
  setAccountInfo
}) => {
  const { address, isConnected, connector } = useAccount2();
  useEffect4(() => {
    if (setAccountAddress) {
      if (address && connector) {
        setAccountAddress(address);
        setConnection(connector);
        setWalletType("metamask");
      } else {
        setAccountAddress("");
        setConnection(null);
        setWalletType("");
      }
    }
  }, [address, connector]);
  return isConnected ? noLogin ? /* @__PURE__ */ React12.createElement(React12.Fragment, null, accountAddress ? /* @__PURE__ */ React12.createElement(
    ComponentTags_default,
    {
      className: "mb-12px",
      title: "Account Connected:",
      value: shortenString(address, 20, 5),
      contentCopy: address
    }
  ) : /* @__PURE__ */ React12.createElement(
    "button",
    {
      onClick: () => {
        setAccountAddress(address);
        setConnection(connector);
        setWalletType("metamask");
      },
      className: "btn btn-ethereum fw-medium px-4 fs-18 lh-sm w-100 btn-secondary text-white d-flex align-items-center justify-content-start"
    },
    /* @__PURE__ */ React12.createElement("img", { className: "me-3", src: ethereum_logo_default, alt: "Ethereum Logo" }),
    "Ethereum wallets"
  )) : /* @__PURE__ */ React12.createElement(
    sign_default2,
    {
      setIsAccountExist,
      setExpand,
      setAccountInfo
    }
  ) : /* @__PURE__ */ React12.createElement(connect_default2, null);
};
var Ethereum_default = SSOEthereumProvider;

// src/SSOButton/Providers/Email/index.tsx
import React13, { useContext as useContext4, useState as useState7 } from "react";
import axios4 from "axios";
import { toast as toast7 } from "react-toastify";
import { env as env3 } from "aesirx-lib";
var SSOEmailProvider = ({
  btnClass = "",
  spacingClass = "",
  noLabel = false,
  forgotPasswordLink = ""
}) => {
  const [loading, setLoading] = useState7(false);
  const { handleOnData, demoUser, demoPassword } = useContext4(SSOModalContext);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const { endpoint, client_id, client_secret } = getClientApp();
      const form = event.target;
      const formData = new FormData(form);
      const queryString = typeof window !== "undefined" && window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const organisationParams = urlParams.get("organisationId");
      const returnParams = urlParams.get("return");
      const channelTypeParams = urlParams.get("channel_type");
      const reqAuthFormData = {
        username: formData.get("ssoemail"),
        password: formData.get("ssoepassword"),
        client_id,
        client_secret,
        grant_type: "password",
        ...channelTypeParams && { channel_type: channelTypeParams },
        ...returnParams && { return: returnParams },
        ...organisationParams && { organisationId: organisationParams }
      };
      const ssoState = env3.REACT_APP_HEADER_JWT === "true" ? "noscopes" : "";
      const config = {
        method: "post",
        url: `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=token&api=oauth2${ssoState === "noscopes" ? "&state=noscopes" : ""}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: reqAuthFormData
      };
      const { data: result } = await axios4(config);
      handleOnData(result);
      setLoading(false);
    } catch (error) {
      console.log("errorerrorerror", error);
      toast7("Wrong authentication", { closeOnClick: false });
      setLoading(false);
      return false;
    }
  };
  return /* @__PURE__ */ React13.createElement("form", { onSubmit: handleSubmit }, demoUser && demoUser && /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement("h5", { className: "text-primary" }, "Demo email: ", demoUser, " "), /* @__PURE__ */ React13.createElement("h5", { className: "mb-3 text-primary" }, "Demo password: ", demoPassword, " ")), /* @__PURE__ */ React13.createElement("div", { className: `${spacingClass ? spacingClass : "mb-4"}` }, !noLabel && /* @__PURE__ */ React13.createElement("label", { htmlFor: "ssoemail", className: "form-label text-primary mb-2" }, "Email address"), /* @__PURE__ */ React13.createElement(
    "input",
    {
      type: "email",
      className: "form-control lh-sm border",
      name: "ssoemail",
      defaultValue: demoUser
    }
  )), /* @__PURE__ */ React13.createElement("div", { className: `${spacingClass ? spacingClass : "mb-4"}` }, !noLabel && /* @__PURE__ */ React13.createElement("label", { htmlFor: "ssoepassword", className: "form-label text-primary mb-2" }, "Password"), /* @__PURE__ */ React13.createElement(
    "input",
    {
      type: "password",
      className: "form-control lh-sm border",
      name: "ssoepassword",
      defaultValue: demoPassword,
      required: true
    }
  )), /* @__PURE__ */ React13.createElement("p", { className: `text-end ${spacingClass ? spacingClass : "mb-4"}` }, /* @__PURE__ */ React13.createElement(
    "a",
    {
      target: "_blank",
      rel: "noopener noreferrer",
      href: `${forgotPasswordLink ? forgotPasswordLink : "https://dapp.shield.aesirx.io/auth/forgot-password"}`,
      className: "text-decoration-none"
    },
    "Forgot password ?"
  )), /* @__PURE__ */ React13.createElement(
    "button",
    {
      type: "submit",
      className: `${btnClass ? btnClass : "btn btn-success w-100 lh-sm text-white fw-semibold"}`
    },
    loading ? /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(
      "span",
      {
        className: "spinner-border spinner-border-sm me-1",
        role: "status",
        "aria-hidden": "true"
      }
    ), "Waiting...") : "Login"
  ));
};
var Email_default = SSOEmailProvider;

// src/SSOButton/Providers/Email/update.tsx
import React14, { useCallback as useCallback2, useContext as useContext5, useState as useState8 } from "react";
import { toast as toast8 } from "react-toastify";
import { useFormik as useFormik2 } from "formik";
import * as Yup2 from "yup";
import { debounce as debounce2 } from "lodash";
import { Form as Form3 } from "react-bootstrap";
import { FontAwesomeIcon as FontAwesomeIcon4 } from "@fortawesome/react-fontawesome";
import { faCircleExclamation as faCircleExclamation2 } from "@fortawesome/free-solid-svg-icons";
var SSOUpdateEmailProvider = ({ accountInfo }) => {
  const [loading, setLoading] = useState8(false);
  const { handleOnData } = useContext5(SSOModalContext);
  const debouncedCheckEmail = useCallback2(debounce2(validateEmail, 200), []);
  const generateValidationSchema = () => {
    const validationSchema = {};
    validationSchema["email"] = Yup2.string().email(`Please enter valid email`).required(`Please enter your email`).test(
      "unique",
      "This Email is already taken",
      async (value) => await debouncedCheckEmail(value)
    );
    return validationSchema;
  };
  const formik = useFormik2({
    initialValues: { email: "" },
    validationSchema: Yup2.object(generateValidationSchema()),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        console.log("accountInfo", accountInfo);
        const response = await updateMember(
          { id: accountInfo?.memberId, sendmail: 1, ...values },
          accountInfo?.data?.access_token
        );
        if (response?.result?.success) {
          handleOnData(accountInfo?.data);
        } else {
          toast8(response?.result?.message, { closeOnClick: false });
        }
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }
  });
  return /* @__PURE__ */ React14.createElement(Form3, { onSubmit: formik.handleSubmit }, /* @__PURE__ */ React14.createElement("div", { className: "mb-4" }, /* @__PURE__ */ React14.createElement("p", null, "Your account is missing an email address.", /* @__PURE__ */ React14.createElement("br", null), "Please update it to continue."), /* @__PURE__ */ React14.createElement(Form3.Group, { className: "mb-3 w-100" }, /* @__PURE__ */ React14.createElement(Form3.Label, { className: "mb-2" }, "Email address ", /* @__PURE__ */ React14.createElement("span", { className: "text-danger" }, "*")), /* @__PURE__ */ React14.createElement("div", { className: "position-relative" }, /* @__PURE__ */ React14.createElement(
    Form3.Control,
    {
      type: "email",
      name: "email",
      onChange: formik.handleChange,
      onBlur: formik.handleBlur,
      value: formik.values["email"],
      className: `py-13px lh-sm ${formik.touched["email"] && formik.errors["email"] ? "border-danger" : ""}`
    }
  )), formik.touched["email"] && formik.errors["email"] ? /* @__PURE__ */ React14.createElement("p", { className: "mt-2 mb-0 p-0 border-0 text-danger d-flex align-items-center" }, /* @__PURE__ */ React14.createElement(FontAwesomeIcon4, { icon: faCircleExclamation2, width: 14, height: 14 }), /* @__PURE__ */ React14.createElement("span", { className: "fs-7 fw-semibold ms-2 lh-1" }, formik.errors["email"])) : null)), /* @__PURE__ */ React14.createElement("button", { type: "submit", className: "btn btn-success w-100 lh-sm text-white fw-semibold" }, loading ? /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(
    "span",
    {
      className: "spinner-border spinner-border-sm me-1",
      role: "status",
      "aria-hidden": "true"
    }
  ), "Waiting...") : "Update"));
};
var update_default = SSOUpdateEmailProvider;

// src/SSOButton/Providers/Social/index.tsx
import React15, { useContext as useContext6, useEffect as useEffect5, useState as useState9 } from "react";
import axios5 from "axios";

// src/SSOButton/images/logo_facebook.svg
var logo_facebook_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 40 40">%0A  <linearGradient id="a" x1="-277.375" x2="-277.375" y1="406.6018" y2="407.5726" gradientTransform="matrix(40 0 0 -39.7778 11115.001 16212.334)" gradientUnits="userSpaceOnUse">%0A    <stop offset="0" stop-color="%230062e0"/>%0A    <stop offset="1" stop-color="%2319afff"/>%0A  </linearGradient>%0A  <path fill="url(%23a)" d="M16.7 39.8C7.2 38.1 0 29.9 0 20 0 9 9 0 20 0s20 9 20 20c0 9.9-7.2 18.1-16.7 19.8l-1.1-.9h-4.4l-1.1.9z"/>%0A  <path fill="%23fff" d="m27.8 25.6.9-5.6h-5.3v-3.9c0-1.6.6-2.8 3-2.8H29V8.2c-1.4-.2-3-.4-4.4-.4-4.6 0-7.8 2.8-7.8 7.8V20h-5v5.6h5v14.1c1.1.2 2.2.3 3.3.3 1.1 0 2.2-.1 3.3-.3V25.6h4.4z"/>%0A</svg>';

// src/SSOButton/images/logo_google.svg
var logo_google_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="%234285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="%2334A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="%23FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="%23EA4335"/><path d="M1 1h22v22H1z" fill="none"/></svg>';

// src/SSOButton/images/logo_twitter.svg
var logo_twitter_default = 'data:image/svg+xml,<?xml version="1.0" encoding="UTF-8"?>%0A<svg width="300" height="271" xmlns="http://www.w3.org/2000/svg">%0A <path d="m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z"/>%0A</svg>';

// src/SSOButton/images/reddit_icon.png
var reddit_icon_default = "data:image/png;base64,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";

// src/SSOButton/Providers/Social/index.tsx
import { Button as Button2 } from "react-bootstrap";
import { toast as toast9 } from "react-toastify";
var SSOSocialProvider = ({
  typeSocial,
  isAccountExist,
  setIsAccountExist,
  setExpand,
  setAccountInfo
}) => {
  const [loading, setLoading] = useState9(false);
  const [idSocial, setIdSocial] = useState9("");
  const { noCreateAccount, isSignUpForm, handleOnData, toggle, isRequireEmail } = useContext6(SSOModalContext);
  const { endpoint } = getClientApp();
  const [showCreate, setShowCreate] = useState9("");
  const [showCreatedMessage, setShowCreatedMessage] = useState9(false);
  const [isExist, setIsExist] = useState9(true);
  const handleSubmit = async (event, isCreate = false) => {
    event.preventDefault();
    setShowCreatedMessage(false);
    setLoading(true);
    try {
      const response = await axios5.get(
        `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=member&task=getSocialLoginUrl&api=hal&socialType=${typeSocial}`
      );
      response?.data.result[0] && window.open(response?.data.result[0], "SSO", "status=1,height=750,width=650");
      const handleLogin = async (e) => {
        if (e.origin !== endpoint)
          return;
        if (e.data && e.data.socialLogin) {
          if (isCreate) {
            setShowCreatedMessage(true);
          } else {
            const dataLogin = JSON.parse(e.data.socialLogin);
            if (isRequireEmail) {
              setLoading(true);
              const member = await getMember(dataLogin?.access_token);
              if (!member?.email || /@aesirx\.io$/.test(member?.email) && (member?.wallet_concordium && member?.email?.includes(member?.wallet_concordium) || member?.wallet_metamask && member?.email?.includes(member?.wallet_metamask))) {
                setExpand("require-email");
                setAccountInfo({ data: dataLogin, memberId: member?.member_id });
              } else {
                handleOnData(dataLogin);
              }
              setLoading(false);
            } else {
              handleOnData(dataLogin);
            }
          }
        } else if (e.data.error) {
          !noCreateAccount && setIsExist(false);
          setIsAccountExist({ status: false, type: typeSocial });
          setIdSocial(e.data.id);
          if (isCreate) {
            setExpand(`social-${typeSocial}`);
            setShowCreate(typeSocial);
          }
        }
        window.removeEventListener("message", handleLogin);
      };
      window.addEventListener("message", handleLogin, false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      return false;
    }
  };
  useEffect5(() => {
    showCreatedMessage && toast9.error("You've already created an account with this social media");
  }, [showCreatedMessage]);
  const handleSuccess = async () => {
    setShowCreate("");
    setExpand("social");
    setIdSocial("");
    setIsAccountExist({ status: true, type: "" });
  };
  return /* @__PURE__ */ React15.createElement(React15.Fragment, null, showCreate === typeSocial ? /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement("div", { className: "text-start" }, /* @__PURE__ */ React15.createElement(
    "div",
    {
      className: "cursor-pointer fw-medium fs-14 d-inline-flex align-items-center back-button text-primary",
      onClick: () => {
        setShowCreate("");
        setExpand("social");
        setIdSocial("");
        setIsAccountExist({ status: true, type: "" });
      }
    },
    /* @__PURE__ */ React15.createElement("img", { src: arrow_left_default, alt: "Back Icon", className: "me-1" }),
    "Back"
  )), /* @__PURE__ */ React15.createElement("div", { className: "text-primary" }, /* @__PURE__ */ React15.createElement(
    CreateAccount_default,
    {
      setShow: isSignUpForm ? toggle : handleSuccess,
      setIsAccountExist,
      isNoWallet: true,
      noLogin: true,
      socialType: { id: idSocial, type: typeSocial },
      isRequireEmail
    }
  ))) : /* @__PURE__ */ React15.createElement("div", { className: "mt-3" }, /* @__PURE__ */ React15.createElement(
    Button2,
    {
      variant: "outline",
      type: "button",
      onClick: (e) => {
        if (!isAccountExist?.status && isAccountExist?.type === typeSocial && (!isExist || isSignUpForm)) {
          if (idSocial) {
            setExpand(`social-${typeSocial}`);
            setShowCreate(typeSocial);
          } else {
            handleSubmit(e, true);
          }
        } else {
          handleSubmit(e);
        }
      },
      className: "w-100 lh-sm fw-semibold d-flex align-items-center"
    },
    loading ? /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(
      "span",
      {
        className: "spinner-border spinner-border-sm me-1",
        role: "status",
        "aria-hidden": "true"
      }
    ), "Waiting...") : /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(
      "img",
      {
        src: typeSocial === "google" ? logo_google_default : typeSocial === "facebook" ? logo_facebook_default : typeSocial === "twitter" ? logo_twitter_default : reddit_icon_default,
        width: 24,
        height: 24,
        alt: "Back Icon",
        className: `me-2 ${typeSocial === "twitter" ? "twitter-icon" : ""}`
      }
    ), !isAccountExist?.status && isAccountExist?.type === typeSocial && (!isExist || isSignUpForm) ? "Create account" : "Log in", " ", "with", /* @__PURE__ */ React15.createElement("span", { className: "text-capitalize ms-1" }, typeSocial?.charAt(0).toUpperCase() + typeSocial?.slice(1)))
  )));
};
var Social_default = SSOSocialProvider;

// src/SSOButton/Providers/index.tsx
var SSOProviders = ({ loginText, loginBg, forgotPasswordLink }) => {
  const [expand, setExpand] = useState10("");
  const [accountInfo, setAccountInfo] = useState10({});
  const [isAccountExist, setIsAccountExist] = useState10({ status: true, type: "" });
  const urlParams = new URLSearchParams(window.location.search);
  let login2 = ["concordium", "metamask", "regular"];
  if (urlParams.has("return")) {
    login2 = new URL(atob(urlParams.get("return"))).searchParams.getAll("login[]");
  }
  const hasMetamask = login2.length === 0 || login2.includes("metamask");
  const hasConcordium = login2.length === 0 || login2.includes("concordium");
  return /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement("div", { className: "row gx-0 align-items-center w-100" }, /* @__PURE__ */ React16.createElement("div", { className: "col-lg-7" }, /* @__PURE__ */ React16.createElement("div", { className: "pt-0 pb-4 px-4 block-wallet" }, /* @__PURE__ */ React16.createElement("div", { className: "py-4 px-lg-4" }, !expand ? /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement("img", { src: privacy_icon_default, alt: "Privacy Icon" }), /* @__PURE__ */ React16.createElement(
    "h3",
    {
      className: "fs-3 fw-semibold mt-2 mb-3 text-primary",
      dangerouslySetInnerHTML: { __html: `Welcome to ${loginText}` }
    }
  ), /* @__PURE__ */ React16.createElement("p", { className: "mb-20px fs-14" }, "Select your login method"), /* @__PURE__ */ React16.createElement(
    "button",
    {
      type: "button",
      className: "btn btn-success w-100 lh-sm text-white fw-semibold mb-18px",
      onClick: () => {
        setExpand("email");
      }
    },
    "Log in with Email and Password"
  ), /* @__PURE__ */ React16.createElement(
    "button",
    {
      type: "button",
      className: "btn btn-outline w-100 lh-sm fw-semibold mb-18px",
      onClick: () => {
        setExpand("social");
      }
    },
    "Log in with Social Media"
  ), /* @__PURE__ */ React16.createElement(
    "button",
    {
      type: "button",
      className: "btn btn-outline w-100 lh-sm fw-semibold",
      onClick: () => {
        setExpand("wallet");
      }
    },
    "Log in with Web3 Wallets"
  )) : expand === "social" || expand === "wallet" || expand === "email" ? /* @__PURE__ */ React16.createElement("div", { className: "text-start" }, /* @__PURE__ */ React16.createElement(
    "div",
    {
      className: "cursor-pointer fw-medium fs-14 d-inline-flex align-items-center back-button text-primary",
      onClick: () => {
        setExpand("");
        setIsAccountExist({ status: true, type: "" });
      }
    },
    /* @__PURE__ */ React16.createElement("img", { src: arrow_left_default, alt: "Back Icon", className: "me-1" }),
    "Back"
  )) : /* @__PURE__ */ React16.createElement(React16.Fragment, null), expand?.includes("wallet") && /* @__PURE__ */ React16.createElement(React16.Fragment, null, !isAccountExist?.status && (expand === "social" || expand === "wallet" || expand === "email") && /* @__PURE__ */ React16.createElement("div", { className: "bg-danger text-white px-3 py-2 rounded-2 d-flex align-items-center mb-3" }, /* @__PURE__ */ React16.createElement(
    "img",
    {
      className: "me-1",
      src: cancel_default,
      alt: "cancel Icon",
      width: "16px",
      height: "16px"
    }
  ), "Your account not exist"), (expand === "wallet" || expand === "wallet-metamask") && hasMetamask && /* @__PURE__ */ React16.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React16.createElement(Suspense2, { fallback: /* @__PURE__ */ React16.createElement(React16.Fragment, null, "Loading...") }, /* @__PURE__ */ React16.createElement(
    Ethereum_default,
    {
      setIsAccountExist,
      setExpand,
      setAccountInfo
    }
  ))), (expand === "wallet" || expand === "wallet-concordium") && hasConcordium && /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(Suspense2, { fallback: /* @__PURE__ */ React16.createElement(React16.Fragment, null, "Loading...") }, /* @__PURE__ */ React16.createElement(
    Concordium_default,
    {
      setIsAccountExist,
      setExpand,
      setAccountInfo
    }
  )))), expand === "email" && /* @__PURE__ */ React16.createElement("div", { className: "control-group" }, /* @__PURE__ */ React16.createElement(Suspense2, { fallback: /* @__PURE__ */ React16.createElement(React16.Fragment, null, "Loading...") }, /* @__PURE__ */ React16.createElement(Email_default, { forgotPasswordLink }))), expand?.includes("social") && /* @__PURE__ */ React16.createElement("div", null, !isAccountExist?.status && (expand === "social" || expand === "wallet" || expand === "email") && /* @__PURE__ */ React16.createElement("div", { className: "bg-danger text-white px-3 py-2 rounded-2 d-flex align-items-center" }, /* @__PURE__ */ React16.createElement(
    "img",
    {
      className: "me-1",
      src: cancel_default,
      alt: "cancel Icon",
      width: "16px",
      height: "16px"
    }
  ), "Your account not link to ", isAccountExist?.type, " yet"), (expand === "social" || expand === "social-google") && /* @__PURE__ */ React16.createElement("div", { className: "mb-1" }, /* @__PURE__ */ React16.createElement(Suspense2, { fallback: /* @__PURE__ */ React16.createElement(React16.Fragment, null, "Loading...") }, /* @__PURE__ */ React16.createElement(
    Social_default,
    {
      typeSocial: "google",
      isAccountExist,
      setIsAccountExist,
      setExpand,
      setAccountInfo
    }
  ))), (expand === "social" || expand === "social-twitter") && /* @__PURE__ */ React16.createElement("div", { className: "mb-1" }, /* @__PURE__ */ React16.createElement(Suspense2, { fallback: /* @__PURE__ */ React16.createElement(React16.Fragment, null, "Loading...") }, /* @__PURE__ */ React16.createElement(
    Social_default,
    {
      typeSocial: "twitter",
      isAccountExist,
      setIsAccountExist,
      setExpand,
      setAccountInfo
    }
  ))), (expand === "social" || expand === "social-facebook") && /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(Suspense2, { fallback: /* @__PURE__ */ React16.createElement(React16.Fragment, null, "Loading...") }, /* @__PURE__ */ React16.createElement(
    Social_default,
    {
      typeSocial: "facebook",
      isAccountExist,
      setIsAccountExist,
      setExpand,
      setAccountInfo
    }
  ))), (expand === "social" || expand === "social-reddit") && /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(Suspense2, { fallback: /* @__PURE__ */ React16.createElement(React16.Fragment, null, "Loading...") }, /* @__PURE__ */ React16.createElement(
    Social_default,
    {
      typeSocial: "reddit",
      isAccountExist,
      setIsAccountExist,
      setExpand,
      setAccountInfo
    }
  )))), expand?.includes("require-email") && /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement("div", { className: "control-group" }, /* @__PURE__ */ React16.createElement(Suspense2, { fallback: /* @__PURE__ */ React16.createElement(React16.Fragment, null, "Loading...") }, /* @__PURE__ */ React16.createElement(update_default, { accountInfo }))))))), /* @__PURE__ */ React16.createElement("div", { className: "d-none d-lg-block col-lg-5" }, /* @__PURE__ */ React16.createElement("img", { className: "w-100", src: loginBg ? loginBg : login_bg_default, alt: "Login Background" }))));
};
var Providers_default = SSOProviders;

// src/SSOButton/modal.tsx
if (typeof window !== "undefined") {
  window.process = { env: "" };
}
var SSOModalContext = React17.createContext(void 0);
var SSOModal = ({
  onGetData,
  show,
  toggle,
  demoUser,
  demoPassword,
  noCreateAccount,
  isRequireEmail = false,
  isSignUpForm = false,
  loginText,
  loginBg,
  customClass,
  forgotPasswordLink
}) => {
  const handleOnData = (data) => {
    onGetData(data);
    toggle();
  };
  return /* @__PURE__ */ React17.createElement("div", { className: "aesirxsso" }, /* @__PURE__ */ React17.createElement(
    Modal,
    {
      centered: true,
      fade: false,
      show,
      onHide: () => {
        toggle();
      },
      size: "xl",
      className: `aesirxsso ${customClass ?? ""}`
    },
    /* @__PURE__ */ React17.createElement(CloseButton, { onClick: toggle }),
    /* @__PURE__ */ React17.createElement(ModalBody, { className: "p-0 bg-white rounded-3" }, /* @__PURE__ */ React17.createElement(Suspense3, { fallback: /* @__PURE__ */ React17.createElement(React17.Fragment, null, "Loading...") }, /* @__PURE__ */ React17.createElement(
      SSOModalContext.Provider,
      {
        value: {
          handleOnData,
          toggle,
          demoUser,
          demoPassword,
          noCreateAccount,
          isRequireEmail,
          isSignUpForm
        }
      },
      /* @__PURE__ */ React17.createElement(
        Providers_default,
        {
          forgotPasswordLink,
          loginText,
          loginBg
        }
      )
    )))
  ));
};
var modal_default = SSOModal;

// src/SSOButton/index.tsx
var SSOButton = ({
  className,
  text = "Login",
  loginText = "AesirX SSO",
  loginBg,
  onGetData,
  demoUser = "",
  demoPassword = "",
  noCreateAccount = false,
  isRequireEmail = false,
  customClass,
  forgotPasswordLink
}) => {
  const [show, setShow] = useState11(false);
  const toggle = () => {
    if (typeof window !== "undefined") {
      !show ? document.body.classList.add("modal-sso-open") : document.body.classList.remove("modal-sso-open");
    }
    setShow(!show);
  };
  return /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement("button", { type: "button", className: `btn ${className}`, onClick: toggle }, text), /* @__PURE__ */ React18.createElement(
    modal_default,
    {
      demoUser,
      demoPassword,
      noCreateAccount,
      isRequireEmail,
      onGetData,
      show,
      toggle,
      loginText,
      loginBg,
      customClass,
      forgotPasswordLink
    }
  ));
};
var SSOButton_default = SSOButton;

// src/SSOButton/ConcordiumLogin.tsx
import React19, { Suspense as Suspense4 } from "react";
var ConcordiumLogin = ({ onGetData }) => {
  const handleOnData = (data) => {
    onGetData(data);
  };
  return /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement("div", null, /* @__PURE__ */ React19.createElement(
    SSOModalContext.Provider,
    {
      value: {
        handleOnData,
        toggle: () => {
        },
        demoUser: null,
        demoPassword: null,
        noCreateAccount: false,
        isSignUpForm: false,
        isRequireEmail: false
      }
    },
    /* @__PURE__ */ React19.createElement(Suspense4, { fallback: /* @__PURE__ */ React19.createElement(React19.Fragment, null, "Loading...") }, /* @__PURE__ */ React19.createElement(
      Concordium_default,
      {
        setIsAccountExist: () => {
        },
        setExpand: () => {
        },
        setAccountInfo: () => {
        }
      }
    ))
  )));
};
var ConcordiumLogin_default = ConcordiumLogin;

// src/SSOButton/EmailLogin.tsx
import React20, { Suspense as Suspense5 } from "react";
var EmailLogin = ({
  onGetData,
  btnClass,
  spacingClass,
  noLabel,
  forgotPasswordLink,
  demoUser,
  demoPassword
}) => {
  const handleOnData = (data) => {
    onGetData(data);
  };
  return /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(
    SSOModalContext.Provider,
    {
      value: {
        handleOnData,
        toggle: () => {
        },
        demoUser: demoUser ?? "",
        demoPassword: demoPassword ?? "",
        noCreateAccount: false,
        isSignUpForm: false,
        isRequireEmail: false
      }
    },
    /* @__PURE__ */ React20.createElement("div", { className: "control-group" }, /* @__PURE__ */ React20.createElement(Suspense5, { fallback: /* @__PURE__ */ React20.createElement(React20.Fragment, null, "Loading...") }, /* @__PURE__ */ React20.createElement(
      Email_default,
      {
        btnClass,
        spacingClass,
        noLabel,
        forgotPasswordLink
      }
    )))
  )));
};
var EmailLogin_default = EmailLogin;

// src/SignUpButton/index.tsx
import React21, { Suspense as Suspense6, useState as useState12 } from "react";
import { CloseButton as CloseButton2, Modal as Modal2, ModalBody as ModalBody2 } from "react-bootstrap";
var SignUpButton = ({
  className,
  text = "Login",
  loginBg,
  isRequireEmail = false,
  productOptions = [],
  customClass,
  alertButton = {
    isShow: false,
    handleClick: void 0,
    alertWarning: void 0
  }
}) => {
  const [show, setShow] = useState12(false);
  const [expand, setExpand] = useState12("");
  const [isAccountExist, setIsAccountExist] = useState12({ status: true, type: "" });
  const urlParams = new URLSearchParams(window.location.search);
  let login2 = ["concordium", "metamask", "regular"];
  if (urlParams.has("return")) {
    login2 = new URL(atob(urlParams.get("return"))).searchParams.getAll("login[]");
  }
  const hasMetamask = login2.length === 0 || login2.includes("metamask");
  const hasConcordium = login2.length === 0 || login2.includes("concordium");
  const toggle = () => {
    setShow(!show);
    setExpand("");
  };
  return /* @__PURE__ */ React21.createElement(React21.Fragment, null, /* @__PURE__ */ React21.createElement("button", { type: "button", className: `btn ${className}`, onClick: toggle }, text), /* @__PURE__ */ React21.createElement(
    Modal2,
    {
      show,
      centered: true,
      onHide: () => {
        setShow(!show);
      },
      size: "xl",
      className: `aesirxsso ${customClass ?? ""}`
    },
    /* @__PURE__ */ React21.createElement(
      CloseButton2,
      {
        onClick: () => {
          setShow(!show);
        }
      }
    ),
    /* @__PURE__ */ React21.createElement(ModalBody2, { className: "p-0 bg-white rounded-3 text-primary" }, /* @__PURE__ */ React21.createElement(
      SSOModalContext.Provider,
      {
        value: {
          handleOnData: null,
          toggle,
          demoUser: null,
          demoPassword: null,
          noCreateAccount: false,
          isSignUpForm: true,
          isRequireEmail
        }
      },
      /* @__PURE__ */ React21.createElement("div", { className: "row gx-0 w-100" }, /* @__PURE__ */ React21.createElement("div", { className: "col-lg-7 d-flex align-items-center" }, /* @__PURE__ */ React21.createElement("div", { className: "pt-0 pb-4 px-4 block-wallet" }, /* @__PURE__ */ React21.createElement("div", { className: "py-4 px-lg-4" }, !expand ? /* @__PURE__ */ React21.createElement(React21.Fragment, null, /* @__PURE__ */ React21.createElement("h3", { className: "fs-4 fw-semibold mt-2 mb-3 text-primary" }, "Sign up"), /* @__PURE__ */ React21.createElement("p", { className: "fs-7" }, "Select your sign up method"), /* @__PURE__ */ React21.createElement(
        "button",
        {
          type: "button",
          className: "btn btn-success w-100 lh-sm text-white fw-semibold mb-18px",
          onClick: () => {
            setExpand("wallet");
          }
        },
        "Connect with Web3 Wallets"
      ), /* @__PURE__ */ React21.createElement(
        "button",
        {
          type: "button",
          className: "btn btn-outline w-100 lh-sm fw-semibold mb-18px",
          onClick: () => {
            setExpand("social");
          }
        },
        "Connect with Social Media"
      ), /* @__PURE__ */ React21.createElement(
        "button",
        {
          type: "button",
          className: "btn btn-outline w-100 lh-sm fw-semibold",
          onClick: () => {
            setExpand("email");
          }
        },
        "Sign up with email"
      )) : expand === "social" || expand === "wallet" || expand === "email" ? /* @__PURE__ */ React21.createElement("div", { className: "text-start" }, /* @__PURE__ */ React21.createElement(
        "div",
        {
          className: "cursor-pointer fw-medium fs-14 d-inline-flex align-items-center back-button text-primary",
          onClick: () => {
            setExpand("");
            setIsAccountExist({ status: true, type: "" });
          }
        },
        /* @__PURE__ */ React21.createElement("img", { src: arrow_left_default, alt: "Back Icon", className: "me-1" }),
        "Back"
      )) : /* @__PURE__ */ React21.createElement(React21.Fragment, null), expand?.includes("wallet") && /* @__PURE__ */ React21.createElement(React21.Fragment, null, (expand === "wallet" || expand === "wallet-metamask") && hasMetamask && /* @__PURE__ */ React21.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React21.createElement(Suspense6, { fallback: /* @__PURE__ */ React21.createElement(React21.Fragment, null, "Loading...") }, /* @__PURE__ */ React21.createElement(
        Ethereum_default,
        {
          setIsAccountExist,
          setExpand
        }
      ))), (expand === "wallet" || expand === "wallet-concordium") && hasConcordium && /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement(Suspense6, { fallback: /* @__PURE__ */ React21.createElement(React21.Fragment, null, "Loading...") }, /* @__PURE__ */ React21.createElement(
        Concordium_default,
        {
          setIsAccountExist,
          setExpand
        }
      )))), expand === "email" && /* @__PURE__ */ React21.createElement(
        CreateAccount_default,
        {
          noLogin: true,
          isNoWallet: true,
          setShow: toggle,
          productOptions,
          alertButton,
          isRequireEmail
        }
      ), expand?.includes("social") && /* @__PURE__ */ React21.createElement("div", null, (expand === "social" || expand === "social-google") && /* @__PURE__ */ React21.createElement("div", { className: "mb-1" }, /* @__PURE__ */ React21.createElement(Suspense6, { fallback: /* @__PURE__ */ React21.createElement(React21.Fragment, null, "Loading...") }, /* @__PURE__ */ React21.createElement(
        Social_default,
        {
          typeSocial: "google",
          isAccountExist: { status: false, type: "google" },
          setIsAccountExist,
          setExpand
        }
      ))), (expand === "social" || expand === "social-twitter") && /* @__PURE__ */ React21.createElement("div", { className: "mb-1" }, /* @__PURE__ */ React21.createElement(Suspense6, { fallback: /* @__PURE__ */ React21.createElement(React21.Fragment, null, "Loading...") }, /* @__PURE__ */ React21.createElement(
        Social_default,
        {
          typeSocial: "twitter",
          isAccountExist: { status: false, type: "twitter" },
          setIsAccountExist,
          setExpand
        }
      ))), (expand === "social" || expand === "social-facebook") && /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement(Suspense6, { fallback: /* @__PURE__ */ React21.createElement(React21.Fragment, null, "Loading...") }, /* @__PURE__ */ React21.createElement(
        Social_default,
        {
          typeSocial: "facebook",
          isAccountExist: { status: false, type: "facebook" },
          setIsAccountExist,
          setExpand
        }
      ))), (expand === "social" || expand === "social-reddit") && /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement(Suspense6, { fallback: /* @__PURE__ */ React21.createElement(React21.Fragment, null, "Loading...") }, /* @__PURE__ */ React21.createElement(
        Social_default,
        {
          typeSocial: "reddit",
          isAccountExist: { status: false, type: "reddit" },
          setIsAccountExist,
          setExpand
        }
      ))))))), /* @__PURE__ */ React21.createElement("div", { className: "d-none d-lg-block col-lg-5" }, /* @__PURE__ */ React21.createElement(
        "img",
        {
          className: "w-100 h-100",
          src: loginBg ? loginBg : login_bg_default,
          alt: "Login Background"
        }
      )))
    ))
  ));
};
var SignUpButton_default = SignUpButton;

// src/SignUpButton/SignUpConcordium.tsx
import React22 from "react";
var SignUpConcordium = ({
  isRequireEmail = false,
  productOptions = [],
  packagesData,
  defaultValues = []
}) => {
  return /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(
    SSOModalContext.Provider,
    {
      value: {
        handleOnData: null,
        toggle: () => {
        },
        demoUser: null,
        demoPassword: null,
        noCreateAccount: false,
        isSignUpForm: true,
        isRequireEmail
      }
    },
    /* @__PURE__ */ React22.createElement(
      CreateAccount_default,
      {
        noLogin: true,
        isNoWallet: true,
        setShow: true,
        packagesData,
        productOptions,
        isRequireEmail,
        defaultValues,
        isRequireConcordium: true
      }
    )
  )));
};
var SignUpConcordium_default = SignUpConcordium;

// src/SSOConfig/index.tsx
import React37 from "react";
import { Col as Col3, Row as Row3 } from "react-bootstrap";

// src/SSOConfig/Concordium/index.tsx
import React29, { useState as useState16 } from "react";

// src/SSOButton/images/concordium_bg_black.png
var concordium_bg_black_default = "data:image/png;base64,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";

// src/SSOButton/Providers/web3.tsx
import React26, { createContext as createContext3, useContext as useContext10, useEffect as useEffect8, useState as useState15 } from "react";

// src/components/Toast.tsx
import React23 from "react";
import { ToastContainer, toast as toast10 } from "react-toastify";

// src/SSOButton/images/toast_danger.png
var toast_danger_default = "data:image/png;base64,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";

// src/SSOButton/images/warning_icon.png
var warning_icon_default = "data:image/png;base64,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";

// src/SSOButton/images/toast_success.png
var toast_success_default = "data:image/png;base64,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";

// src/components/Toast.tsx
var notify = async (msg, type = "success") => {
  switch (type) {
    case "error":
      toast10.error(
        /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement("span", null, "Error"), msg && typeof msg === "string" && /* @__PURE__ */ React23.createElement("p", { className: "fw-normal m-0" }, msg)),
        {
          className: "bg-red-10 fw-bold text-red-100 ps-4 bg-noti-bg-error text-noti-error",
          icon: () => /* @__PURE__ */ React23.createElement("img", { alt: "error", src: toast_danger_default })
        }
      );
      break;
    case "warn":
      toast10.warn(
        /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement("span", null, "Warning"), msg && typeof msg === "string" && /* @__PURE__ */ React23.createElement("p", { className: "fw-normal m-0" }, msg)),
        {
          className: "bg-yellow-10 fw-bold text-yellow-200 ps-4 bg-noti-bg-warn text-noti-warn",
          icon: () => /* @__PURE__ */ React23.createElement("img", { alt: "warn", src: warning_icon_default })
        }
      );
      break;
    case "success":
      toast10.success(
        /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement("span", null, "Successful"), msg && typeof msg === "string" && /* @__PURE__ */ React23.createElement("p", { className: "fw-normal m-0" }, msg)),
        {
          className: "bg-primary-10 bg-noti-bg-success text-green fw-bold ps-4",
          icon: () => /* @__PURE__ */ React23.createElement("img", { alt: "success", src: toast_success_default })
        }
      );
      break;
    case "promise":
      return await toast10.promise(
        msg,
        {
          pending: {
            render() {
              return /* @__PURE__ */ React23.createElement("span", { className: "p-15 pe-2" }, "Progressing...");
            },
            icon: () => /* @__PURE__ */ React23.createElement("img", { alt: "success", src: toast_success_default })
          },
          success: {
            render() {
              return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement("span", null, "Successful"), msg && typeof msg === "string" && /* @__PURE__ */ React23.createElement("p", { className: "fw-normal m-0" }, msg));
            },
            className: "bg-primary-10 text-green bg-noti-bg-success  fw-bold ps-4",
            icon: () => /* @__PURE__ */ React23.createElement("img", { alt: "success", src: toast_success_default })
          },
          error: {
            render() {
              return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement("span", null, "Error"), msg && typeof msg === "string" && /* @__PURE__ */ React23.createElement("p", { className: "fw-normal m-0" }, msg));
            },
            className: "bg-red-10 fw-bold bg-noti-bg-error text-noti-error text-red-100 ps-4",
            icon: () => /* @__PURE__ */ React23.createElement("img", { alt: "error", src: toast_danger_default })
          }
        },
        {
          className: "bg-dark"
        }
      );
    default:
      toast10.info(msg, {
        className: "bg-info"
      });
      break;
  }
};

// src/SSOButton/Providers/user.tsx
import React25, {
  createContext as createContext2,
  useCallback as useCallback4,
  useContext as useContext9,
  useEffect as useEffect7,
  useState as useState14
} from "react";

// src/SSOButton/Providers/global.tsx
import React24, {
  createContext,
  useCallback as useCallback3,
  useContext as useContext8,
  useEffect as useEffect6,
  useState as useState13
} from "react";
import { AUTHORIZATION_KEY, Storage } from "aesirx-lib";
import secureLocalStorage2 from "react-secure-storage";
var globalContext = createContext({
  jwt: "",
  accessToken: "",
  globalLoading: false,
  onLogin: void 0,
  onLogout: void 0
});
var GlobalContextProvider = ({ children }) => {
  return /* @__PURE__ */ React24.createElement(GlobalContextApp, null, children);
};
var GlobalContextApp = ({ children }) => {
  const [jwt, setJwt] = useState13("");
  const [accessToken, setAccessToken] = useState13("");
  const onSSOData = useCallback3(async (response) => {
    if (response.error) {
      console.log("ee", response);
    } else {
      secureLocalStorage2.setItem("jwt", response?.jwt);
      Storage.getItem("accessToken", AUTHORIZATION_KEY.ACCESS_TOKEN);
      setJwt(response?.jwt);
      setAccessToken(response?.access_token);
    }
  }, []);
  useEffect6(() => {
    const jwt2 = secureLocalStorage2.getItem("jwt");
    const accessToken2 = Storage.getItem(AUTHORIZATION_KEY.ACCESS_TOKEN);
    if (jwt2) {
      setJwt(jwt2);
    }
    if (accessToken2) {
      setAccessToken(accessToken2);
    }
  }, []);
  const handleLogout = async () => {
    secureLocalStorage2.removeItem("jwt");
    secureLocalStorage2.removeItem("accessToken");
    secureLocalStorage2.removeItem("connection");
    secureLocalStorage2.removeItem("aesirxData");
    secureLocalStorage2.removeItem("preregistration");
    setJwt("");
    setAccessToken("");
  };
  return /* @__PURE__ */ React24.createElement(
    globalContext.Provider,
    {
      value: {
        jwt,
        accessToken,
        globalLoading: false,
        onLogin: onSSOData,
        onLogout: handleLogout
      }
    },
    children
  );
};
var useGlobalContext = () => useContext8(globalContext);

// src/SSOButton/Providers/user.tsx
import secureLocalStorage3 from "react-secure-storage";
import axios6 from "axios";
import { AUTHORIZATION_KEY as AUTHORIZATION_KEY2, Storage as Storage2 } from "aesirx-lib";
var userContext = createContext2({
  userLoading: void 0,
  getData: void 0
});
var UserContextProvider = ({ children, isGetInterest = false }) => {
  const { jwt, onLogout } = useGlobalContext();
  const accessToken = Storage2.getItem(AUTHORIZATION_KEY2.ACCESS_TOKEN);
  const [preregistration, setPreregistration] = useState14(null);
  const [aesirxData, setAesirxData] = useState14(null);
  const [isAdmin, setIsAdmin] = useState14(false);
  const [loading, setLoading] = useState14(true);
  useEffect7(() => {
    if (jwt && accessToken) {
      try {
        (async () => {
          await getData(jwt, accessToken);
        })();
      } catch (error) {
        notify(`${error.message}`, "error");
      }
    }
  }, [jwt, accessToken]);
  const getData = useCallback4(async (jwt2, accessToken2) => {
    setLoading(true);
    let _preregistration = {};
    let aesirxData2 = {};
    if (jwt2) {
      try {
        const member = await getMember(accessToken2);
        aesirxData2 = { ...member };
        const preregistrationData = (await getPreregistration(jwt2)).data?.objForm;
        if (preregistrationData?.aesirXAccount) {
          const response = await axios6.post("/api/member/checkadmin", {
            username: preregistrationData?.aesirXAccount
          });
          response?.data && setIsAdmin(true);
        }
        _preregistration = {
          ...preregistrationData,
          ..._preregistration
        };
        secureLocalStorage3.setItem("auth", true);
        secureLocalStorage3.setItem("access_token", accessToken2);
        secureLocalStorage3.setItem("member_id", aesirxData2?.member_id);
        secureLocalStorage3.setItem("member_email", aesirxData2?.email);
      } catch (error) {
        if (error?.response?.status === 403 || error?.response?.status === 401 && error?.response?.data?.error !== "Account preregistration doesn't exist") {
          onLogout();
        }
      }
    }
    setAesirxData(aesirxData2);
    setPreregistration(_preregistration);
    setLoading(false);
  }, []);
  return /* @__PURE__ */ React25.createElement(
    userContext.Provider,
    {
      value: {
        preregistration,
        aesirxData,
        isAdmin,
        userLoading: loading,
        getData
      }
    },
    children
  );
};
var useUserContext = () => useContext9(userContext);

// src/SSOButton/Providers/web3.tsx
import secureLocalStorage4 from "react-secure-storage";
import {
  WithWalletConnector as WithWalletConnector2,
  useConnect as useConnect2,
  useConnection as useConnection2,
  MAINNET as MAINNET2,
  TESTNET as TESTNET2,
  BrowserWalletConnector as BrowserWalletConnector2,
  useGrpcClient as useGrpcClient2
} from "@concordium/react-components";
import { BlockHash as BlockHash2 } from "@concordium/web-sdk";
var { network } = getClientApp();
var Web3Context = createContext3({
  account: "",
  gRPCClient: {}
});
var checkNetwork = (hash) => {
  switch (network) {
    case "testnet":
      return BlockHash2.toHexString(hash) === TESTNET2.genesisHash;
    default:
      return BlockHash2.toHexString(hash) === MAINNET2.genesisHash;
  }
};
var Web3ContextProvider = ({ children, autoLoad }) => {
  return /* @__PURE__ */ React26.createElement(WithWalletConnector2, { network: network === "mainnet" ? MAINNET2 : TESTNET2 }, (props) => /* @__PURE__ */ React26.createElement(Web3ContextApp, { ...props, autoLoad }, children));
};
var Web3ContextApp = ({ children, ...props }) => {
  const {
    activeConnectorError,
    network: network2,
    connectedAccounts,
    genesisHashes,
    activeConnector,
    setActiveConnectorType,
    activeConnectorType,
    autoLoad = true
  } = props;
  const { setConnection, account, connection, genesisHash } = useConnection2(
    connectedAccounts,
    genesisHashes
  );
  const { connect, connectError, isConnecting } = useConnect2(activeConnector, setConnection);
  const [, setRpcGenesisHash] = useState15();
  const { preregistration } = useUserContext();
  const rpc = useGrpcClient2(network2);
  useEffect8(() => {
    if (activeConnector) {
      connect();
    }
  }, [activeConnector, connect]);
  useEffect8(() => {
    if (connectError) {
      notify(`${connectError}`, "error");
    }
  }, [connectError]);
  useEffect8(() => {
    if (activeConnectorError) {
      notify(`${activeConnectorError}`, "error");
    }
  }, [activeConnectorError]);
  useEffect8(() => {
    const connection2 = secureLocalStorage4.getItem("concordium");
    if (connection2 === "browser" && autoLoad) {
      setActiveConnectorType(BROWSER_WALLET);
    } else if (connection2 === "walletconnect") {
    }
  }, []);
  useEffect8(() => {
    if (rpc) {
      setRpcGenesisHash(void 0);
      rpc.getConsensusStatus().then((status) => status.genesisBlock).then(async (hash) => {
        if (!checkNetwork(hash)) {
          throw new Error(`Please change the network to ${network2} in Wallet`);
        }
        setRpcGenesisHash(hash);
        secureLocalStorage4.setItem(
          "concordium",
          activeConnector instanceof BrowserWalletConnector2 ? "browser" : "walletconnect"
        );
      }).catch((err) => {
        if (err) {
          notify(`${err.message}`, "error");
        }
        connection.disconnect();
        setRpcGenesisHash(void 0);
        setActiveConnectorType(void 0);
      });
    }
  }, [account, rpc, preregistration?.id, setActiveConnectorType]);
  return /* @__PURE__ */ React26.createElement(
    Web3Context.Provider,
    {
      value: {
        account: account ?? "",
        setActiveConnectorType,
        connection,
        isConnecting,
        gRPCClient: rpc
      }
    },
    children
  );
};
var useWeb3Context = () => useContext10(Web3Context);

// src/components/Image.tsx
import React27 from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
var Image = (props) => /* @__PURE__ */ React27.createElement(
  LazyLoadImage,
  {
    placeholderSrc: props?.placeholderSrc ? props?.placeholderSrc : "/assets/images/default_channel_image.png",
    ...props,
    effect: "blur"
  }
);

// src/SSOConfig/Concordium/Connect.tsx
import React28 from "react";
import { Button as Button3 } from "react-bootstrap";
import { isDesktop as isDesktop2 } from "react-device-detect";
var Connect = (props) => {
  return /* @__PURE__ */ React28.createElement("div", null, isDesktop2 && /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(
    Button3,
    {
      type: "button",
      className: `fw-semibold text-white w-100  d-flex align-items-center justify-content-center `,
      variant: "success",
      onClick: () => props.setActiveConnectorType(BROWSER_WALLET)
    },
    /* @__PURE__ */ React28.createElement(Image, { src: concordium_default, alt: "concordium-logo", width: 20, height: 21 }),
    /* @__PURE__ */ React28.createElement("span", { className: "ms-2" }, "Browser Wallet")
  )));
};
var Connect_default = Connect;

// src/SSOConfig/Concordium/index.tsx
import { Button as Button4 } from "react-bootstrap";
var Concordium = ({ connectWallet: connectWallet2, setShow }) => {
  const { account, setActiveConnectorType } = useWeb3Context();
  const { aesirxData } = useUserContext();
  const [connecting, setConnecting] = useState16(false);
  const walletAddress = aesirxData?.wallet_concordium ? aesirxData?.wallet_concordium : account;
  const hanleConnect = async (address, walletType) => {
    setConnecting(true);
    await connectWallet2(address, walletType);
    setConnecting(false);
  };
  return /* @__PURE__ */ React29.createElement("div", { className: "py-4 px-4 border rounded" }, /* @__PURE__ */ React29.createElement("div", { className: "d-flex justify-content-start align-items-center mb-3" }, /* @__PURE__ */ React29.createElement(
    Image,
    {
      className: "me-14px",
      src: concordium_bg_black_default,
      width: 40,
      height: 40,
      alt: "logo concordium"
    }
  ), /* @__PURE__ */ React29.createElement("p", { className: "fw-semibold fs-18 mb-0 ms-2" }, "Concordium")), /* @__PURE__ */ React29.createElement("p", { className: "fw-medium mb-12px" }, "Address"), /* @__PURE__ */ React29.createElement("div", { className: "position-relative overflow-hidden fs-7 mb-3 py-2 px-3 bg-gray-100 rounded border border-gray-stoke-1" }, /* @__PURE__ */ React29.createElement("span", { className: "fw-normal" }, !walletAddress ? "Not Connect!" : shortenString(walletAddress, 20, 6)), /* @__PURE__ */ React29.createElement(
    ButtonCopy_default,
    {
      content: aesirxData?.wallet_concordium,
      className: " border-0 top-0 bottom-0 p-0 px-2 bg-gray-100 position-absolute end-0"
    }
  )), !aesirxData?.wallet_concordium && /* @__PURE__ */ React29.createElement(React29.Fragment, null, account ? /* @__PURE__ */ React29.createElement(
    Button4,
    {
      disabled: connecting,
      onClick: () => {
        !account ? open() : hanleConnect(account, "concordium");
      },
      variant: "success",
      className: "fw-semibold  w-100"
    },
    account ? "Connect this address" : "Connect to Ethereum wallets"
  ) : /* @__PURE__ */ React29.createElement(Connect_default, { setActiveConnectorType })), aesirxData?.wallet_concordium && /* @__PURE__ */ React29.createElement(
    Button4,
    {
      onClick: () => setShow({
        show: true,
        data: {
          wallet: "concordium",
          address: aesirxData?.wallet_concordium
        }
      }),
      variant: "danger",
      className: "fw-semibold py-12px py-12px w-100"
    },
    "Disconnect"
  ));
};
var Concordium_default2 = Concordium;

// src/SSOConfig/DeleteModal.tsx
import React30, { useState as useState17 } from "react";
import { Button as Button5, Modal as Modal3 } from "react-bootstrap";
var DeleteModal = ({ show, action, setShow, data }) => {
  const [loading, setLoading] = useState17(false);
  const handleDelete = async () => {
    setLoading(true);
    await action(data?.address, data?.wallet);
    setLoading(false);
    setShow({ show: false });
  };
  return /* @__PURE__ */ React30.createElement(Modal3, { show, onHide: () => setShow({ show: false }), centered: true }, /* @__PURE__ */ React30.createElement(Modal3.Body, { className: "py-4 px-2rem text-center" }, /* @__PURE__ */ React30.createElement(Image, { src: warning_icon_default, alt: "warning icon", className: "mb-3" }), /* @__PURE__ */ React30.createElement("h3", { className: "text-center mb-2 fs-18 fw-semibold" }, "Are you sure you want to disconnect your wallet?"), /* @__PURE__ */ React30.createElement("p", { className: "mb-4" }, "This action is irreversible, are you sure you want to disconnect?"), /* @__PURE__ */ React30.createElement("div", { className: "d-flex justify-content-between" }, /* @__PURE__ */ React30.createElement(
    Button5,
    {
      onClick: () => setShow({ show: false }),
      variant: "outline-light",
      className: "border text-primary fw-semibold fs-7 px-4 py-12px"
    },
    "Cancel"
  ), /* @__PURE__ */ React30.createElement(
    Button5,
    {
      onClick: handleDelete,
      disabled: loading,
      variant: "danger",
      className: "fw-semibold fs-7 px-4 py-12px"
    },
    "Yes, disconnect!"
  ))));
};
var DeleteModal_default = DeleteModal;

// src/SSOConfig/index.tsx
import { useState as useState22, useEffect as useEffect10 } from "react";

// src/SSOConfig/AesirX/Email.tsx
import React31, { useCallback as useCallback5, useState as useState18, useEffect as useEffect9 } from "react";
import { Button as Button6, Form as Form4 } from "react-bootstrap";
import { useFormik as useFormik3 } from "formik";
import { FontAwesomeIcon as FontAwesomeIcon5 } from "@fortawesome/react-fontawesome";
import { faCircleExclamation as faCircleExclamation3 } from "@fortawesome/free-solid-svg-icons";

// src/SSOButton/images/mail_logo.png
var mail_logo_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAADpUlEQVR4Ac2YP0wTURzHv+/aMhQ0dcA4gJZRGMCNjbIYRjGUwgYDM38S4widHDBSBjcVnJBSIoMaYaEMJAQTgwkw4MApbULCwCFQE8vd8/cetoHSlrv2bPtJ2ubuvZf79vve+93v/RgKpK5rxqcwRzPn3AcFLYwzDwf3iDYGphngKuNQObABGCuxSG8UBcCsdPY+mvIYVe4hcDaYEmPhQSSWRR1JPagu9KoWxpkU5qoeI1GDsAU2bVbotQLvdr8jx5RRq46ZeLAKA2M/5wNvr+mXR5w/HLLPtZwKQnvhwHDu5iyIKdVd1e8B2gAlQGykk2SiXVvo1zLblGwDDJd7uVTiBORSS4005CpXBJ5PK1pQYhgZUt89O5F533Hxot4/00ddn6F8tHoaHx8dbc+vpW6k16C3Z8ZrGMoy5/CivGjHyURDaj2mp1jXHaMVIE7guVHlHk1dSAeFe7qu7KKCIBdvCRelg8I9VBg1TreMv1IgY6ULKWZhDEPyV2QljCnLZgcO+5vkpxAm5rbkxyycG+1OMrENFhDitnYPMfB8FbGDhKkxN90uzI755FgrAsnGZoVyN8tBefFLnB7Yjrpa97V962qr8Xn8IRbX47AK5ZOUczLroSUU2cabjztSZOO93ElOo9eDMDn36sOOHGNdIWuhKS4s9r3+9B17NMXhYDvGpr4isvLjUnuXz4uRriaMvFzH2vYBCsTjLCbPW6Kp7niyhPCoD/W3a9LrS6y1rjYvuoPLptdpToEoktjBKQmJSpGCm9UutN6vRaB4cRKxSTQUiRDZ8XRJrjmxJgMk2A5xhObkjGuUMRadzv86TWJgfBV2QmmfqsBgG6hQGOeqCDNRWEQE3lKMoWPqhtPg+jd61Zke9CK8ic3pThSCGGsJxqIy3aI0/9DuY6UNqHtzgYZz6zgPoeLgUfEtBSpnVZOoMJJJHhS/UqC60KmJAzQqBj69/68skt4djj9VQTuCtg2oKfcEaYHCRZ0bQZQZg+o1+xeKSpfiSzzSEyrrVNNmjWcUk7LWZur94ZKWPgSiPhObCzzIvJ81QjuSrk5ajyV7BVKVNiqKR9na8pbfZK2En5+u/hs0rXuRnpzlt7zvOFG3M2D0099QYTtMo7fXUD5xshdMcIcqDy6d0eGe9cEOyLXjs9/BbPXATCwV0dNCGfPBch2HHCNhJ2eJSTPCChJ4kTp/uI2c8IniI6eTIW0qL9IJhwj4BiXCbINTRgK5Q7tXUAB/AXHFfj1wiRX1AAAAAElFTkSuQmCC";

// src/SSOConfig/AesirX/Email.tsx
import * as Yup3 from "yup";
import { debounce as debounce3 } from "lodash";
var Email = () => {
  const [updating, setUpdating] = useState18(false);
  const { aesirxData, getData } = useUserContext();
  const { jwt, accessToken } = useGlobalContext();
  const debouncedCheckEmail = useCallback5(debounce3(validateEmail, 200), []);
  console.log(aesirxData, "aesirxData");
  const formik = useFormik3({
    initialValues: {
      email: aesirxData?.email
    },
    validationSchema: Yup3.object({
      email: Yup3.string().email("Invalid email address").required("Please enter your email").test("unique", "This Email is already taken", async (value) => {
        if (value != aesirxData?.email) {
          return await debouncedCheckEmail(value);
        } else {
          return true;
        }
      })
    }),
    onSubmit: async (values) => {
      let updateSuccess = true;
      setUpdating(true);
      try {
        const response = await updateMember(
          { id: aesirxData?.member_id, ...values },
          accessToken
        );
        if (response?.result?.success) {
          notify("Update email sucessfully!", "success");
        } else {
          updateSuccess = false;
          notify(`${response?._messages?.[0]?.message || "Something when wrong!"}`, "error");
        }
      } catch (error) {
        console.log("Error", error);
        updateSuccess = false;
        notify(`${error?.response?.data?._messages?.[0]?.message || error?.message}`, "error");
      }
      setUpdating(false);
      if (updateSuccess) {
        await getData(jwt, accessToken);
      }
    },
    validateOnMount: true
  });
  useEffect9(() => {
    formik.setFieldValue("email", aesirxData?.email);
  }, [aesirxData?.email]);
  return /* @__PURE__ */ React31.createElement("div", { className: "py-4 px-4 border rounded" }, /* @__PURE__ */ React31.createElement("div", { className: "d-flex justify-content-start align-items-center mb-3" }, /* @__PURE__ */ React31.createElement(
    Image,
    {
      quality: 100,
      className: "me-2",
      src: mail_logo_default,
      width: 40,
      height: 40,
      alt: "logo ethereum"
    }
  ), /* @__PURE__ */ React31.createElement("p", { className: "fw-semibold fs-18 mb-0 ms-2" }, " Email")), /* @__PURE__ */ React31.createElement(Form4, { onSubmit: formik.handleSubmit, className: "text-start" }, /* @__PURE__ */ React31.createElement(Form4.Group, null, /* @__PURE__ */ React31.createElement(Form4.Label, { className: "fw-medium mb-2" }, "Email address", /* @__PURE__ */ React31.createElement("span", { className: "text-danger" }, "*")), /* @__PURE__ */ React31.createElement("div", { className: "position-relative fs-7 mb-2" }, /* @__PURE__ */ React31.createElement(
    Form4.Control,
    {
      type: "email",
      name: "email",
      onChange: formik.handleChange,
      onBlur: formik.handleBlur,
      value: formik.values["email"],
      className: `py-2 fs-7 ${formik.touched["email"] && formik.errors["email"] ? "border-danger" : ""}`
    }
  ), /* @__PURE__ */ React31.createElement(
    ButtonCopy_default,
    {
      content: formik.values["email"],
      className: "border-0 top-0 bottom-0 p-0 px-2 m-1 bg-gray-100 position-absolute end-0"
    }
  )), formik.touched["email"] && formik.errors["email"] ? /* @__PURE__ */ React31.createElement("p", { className: "mt-2 fs-7 mb-12px p-0 bg-white border-0 text-danger d-flex align-items-center" }, /* @__PURE__ */ React31.createElement(FontAwesomeIcon5, { icon: faCircleExclamation3, width: 14, height: 14 }), /* @__PURE__ */ React31.createElement("span", { className: "fs-7 fw-semibold ms-2 lh-1" }, formik.errors["email"].toString())) : null), /* @__PURE__ */ React31.createElement(
    Button6,
    {
      type: "submit",
      disabled: !formik.isValid || formik.values["email"] == aesirxData?.email || updating,
      variant: "success",
      className: "fw-semibold py-12px py-12px w-100"
    },
    formik.values["email"] != aesirxData?.email ? "Update Email" : "Connected"
  )));
};
var Email_default2 = Email;

// src/SSOConfig/AesirX/Password.tsx
import { faCircleExclamation as faCircleExclamation4 } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as FontAwesomeIcon7 } from "@fortawesome/react-fontawesome";
import React33 from "react";
import { Button as Button7, Form as Form5, Modal as Modal4 } from "react-bootstrap";
import * as Yup4 from "yup";
import { useFormik as useFormik4 } from "formik";
import { useState as useState19 } from "react";

// src/SSOButton/images/register_success_icon.png
var register_success_icon_default = "data:image/png;base64,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";

// src/components/ComponentAlert.tsx
import { faCheckCircle as faCheckCircle2, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as FontAwesomeIcon6 } from "@fortawesome/react-fontawesome";
import React32 from "react";
var ComponentAlert = ({ type, content }) => {
  let alertClass = "bg-green-light text-success";
  switch (type) {
    case "success":
      alertClass = "bg-green-light text-success";
      break;
    case "error":
      alertClass = "bg-warning-50 text-warning";
      break;
  }
  return /* @__PURE__ */ React32.createElement("div", { className: `${alertClass} text-start rounded py-20px px-3 mb-4 d-flex` }, /* @__PURE__ */ React32.createElement("span", { className: "me-2" }, /* @__PURE__ */ React32.createElement(
    FontAwesomeIcon6,
    {
      icon: type == "success" ? faCheckCircle2 : faXmarkCircle,
      width: 16,
      height: 16,
      className: "fs-6"
    }
  )), /* @__PURE__ */ React32.createElement("div", null, content));
};
var ComponentAlert_default = ComponentAlert;

// src/SSOConfig/AesirX/Password.tsx
var Password = ({ show, setShow }) => {
  const { aesirxData, getData } = useUserContext();
  const { accessToken, jwt } = useGlobalContext();
  const [sending, setSending] = useState19(false);
  const [alert, setAlert] = useState19({ show: false, content: "", type: "success" });
  const transformMessage = (content_id) => {
    let message = "Update password unsucessfully!";
    switch (content_id) {
      case "wrong_current_password":
        message = "Current password is wrong!";
        break;
    }
    return message;
  };
  const formik = useFormik4({
    initialValues: {
      curr_password: "",
      new_password: ""
    },
    validationSchema: Yup4.object({
      curr_password: Yup4.string().required("Please enter current password"),
      new_password: Yup4.string().required("Please enter new password").notOneOf([Yup4.ref("curr_password")], "New password must be different from old password")
    }),
    onSubmit: async (values) => {
      let alertObject = {
        show: true,
        content: "Something when wrong!",
        type: "error"
      };
      setSending(true);
      try {
        const response = await updateMember({ id: aesirxData?.member_id, ...values }, accessToken);
        if (response?.result?.success) {
          alertObject.type = "success";
          alertObject.content = `Update password successfully!`;
          formik.resetForm();
        } else {
          const message = transformMessage(response?.result?.content_id);
          alertObject = {
            ...alertObject,
            type: "error",
            content: message
          };
        }
      } catch (error) {
        console.log("Error", error);
        notify("Something when wrong!", "error");
      }
      setSending(false);
      setAlert(alertObject);
    },
    validateOnMount: true
  });
  return /* @__PURE__ */ React33.createElement(
    Modal4,
    {
      show,
      onHide: () => setShow(false),
      "aria-labelledby": "contained-modal-title-vcenter",
      centered: true
    },
    /* @__PURE__ */ React33.createElement(Modal4.Header, { className: "border-0 pb-0", closeButton: true }),
    /* @__PURE__ */ React33.createElement(Modal4.Body, null, /* @__PURE__ */ React33.createElement("div", { className: "py-2rem px-4 rounded text-center" }, alert?.show && /* @__PURE__ */ React33.createElement(ComponentAlert_default, { type: alert.type, content: alert.content }), /* @__PURE__ */ React33.createElement(Image, { src: register_success_icon_default, width: 96, height: 99, quality: 100, alt: "Icon Image " }), /* @__PURE__ */ React33.createElement("h3", { className: "fw-medium text-primary fs-2 mb-4" }, "Change password"), /* @__PURE__ */ React33.createElement(Form5, { onSubmit: formik.handleSubmit, className: "text-start" }, /* @__PURE__ */ React33.createElement(Form5.Group, null, /* @__PURE__ */ React33.createElement(Form5.Label, { className: "text-primary mb-2" }, "Current password", /* @__PURE__ */ React33.createElement("span", { className: "text-danger" }, "*")), /* @__PURE__ */ React33.createElement(
      Form5.Control,
      {
        type: "password",
        name: "curr_password",
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values["curr_password"],
        className: `py-13px lh-sm ${formik.touched["curr_password"] && formik.errors["curr_password"] ? "border-danger" : ""}`
      }
    ), formik.touched["curr_password"] && formik.errors["curr_password"] ? /* @__PURE__ */ React33.createElement("p", { className: "mt-2 fs-7 mb-12px p-0 bg-white border-0 text-danger d-flex align-items-center" }, /* @__PURE__ */ React33.createElement(FontAwesomeIcon7, { icon: faCircleExclamation4, width: 14, height: 14 }), /* @__PURE__ */ React33.createElement("span", { className: "fs-7 fw-semibold ms-2 lh-1" }, formik.errors["curr_password"].toString())) : null), /* @__PURE__ */ React33.createElement(Form5.Group, { className: "mt-3" }, /* @__PURE__ */ React33.createElement(Form5.Label, { className: "text-primary mb-2" }, "New password", /* @__PURE__ */ React33.createElement("span", { className: "text-danger" }, "*")), /* @__PURE__ */ React33.createElement(
      Form5.Control,
      {
        type: "password",
        name: "new_password",
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values["new_password"],
        className: `py-13px lh-sm ${formik.touched["new_password"] && formik.errors["new_password"] ? "border-danger" : ""}`
      }
    ), formik.touched["new_password"] && formik.errors["new_password"] ? /* @__PURE__ */ React33.createElement("p", { className: "mt-2 fs-7 mb-12px p-0 bg-white border-0 text-danger d-flex align-items-center" }, /* @__PURE__ */ React33.createElement(FontAwesomeIcon7, { icon: faCircleExclamation4, width: 14, height: 14 }), /* @__PURE__ */ React33.createElement("span", { className: "fs-7 fw-semibold ms-2 lh-1" }, formik.errors["new_password"].toString())) : null), /* @__PURE__ */ React33.createElement("p", { className: "mb-0 text-end mt-1" }, /* @__PURE__ */ React33.createElement(
      "a",
      {
        className: "fs-7 fw-medium text-decoration-none",
        href: "/auth/forgot-password",
        target: "_blank"
      },
      "Forgot password?"
    )), /* @__PURE__ */ React33.createElement(
      Button7,
      {
        disabled: sending || !formik.isValid,
        type: "submit",
        variant: "success",
        className: "fw-semibold py-12px mt-12px py-12px w-100"
      },
      "Change Password"
    ))))
  );
};
var Password_default = Password;

// src/SSOConfig/Social/index.tsx
import React34 from "react";
import { Button as Button8, Form as Form6, Spinner } from "react-bootstrap";
import { useState as useState20 } from "react";
import axios7 from "axios";
var Social = ({ typeSocial, keySocial }) => {
  const [loading, setLoading] = useState20(false);
  const { aesirxData, getData } = useUserContext();
  const { accessToken, jwt } = useGlobalContext();
  const { endpoint } = getClientApp();
  const connectSocial = async () => {
    try {
      setLoading(true);
      const response = await axios7.get(
        `${endpoint}/index.php?webserviceClient=site&webserviceVersion=1.0.0&option=member&task=getSocialConnectUrl&api=hal&socialType=${typeSocial}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken
          }
        }
      );
      const popupSocial = response?.data.result[0] && window.open(response?.data.result[0], "SSO", "status=1,height=750,width=650");
      const timer = setInterval(function() {
        if (popupSocial?.closed) {
          clearInterval(timer);
          setLoading(false);
        }
      }, 1e3);
      window.addEventListener(
        "message",
        (e) => {
          if (e.origin !== endpoint)
            return;
          if (e.data && e.data.socialType) {
            setLoading(false);
            getData(jwt, accessToken);
          } else if (e.data.error) {
            notify(`${e.data.error}`, "error");
          }
        },
        false
      );
    } catch (error) {
      console.error(error);
    }
  };
  const disconnectSocial = async () => {
    let updateSuccess = true;
    setLoading(true);
    try {
      const response = await updateMember(
        { id: aesirxData?.member_id, [keySocial]: "" },
        accessToken
      );
      if (response?.result?.success) {
        notify("Disconnect sucessfully!", "success");
      } else {
        updateSuccess = false;
        notify(`${response?._messages?.[0]?.message || "Something when wrong!"}`, "error");
      }
    } catch (error) {
      console.log("Error", error);
      updateSuccess = false;
      notify(`${error?.response?.data?._messages?.[0]?.message || error?.message}`, "error");
    }
    setLoading(false);
    if (updateSuccess) {
      getData(jwt, accessToken);
    }
  };
  let logoSocial = logo_google_default;
  switch (typeSocial) {
    case "facebook":
      logoSocial = logo_facebook_default;
      break;
    case "twitter":
      logoSocial = logo_twitter_default;
      break;
  }
  let valueSocial = "";
  switch (typeSocial) {
    case "facebook":
      valueSocial = aesirxData?.social_facebook;
      break;
    case "twitter":
      valueSocial = aesirxData?.social_twitter;
      break;
    case "google":
      valueSocial = aesirxData?.social_google;
      break;
  }
  return /* @__PURE__ */ React34.createElement("div", { className: "py-4 px-4 border rounded" }, /* @__PURE__ */ React34.createElement("div", { className: "d-flex justify-content-start align-items-center mb-3" }, /* @__PURE__ */ React34.createElement(
    Image,
    {
      quality: 100,
      className: "me-2",
      src: logoSocial,
      width: 40,
      height: 40,
      alt: "logo social"
    }
  ), /* @__PURE__ */ React34.createElement("p", { className: "fw-semibold fs-18  text-capitalize ms-2 mb-0" }, typeSocial)), valueSocial && /* @__PURE__ */ React34.createElement(Form6.Group, null, /* @__PURE__ */ React34.createElement(Form6.Label, { className: "fw-medium mb-1" }, "ID"), /* @__PURE__ */ React34.createElement("div", { className: "position-relative fs-7 mb-1" }, /* @__PURE__ */ React34.createElement(
    Form6.Control,
    {
      type: "email",
      name: "email",
      value: valueSocial,
      className: `py-13px fs-7`,
      readOnly: true
    }
  ), /* @__PURE__ */ React34.createElement(
    ButtonCopy_default,
    {
      content: valueSocial,
      className: "border-0 top-0 bottom-0 p-0 px-2 m-1 bg-gray-100 position-absolute end-0"
    }
  ))), /* @__PURE__ */ React34.createElement(
    Button8,
    {
      type: "button",
      variant: `${valueSocial ? "danger" : "success"}`,
      className: `fw-semibold py-12px py-12px w-100 ${valueSocial ? "" : "mt-3"}`,
      onClick: () => {
        if (valueSocial) {
          disconnectSocial();
        } else {
          connectSocial();
        }
      },
      disabled: loading
    },
    loading && /* @__PURE__ */ React34.createElement(Spinner, { size: "sm", className: "me-1" }),
    valueSocial ? "Disconnect" : /* @__PURE__ */ React34.createElement(React34.Fragment, null, "Connect to ", /* @__PURE__ */ React34.createElement("span", { className: "text-capitalize" }, typeSocial))
  ));
};
var Social_default2 = Social;

// src/components/Spinner.tsx
import React35 from "react";
import MoonLoader from "react-spinners/MoonLoader";
function Spinner2({ className = "", size }) {
  return /* @__PURE__ */ React35.createElement(
    "div",
    {
      className: `${className} d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle zindex-1 w-100 h-100`
    },
    /* @__PURE__ */ React35.createElement(MoonLoader, { color: `#1ab394`, size: `${size ?? "60px"}` })
  );
}

// src/SSOConfig/MetaMask/index.tsx
import React36, { useState as useState21 } from "react";
import { useWeb3Modal as useWeb3Modal2 } from "@web3modal/react";

// src/SSOButton/images/ethereum_icon.png
var ethereum_icon_default = "data:image/png;base64,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";

// src/SSOConfig/MetaMask/index.tsx
import { Button as Button9 } from "react-bootstrap";
import { EthereumClient as EthereumClient2, w3mConnectors as w3mConnectors2, w3mProvider as w3mProvider2 } from "@web3modal/ethereum";
import { Web3Modal as Web3Modal2 } from "@web3modal/react";
import { configureChains as configureChains2, createConfig as createConfig2, WagmiConfig as WagmiConfig2, useAccount as useAccount3 } from "wagmi";
import { arbitrum as arbitrum2, mainnet as mainnet2, polygon as polygon2 } from "wagmi/chains";
import { CONCORDIUM_WALLET_CONNECT_PROJECT_ID as CONCORDIUM_WALLET_CONNECT_PROJECT_ID3 } from "@concordium/react-components";
var chains2 = [arbitrum2, mainnet2, polygon2];
var projectId2 = CONCORDIUM_WALLET_CONNECT_PROJECT_ID3;
var { publicClient: publicClient2 } = configureChains2(chains2, [w3mProvider2({ projectId: projectId2 })]);
var wagmiConfig2 = createConfig2({
  autoConnect: true,
  connectors: [...w3mConnectors2({ projectId: projectId2, chains: chains2 })],
  publicClient: publicClient2
});
var ethereumClient2 = new EthereumClient2(wagmiConfig2, chains2);
var MetaMask = ({ connectWallet: connectWallet2, setShow }) => {
  return /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement(WagmiConfig2, { config: wagmiConfig2 }, /* @__PURE__ */ React36.createElement(MetaMaskApp, { connectWallet: connectWallet2, setShow })), /* @__PURE__ */ React36.createElement(Web3Modal2, { projectId: projectId2, ethereumClient: ethereumClient2 }));
};
var MetaMaskApp = ({ connectWallet: connectWallet2, setShow }) => {
  const { aesirxData } = useUserContext();
  const { open: open2, isOpen } = useWeb3Modal2();
  const { address, isConnecting } = useAccount3();
  const [connecting, setConnecting] = useState21(false);
  const walletAddress = aesirxData?.wallet_metamask ? aesirxData?.wallet_metamask : address;
  const hanleConnect = async (address2, walletType) => {
    setConnecting(true);
    await connectWallet2(address2, walletType);
    setConnecting(false);
  };
  return /* @__PURE__ */ React36.createElement("div", { className: "py-4 px-4 border rounded" }, /* @__PURE__ */ React36.createElement("div", { className: "d-flex justify-content-start align-items-center mb-3" }, /* @__PURE__ */ React36.createElement(Image, { className: "me-14px", src: ethereum_icon_default, width: 25, height: 40, alt: "logo ethereum" }), /* @__PURE__ */ React36.createElement("p", { className: "fw-semibold fs-18 mb-0 ms-2" }, "Ethereum")), /* @__PURE__ */ React36.createElement("p", { className: "fw-medium mb-12px" }, "Address"), /* @__PURE__ */ React36.createElement("div", { className: "position-relative overflow-hidden fs-7 mb-3 py-2 px-3 bg-gray-100 rounded border border-gray-stoke-1" }, /* @__PURE__ */ React36.createElement("span", { className: "fw-normal" }, !walletAddress ? "Not Connect!" : shortenString(walletAddress, 20, 6)), /* @__PURE__ */ React36.createElement(
    ButtonCopy_default,
    {
      content: walletAddress || aesirxData?.wallet_metamask,
      className: " border-0 top-0 bottom-0 p-0 px-2 bg-gray-100 position-absolute end-0"
    }
  )), !aesirxData?.wallet_metamask && /* @__PURE__ */ React36.createElement(
    Button9,
    {
      disabled: isConnecting || isOpen || connecting,
      onClick: () => {
        !address ? open2() : hanleConnect(address, "metamask");
      },
      variant: "success",
      className: "fw-semibold py-12px py-12px w-100"
    },
    address ? "Connect this address" : "Connect to Ethereum wallets"
  ), aesirxData?.wallet_metamask && /* @__PURE__ */ React36.createElement(
    Button9,
    {
      onClick: () => setShow({
        show: true,
        data: {
          wallet: "metamask",
          address: aesirxData?.wallet_metamask
        }
      }),
      variant: "danger",
      className: "fw-semibold py-12px py-12px w-100"
    },
    "Disconnect"
  ));
};
var MetaMask_default = MetaMask;

// src/SSOConfig/index.tsx
var SSO = () => {
  return /* @__PURE__ */ React37.createElement(GlobalContextProvider, null, /* @__PURE__ */ React37.createElement(UserContextProvider, null, /* @__PURE__ */ React37.createElement(Web3ContextProvider, { autoLoad: true }, /* @__PURE__ */ React37.createElement(SSOApp, null))));
};
var SSOApp = () => {
  const [modal, setModal] = useState22({ show: false });
  const [modalPassword, setModalPassword] = useState22(false);
  const { aesirxData, getData } = useUserContext();
  const { jwt, accessToken } = useGlobalContext();
  const [isLoading, setIsLoading] = useState22(true);
  useEffect10(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3e3);
  }, []);
  const connectWeb3Wallet = async (address, walletType) => {
    let connectSuccess = true;
    if (address) {
      try {
        const response = await connectWallet(
          address,
          walletType ?? "concordium",
          accessToken,
          aesirxData?.username
        );
        if (response?.result) {
          notify("Connect wallet sucessfully!", "success");
        } else {
          notify(`${response?._messages?.[0]?.message}`, "error");
        }
      } catch (error) {
        connectSuccess = false;
        notify(`${error?.response?.data?._messages?.[0]?.message || error?.message}`, "error");
      }
    }
    if (connectSuccess) {
      await getData(jwt, accessToken);
    }
  };
  const removeWeb3Wallet = async (address, walletType) => {
    let removeSuccess = true;
    if (address) {
      try {
        const response = await removeWallet(
          address,
          walletType ?? "concordium",
          accessToken,
          aesirxData?.username
        );
        if (response?.result) {
          notify("Remove wallet sucessfully!", "success");
        } else {
          notify(`${response?._messages?.[0]?.message}`, "error");
        }
      } catch (error) {
        removeSuccess = false;
        notify(`${error?.response?.data?._messages?.[0]?.message || error?.message}`, "error");
      }
    }
    if (removeSuccess) {
      await getData(jwt, accessToken);
    }
  };
  return /* @__PURE__ */ React37.createElement(React37.Fragment, null, modal?.show && /* @__PURE__ */ React37.createElement(
    DeleteModal_default,
    {
      data: modal?.data,
      action: removeWeb3Wallet,
      setShow: setModal,
      show: modal?.show
    }
  ), modalPassword && /* @__PURE__ */ React37.createElement(Password_default, { setShow: setModalPassword, show: modal }), /* @__PURE__ */ React37.createElement("h2", { className: "fs-24 fw-semibold mb-3 p-3" }, "Single Sign-On Management"), isLoading ? /* @__PURE__ */ React37.createElement(Spinner2, null) : /* @__PURE__ */ React37.createElement("div", { className: "bg-white rounded p-4" }, /* @__PURE__ */ React37.createElement("h3", { className: "fs-5 fw-medium mb-12px" }, "WEB3"), /* @__PURE__ */ React37.createElement(Row3, null, /* @__PURE__ */ React37.createElement(Col3, { md: 6, lg: 6, xxl: 4, className: "mb-4" }, /* @__PURE__ */ React37.createElement(Concordium_default2, { setShow: setModal, connectWallet: connectWeb3Wallet })), /* @__PURE__ */ React37.createElement(Col3, { md: 6, lg: 6, xxl: 4, className: "mb-4" }, /* @__PURE__ */ React37.createElement(MetaMask_default, { setShow: setModal, connectWallet: connectWeb3Wallet }))), /* @__PURE__ */ React37.createElement("h3", { className: "fs-5 d-flex align-items-center fw-medium mb-12px" }, "AesirX Account", /* @__PURE__ */ React37.createElement(
    "p",
    {
      onClick: () => setModalPassword(true),
      className: "fw-medium fs-7 ms-4 mb-0 text-decoration-underline text-success cursor-pointer"
    },
    "Change Password"
  )), /* @__PURE__ */ React37.createElement(Row3, null, /* @__PURE__ */ React37.createElement(Col3, { md: 6, lg: 6, xxl: 4, className: "mb-4" }, /* @__PURE__ */ React37.createElement(Email_default2, null))), /* @__PURE__ */ React37.createElement("h3", { className: "fs-5 fw-medium mb-12px" }, "Social Media"), /* @__PURE__ */ React37.createElement(Row3, null, /* @__PURE__ */ React37.createElement(Col3, { md: 6, lg: 6, xxl: 4, className: "mb-4" }, /* @__PURE__ */ React37.createElement(Social_default2, { typeSocial: "google", keySocial: "social_google" })), /* @__PURE__ */ React37.createElement(Col3, { md: 6, lg: 6, xxl: 4, className: "mb-4" }, /* @__PURE__ */ React37.createElement(Social_default2, { typeSocial: "twitter", keySocial: "social_twitter" })), /* @__PURE__ */ React37.createElement(Col3, { md: 6, lg: 6, xxl: 4, className: "mb-4" }, /* @__PURE__ */ React37.createElement(Social_default2, { typeSocial: "facebook", keySocial: "social_facebook" })))));
};
var SSOConfig_default = SSO;
export {
  ConcordiumLogin_default as ConcordiumLogin,
  CreateAccount_default as CreateAccount,
  EmailLogin_default as EmailLogin,
  SSOButton_default as SSOButton,
  SSOConfig_default as SSOConfig,
  SignUpButton_default as SignUpButton,
  SignUpConcordium_default as SignUpConcordium
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
